/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './api-types';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { fetchGenerated } from '../client';
export type GetGameBySlugQueryVariables = Exact<{
  slug: string;
}>;


export type GetGameBySlugQuery = { getGameBySlug: { id: string, info: { slug: string, name: string, status: Types.GameStatus, type: Types.GameType } } };

export type GetGameDetailsBySlugQueryVariables = Exact<{
  slug: string;
}>;


export type GetGameDetailsBySlugQuery = { getGameBySlug: { id: string, info: { slug: string, name: string, status: Types.GameStatus, type: Types.GameType, anticipationStartsAt: string, teamsStartsAt: string, startsAt: string, endsAt: string, sustainEndsAt: string, hideOnLanding: boolean | null, originalSlug: string | null, boundingBox: string | null, helpWidget: Types.HelpWidget, isMobileGame: boolean | null, appOnlyGame: boolean | null, appVariant: Types.AppVariant | null, restrictAtDays: number | null, endCountdownDays: number | null, region: Types.GameRegion | null, settings: { minSwipeTime: number, timezone: string, city: string | null, lat: number | null, lon: number | null, target: number, targetZones: Array<string> | null, locationDistanceMeters: number, beatBoxPlacementValidationEnabled: boolean | null, POIName: string | null, collectPartnerConsentForAges13To17: boolean | null, luckyTapEnabled: boolean | null, luckyTapFrequency: number | null, luckyTapPoints: number | null, mappingApprovalsRequired: boolean | null, mappingPostRequired: boolean | null, targetBeatBoxCount: number | null }, targetedEmails: { gameCountdown: boolean, noActivity: boolean, stoppedPlaying: boolean } | null }, liveTotals: { totalMiles: number, totalPlayers: number, everJoinedPlayers: number, registeredPlayers: number } } };

export type FEventBaseFragment = { id: string, description: string, points: number | null, startDate: string, endDate: string, allDay: boolean | null, weekDay: Array<number>, allBeatBoxes: boolean | null, timing: Array<{ startTime: string, endTime: string }> | null };

export type FEventDetailsFragment = { groupIds: Array<string> | null };

export type FEventAllFragment = { customLocationIds: Array<string> | null, isVisible: boolean | null, sanityID: string | null, id: string, description: string, points: number | null, startDate: string, endDate: string, allDay: boolean | null, weekDay: Array<number>, allBeatBoxes: boolean | null, groupIds: Array<string> | null, timing: Array<{ startTime: string, endTime: string }> | null };

export type FGameInfoBasicFragment = { slug: string, name: string, status: Types.GameStatus, type: Types.GameType };

export type FGameInfoDatesFragment = { anticipationStartsAt: string, teamsStartsAt: string, startsAt: string, endsAt: string, sustainEndsAt: string };

export type FGameInfoRestFragment = { hideOnLanding: boolean | null, originalSlug: string | null, boundingBox: string | null, helpWidget: Types.HelpWidget, isMobileGame: boolean | null, appOnlyGame: boolean | null, appVariant: Types.AppVariant | null, restrictAtDays: number | null, endCountdownDays: number | null };

export type FGameInfoSettingsFragment = { region: Types.GameRegion | null, settings: { minSwipeTime: number, timezone: string, city: string | null, lat: number | null, lon: number | null, target: number, targetZones: Array<string> | null, locationDistanceMeters: number, beatBoxPlacementValidationEnabled: boolean | null, POIName: string | null, collectPartnerConsentForAges13To17: boolean | null, luckyTapEnabled: boolean | null, luckyTapFrequency: number | null, luckyTapPoints: number | null, mappingApprovalsRequired: boolean | null, mappingPostRequired: boolean | null, targetBeatBoxCount: number | null } };

export type FGameInfoSurveysFragment = { surveys: { tellUsAboutYou: { surveyID: string, link: string, surveyName: string | null, validationStatus: Types.ValidationStatus | null, lastValidated: string | null } | null, closing: { surveyID: string, link: string, surveyName: string | null, validationStatus: Types.ValidationStatus | null, lastValidated: string | null, shownFromDate: string, isAutoSend: boolean, sendDaysBeforeEnd: Array<number> | null } | null, sixMonths: { surveyID: string, link: string, surveyName: string | null, validationStatus: Types.ValidationStatus | null, lastValidated: string | null, sendDate: string, isAutoSend: boolean } | null, oneYear: { surveyID: string, link: string, surveyName: string | null, validationStatus: Types.ValidationStatus | null, lastValidated: string | null, sendDate: string, isAutoSend: boolean } | null } | null };

export type FGameInfoTargetedEmailsFragment = { targetedEmails: { gameCountdown: boolean, noActivity: boolean, stoppedPlaying: boolean } | null };

export type FGameInfoFragment = { info: { slug: string, name: string, status: Types.GameStatus, type: Types.GameType, anticipationStartsAt: string, teamsStartsAt: string, startsAt: string, endsAt: string, sustainEndsAt: string, hideOnLanding: boolean | null, originalSlug: string | null, boundingBox: string | null, helpWidget: Types.HelpWidget, isMobileGame: boolean | null, appOnlyGame: boolean | null, appVariant: Types.AppVariant | null, restrictAtDays: number | null, endCountdownDays: number | null, region: Types.GameRegion | null, settings: { minSwipeTime: number, timezone: string, city: string | null, lat: number | null, lon: number | null, target: number, targetZones: Array<string> | null, locationDistanceMeters: number, beatBoxPlacementValidationEnabled: boolean | null, POIName: string | null, collectPartnerConsentForAges13To17: boolean | null, luckyTapEnabled: boolean | null, luckyTapFrequency: number | null, luckyTapPoints: number | null, mappingApprovalsRequired: boolean | null, mappingPostRequired: boolean | null, targetBeatBoxCount: number | null }, targetedEmails: { gameCountdown: boolean, noActivity: boolean, stoppedPlaying: boolean } | null } };

export type FGameLiveTotalsFragment = { liveTotals: { totalMiles: number, totalPlayers: number, everJoinedPlayers: number, registeredPlayers: number } };

export type FGameTagRangeFragment = { tagRanges: Array<{ id: string, from: number, to: number }> };

export type FGameTagSubrangeFragment = { tagSubranges: Array<{ id: string, from: number, to: number, amount: number, description: string | null, isApproved: boolean, isLocked: boolean, connectionId: string | null, tagType: Types.TagsTypes, type: Types.SubrangesTypes }> };

export type FLocationsBaseFragment = { id: string, slug: string, type: Types.LocationTypes, name: string | null, isBonus: boolean | null, beatBoxNumber: number | null };

export type FLocationAllFragment = { lat: number, lng: number, points: number, currentPoints: number, status: Types.LocationStatus, gameId: string, gemType: Types.GemType | null, description: string | null, accessible: boolean | null, what3words: string | null, ownerName: string | null, id: string, slug: string, type: Types.LocationTypes, name: string | null, isBonus: boolean | null, beatBoxNumber: number | null, stats: { reported: string | null, batteryLevel: string | null, deviceID: string | null } | null };

export type FLocationInfoBasicFragment = { id: string, type: Types.LocationTypes, slug: string, points: number, gemType: Types.GemType | null, beatBoxNumber: number | null, geo: { isochrone: unknown, nearest: unknown, lamppost: unknown } | null };

export type FLocationCoordinatesFragment = { lng: number, lat: number };

export type FLocationCoreFragment = { name: string | null, isBonus: boolean | null, description: string | null, accessible: boolean | null, what3words: string | null };

export type FLocationStatsFieldsFragment = { deviceID: string | null, batteryLevel: string | null, reported: string | null };

export type FLocationDetailsFragment = { name: string | null, isBonus: boolean | null, description: string | null, accessible: boolean | null, what3words: string | null, stats: { deviceID: string | null, batteryLevel: string | null, reported: string | null } | null };

export type FLocationDetailsBasicFragment = { name: string | null, isBonus: boolean | null, description: string | null, accessible: boolean | null };

export type FPlayerPointContextFragment = { all: number, routes: number, gems: number, extra: number, mileage: number | null };

export type FPlayerPointFragment = { points: { all: number, routes: number, gems: number, extra: number, mileage: number | null } | null };

export type FPlayerProfileContextFragment = { firstName: string | null, email: string, birthDate: string | null, gender: string | null, isRegistered: boolean | null, ageGroup: string | null };

export type FPlayerProfileFragment = { profile: { firstName: string | null, email: string, birthDate: string | null, gender: string | null, isRegistered: boolean | null, ageGroup: string | null } };

export type FPlayerInfoContextFragment = { gameId: string | null, teamId: string | null, publicName: string | null, avatar: string | null };

export type FPlayerInfoFragment = { info: { gameId: string | null, teamId: string | null, publicName: string | null, avatar: string | null } };

export type FPlayerTeamFragment = { team: { id: string, name: string } | null };

export type FPlayerRoleContextFragment = { isChild: boolean | null, parentId: string | null, isAnonymous: boolean | null, authID: string | null, removedAt: string | null };

export type FPlayerRoleFragment = { role: { isChild: boolean | null, parentId: string | null, isAnonymous: boolean | null, authID: string | null, removedAt: string | null } };

export type FTagGlobalFullFragment = { id: string, name: string, status: Types.CardOrderStatus, type: Types.OrderTagTypes, supplier: string | null, quantity: number, start: number, end: number, deliveryDate: string | null, createdAt: string };

export type FTagSubrangeFragment = { id: string, from: number, to: number, amount: number, description: string | null, isApproved: boolean, isLocked: boolean, connectionId: string | null, tagType: Types.TagsTypes, createdAt: string | null, type: Types.SubrangesTypes, distributionPointId: string | null, reassignTeams: boolean | null, reassignExistingTeams: boolean | null };

export type FTeamBasicFragment = { id: string, name: string, type: Types.TeamTypes, status: Types.TeamStatus, leaderboardId: string | null };

export type FTeamRangesFragment = { subranges: Array<{ from: number, to: number }> };

export type FTeamStatsFragment = { all: number, mileage: number | null, totalMembers: number, gems: number, extra: number };

export type FTeamDetailsFragment = { details: { description: string | null, rejectionReason: string | null, rollNumber: number | null, leaders: Array<string> | null, leadersEmails: Array<string> | null } };

export type FTeamRestFragment = { gameId: string | null, leaderboardId: string | null, routes: number };

export type FTeamFragment = { id: string, name: string, type: Types.TeamTypes, status: Types.TeamStatus, leaderboardId: string | null, all: number, mileage: number | null, totalMembers: number, gems: number, extra: number, gameId: string | null, routes: number, subranges: Array<{ from: number, to: number }>, details: { description: string | null, rejectionReason: string | null, rollNumber: number | null, leaders: Array<string> | null, leadersEmails: Array<string> | null } };

export type ListGamesInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ListGamesInfoQuery = { listGames: Array<{ id: string, liveTotals: { totalPlayers: number, everJoinedPlayers: number, totalMiles: number }, info: { slug: string, name: string, status: Types.GameStatus, type: Types.GameType, anticipationStartsAt: string, teamsStartsAt: string, startsAt: string, endsAt: string, sustainEndsAt: string, hideOnLanding: boolean | null, originalSlug: string | null, boundingBox: string | null, helpWidget: Types.HelpWidget, isMobileGame: boolean | null, appOnlyGame: boolean | null, appVariant: Types.AppVariant | null, restrictAtDays: number | null, endCountdownDays: number | null, region: Types.GameRegion | null, settings: { minSwipeTime: number, timezone: string, city: string | null, lat: number | null, lon: number | null, target: number, targetZones: Array<string> | null, locationDistanceMeters: number, beatBoxPlacementValidationEnabled: boolean | null, POIName: string | null, collectPartnerConsentForAges13To17: boolean | null, luckyTapEnabled: boolean | null, luckyTapFrequency: number | null, luckyTapPoints: number | null, mappingApprovalsRequired: boolean | null, mappingPostRequired: boolean | null, targetBeatBoxCount: number | null }, targetedEmails: { gameCountdown: boolean, noActivity: boolean, stoppedPlaying: boolean } | null } }> };

export type GetPlayerQueryVariables = Exact<{
  id: string;
}>;


export type GetPlayerQuery = { getPlayer: { id: string, emailVerified: boolean | null, tags: Array<{ id: string, tagNumber: number, tagType: Types.TagTypes }>, profile: { postCode: string | null, firstName: string | null, email: string, birthDate: string | null, gender: string | null, isRegistered: boolean | null, ageGroup: string | null }, team: { id: string, name: string } | null, info: { gameId: string | null, teamId: string | null, publicName: string | null, avatar: string | null }, points: { all: number, routes: number, gems: number, extra: number, mileage: number | null } | null, role: { isChild: boolean | null, parentId: string | null, isAnonymous: boolean | null, authID: string | null, removedAt: string | null } } };

export type FindFamilyPlayersQueryVariables = Exact<{
  input: Types.FindFamilyPlayersInput;
}>;


export type FindFamilyPlayersQuery = { findFamilyPlayers: Array<{ id: string, info: { publicName: string | null }, role: { isChild: boolean | null } }> };

export type AdminBasicFragment = { id: string, email: string, fullName: string, adminManagement: boolean, gameCreation: boolean, isSuperAdmin: boolean, globalModulesAccess: boolean, pii: boolean, enabled: boolean | null, createdAt: string, updatedAt: string };

export type AdminMembershipFieldsFragment = { adminId: string, gameId: string, roles: Array<string>, createdAt: string, updatedAt: string | null, roleDetails: Array<{ id: string, name: string, description: string | null, permissions: Array<string>, isSystem: boolean, createdAt: string, updatedAt: string | null }> | null };

export type ListAdminsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAdminsQuery = { listAdmins: Array<{ id: string, email: string, fullName: string, adminManagement: boolean, gameCreation: boolean, isSuperAdmin: boolean, globalModulesAccess: boolean, pii: boolean, memberships: Array<{ adminId: string, gameId: string }> | null }> };

export type GetAdminQueryVariables = Exact<{
  id: string;
}>;


export type GetAdminQuery = { getAdmin: { id: string, email: string, fullName: string, adminManagement: boolean, gameCreation: boolean, isSuperAdmin: boolean, globalModulesAccess: boolean, pii: boolean, enabled: boolean | null, createdAt: string, updatedAt: string, memberships: Array<{ adminId: string, gameId: string, roles: Array<string>, createdAt: string, updatedAt: string | null, roleDetails: Array<{ id: string, name: string, description: string | null, permissions: Array<string>, isSystem: boolean, createdAt: string, updatedAt: string | null }> | null }> | null, permissions: { allGames: Array<string>, perGame: unknown } | null, roles: Array<{ id: string, name: string, description: string | null, permissions: Array<string>, isSystem: boolean, createdAt: string, updatedAt: string | null }> | null } | null };

export type UpdateAdminMutationVariables = Exact<{
  input: Types.UpdateAdminInput;
}>;


export type UpdateAdminMutation = { updateAdmin: { id: string, email: string, fullName: string, adminManagement: boolean, gameCreation: boolean, isSuperAdmin: boolean, globalModulesAccess: boolean, pii: boolean, enabled: boolean | null, createdAt: string, updatedAt: string } };

export type CreateAdminMutationVariables = Exact<{
  input: Types.CreateAdminInput;
}>;


export type CreateAdminMutation = { createAdmin: { id: string, email: string, fullName: string, adminManagement: boolean, gameCreation: boolean, isSuperAdmin: boolean, globalModulesAccess: boolean, pii: boolean, enabled: boolean | null, createdAt: string, updatedAt: string } };

export type DeleteAdminMutationVariables = Exact<{
  id: string;
}>;


export type DeleteAdminMutation = { deleteAdmin: boolean };

export type ChangeAdminPasswordMutationVariables = Exact<{
  input: Types.ChangeAdminPasswordInput;
}>;


export type ChangeAdminPasswordMutation = { changeAdminPassword: boolean };

export type ChangeMyPasswordMutationVariables = Exact<{
  password: string;
}>;


export type ChangeMyPasswordMutation = { changeMyPassword: boolean };

export type UpdateMyProfileMutationVariables = Exact<{
  fullName: string;
}>;


export type UpdateMyProfileMutation = { updateMyProfile: { id: string, email: string, fullName: string, adminManagement: boolean, gameCreation: boolean, isSuperAdmin: boolean, globalModulesAccess: boolean, pii: boolean, enabled: boolean | null, createdAt: string, updatedAt: string } };

export type CreateMembershipMutationVariables = Exact<{
  input: Types.CreateMembershipInput;
}>;


export type CreateMembershipMutation = { createMembership: { adminId: string, gameId: string, roles: Array<string>, createdAt: string, updatedAt: string | null, roleDetails: Array<{ id: string, name: string, description: string | null, permissions: Array<string>, isSystem: boolean, createdAt: string, updatedAt: string | null }> | null } };

export type UpdateMembershipMutationVariables = Exact<{
  input: Types.UpdateMembershipInput;
}>;


export type UpdateMembershipMutation = { updateMembership: { adminId: string, gameId: string, roles: Array<string>, createdAt: string, updatedAt: string | null, roleDetails: Array<{ id: string, name: string, description: string | null, permissions: Array<string>, isSystem: boolean, createdAt: string, updatedAt: string | null }> | null } };

export type DeleteMembershipMutationVariables = Exact<{
  input: Types.DeleteMembershipInput;
}>;


export type DeleteMembershipMutation = { deleteMembership: boolean };

export type ListRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListRolesQuery = { listRoles: Array<{ id: string, name: string, description: string | null, permissions: Array<string>, isSystem: boolean, createdAt: string, updatedAt: string | null }> };

export type CreateRoleMutationVariables = Exact<{
  input: Types.CreateAdminRoleInput;
}>;


export type CreateRoleMutation = { createRole: { id: string, name: string, description: string | null, permissions: Array<string>, isSystem: boolean, createdAt: string, updatedAt: string | null } };

export type UpdateRoleMutationVariables = Exact<{
  input: Types.UpdateAdminRoleInput;
}>;


export type UpdateRoleMutation = { updateRole: { id: string, name: string, description: string | null, permissions: Array<string>, isSystem: boolean, createdAt: string, updatedAt: string | null } };

export type DeleteRoleMutationVariables = Exact<{
  id: string;
}>;


export type DeleteRoleMutation = { deleteRole: boolean };

export type CreateCardOrderMutationVariables = Exact<{
  input: Types.TagGlobalRangeCreateInput;
}>;


export type CreateCardOrderMutation = { createTagGlobal: { id: string } };

export type UpdateCardOrderMutationVariables = Exact<{
  input: Types.TagGlobalRangeUpdateInput;
}>;


export type UpdateCardOrderMutation = { updateTagGlobal: { id: string } };

export type DeleteCardOrderMutationVariables = Exact<{
  id: string;
}>;


export type DeleteCardOrderMutation = { deleteTagGlobal: boolean };

export type FindCardOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type FindCardOrdersQuery = { findTagGlobal: Array<{ id: string, name: string, status: Types.CardOrderStatus, type: Types.OrderTagTypes, supplier: string | null, quantity: number, start: number, end: number, deliveryDate: string | null, createdAt: string }> };

export type GetCardOrderQueryVariables = Exact<{
  id: string;
}>;


export type GetCardOrderQuery = { getTagGlobal: { id: string, name: string, status: Types.CardOrderStatus, type: Types.OrderTagTypes, supplier: string | null, quantity: number, start: number, end: number, deliveryDate: string | null, createdAt: string } };

export type FMapDatasetFragment = { id: string, name: string, description: string | null, category: Types.MapDatasetCategory, geometryType: Types.MapDatasetGeometryType, featureCount: number, bbox: Array<number>, featuresUrl: string, version: number, updatedAt: string, updatedBy: string | null, source: { kind: Types.MapDatasetSourceKind, filename: string | null, serviceUrl: string | null, attribution: string | null }, defaultStyle: { color: string, lineWidth: number, opacity: number } };

export type MapDatasetsQueryVariables = Exact<{ [key: string]: never; }>;


export type MapDatasetsQuery = { mapDatasets: Array<{ id: string, name: string, description: string | null, category: Types.MapDatasetCategory, geometryType: Types.MapDatasetGeometryType, featureCount: number, bbox: Array<number>, featuresUrl: string, version: number, updatedAt: string, updatedBy: string | null, source: { kind: Types.MapDatasetSourceKind, filename: string | null, serviceUrl: string | null, attribution: string | null }, defaultStyle: { color: string, lineWidth: number, opacity: number } }> };

export type MapDatasetQueryVariables = Exact<{
  id: string;
}>;


export type MapDatasetQuery = { mapDataset: { id: string, name: string, description: string | null, category: Types.MapDatasetCategory, geometryType: Types.MapDatasetGeometryType, featureCount: number, bbox: Array<number>, featuresUrl: string, version: number, updatedAt: string, updatedBy: string | null, source: { kind: Types.MapDatasetSourceKind, filename: string | null, serviceUrl: string | null, attribution: string | null }, defaultStyle: { color: string, lineWidth: number, opacity: number } } };

export type MapDatasetUploadUrlMutationVariables = Exact<{
  input: Types.MapDatasetUploadTargetInput;
}>;


export type MapDatasetUploadUrlMutation = { mapDatasetUploadUrl: { uploadUrl: string, stagingKey: string } };

export type ImportMapDatasetMutationVariables = Exact<{
  input: Types.ImportMapDatasetInput;
}>;


export type ImportMapDatasetMutation = { importMapDataset: { id: string, name: string, description: string | null, category: Types.MapDatasetCategory, geometryType: Types.MapDatasetGeometryType, featureCount: number, bbox: Array<number>, featuresUrl: string, version: number, updatedAt: string, updatedBy: string | null, source: { kind: Types.MapDatasetSourceKind, filename: string | null, serviceUrl: string | null, attribution: string | null }, defaultStyle: { color: string, lineWidth: number, opacity: number } } };

export type RefreshMapDatasetMutationVariables = Exact<{
  id: string;
}>;


export type RefreshMapDatasetMutation = { refreshMapDataset: { id: string, name: string, description: string | null, category: Types.MapDatasetCategory, geometryType: Types.MapDatasetGeometryType, featureCount: number, bbox: Array<number>, featuresUrl: string, version: number, updatedAt: string, updatedBy: string | null, source: { kind: Types.MapDatasetSourceKind, filename: string | null, serviceUrl: string | null, attribution: string | null }, defaultStyle: { color: string, lineWidth: number, opacity: number } } };

export type UpdateMapDatasetMutationVariables = Exact<{
  input: Types.UpdateMapDatasetInput;
}>;


export type UpdateMapDatasetMutation = { updateMapDataset: { id: string, name: string, description: string | null, category: Types.MapDatasetCategory, geometryType: Types.MapDatasetGeometryType, featureCount: number, bbox: Array<number>, featuresUrl: string, version: number, updatedAt: string, updatedBy: string | null, source: { kind: Types.MapDatasetSourceKind, filename: string | null, serviceUrl: string | null, attribution: string | null }, defaultStyle: { color: string, lineWidth: number, opacity: number } } };

export type DeleteMapDatasetMutationVariables = Exact<{
  id: string;
}>;


export type DeleteMapDatasetMutation = { deleteMapDataset: boolean };

export type GetTagSubrangeQueryVariables = Exact<{
  id: string;
  gameId: string;
}>;


export type GetTagSubrangeQuery = { getTagSubrange: { id: string, from: number, to: number, amount: number, description: string | null, isApproved: boolean, isLocked: boolean, connectionId: string | null, tagType: Types.TagsTypes, createdAt: string | null, type: Types.SubrangesTypes, distributionPointId: string | null, reassignTeams: boolean | null, reassignExistingTeams: boolean | null } };

export type CardsTagSubrangesQueryVariables = Exact<{
  input: Types.FindTagSubranges;
}>;


export type CardsTagSubrangesQuery = { tagSubranges: Array<{ id: string, from: number, to: number, amount: number, description: string | null, isApproved: boolean, isLocked: boolean, connectionId: string | null, tagType: Types.TagsTypes, createdAt: string | null, type: Types.SubrangesTypes, distributionPointId: string | null, reassignTeams: boolean | null, reassignExistingTeams: boolean | null, team: { name: string } | null }> };

export type UpdateTagSubrangeMutationVariables = Exact<{
  input: Types.GameTagSubrangeUpdateInput;
}>;


export type UpdateTagSubrangeMutation = { updateTagSubrange: { id: string } };

export type CreateTagSubrangeMutationVariables = Exact<{
  input: Types.GameTagSubrangeCreateInput;
}>;


export type CreateTagSubrangeMutation = { createTagSubrange: { id: string } };

export type DeleteTagSubrangeMutationVariables = Exact<{
  input: Types.GameTagSubrangeDeleteInput;
}>;


export type DeleteTagSubrangeMutation = { deleteTagSubrange: boolean };

export type UnlockApprovedSubrangeMutationVariables = Exact<{
  input: Types.GameTagSubrangeDeleteInput;
}>;


export type UnlockApprovedSubrangeMutation = { unlockApprovedTagSubrange: { id: string, isApproved: boolean, isLocked: boolean } };

export type AssignSubrangeMutationVariables = Exact<{
  input: Types.AssignSubranges;
}>;


export type AssignSubrangeMutation = { assignTagSubrange: { success: boolean, successCount: number, skippedCount: number, skippedRanges: Array<{ subrangeId: string, range: string, reason: string, conflictingGame: { id: string, name: string } | null }> } };

export type ApproveSubrangeMutationVariables = Exact<{
  input: Types.BulkChangeSubranges;
}>;


export type ApproveSubrangeMutation = { bulkChangeTagSubrange: boolean };

export type UpdateLockSubrangesMutationVariables = Exact<{
  input: Types.BulkChangeSubranges;
}>;


export type UpdateLockSubrangesMutation = { bulkChangeTagSubrange: boolean };

export type FindCardsLocationsQueryVariables = Exact<{
  gameId: string;
}>;


export type FindCardsLocationsQuery = { locations: Array<{ id: string, type: Types.LocationTypes, slug: string, name: string | null }> };

export type FindCardsTeamsQueryVariables = Exact<{
  input: Types.FindTeamsInput;
}>;


export type FindCardsTeamsQuery = { teams: Array<{ id: string, name: string }> };

export type FindTagRangesByGameQueryVariables = Exact<{
  gameId: string;
}>;


export type FindTagRangesByGameQuery = { findTagRanges: Array<{ id: string, from: number, to: number }> };

export type CreateTagRangeMutationVariables = Exact<{
  input: Types.GameTagRangeCreateInput;
}>;


export type CreateTagRangeMutation = { createTagRange: { id: string } };

export type DeleteTagRangeMutationVariables = Exact<{
  input: Types.GameTagRangeDeleteInput;
}>;


export type DeleteTagRangeMutation = { deleteTagRange: boolean };

export type FindTagSubrangesByGameQueryVariables = Exact<{
  input: Types.FindTagSubranges;
}>;


export type FindTagSubrangesByGameQuery = { findTagSubranges: Array<{ id: string, from: number, to: number, isLocked: boolean, isApproved: boolean }> };

export type GetTagRangeQueryVariables = Exact<{
  id: string;
  gameId: string;
}>;


export type GetTagRangeQuery = { getTagRange: { id: string, from: number, to: number } };

export type UpdateTagRangeMutationVariables = Exact<{
  input: Types.GameTagRangeUpdateInput;
}>;


export type UpdateTagRangeMutation = { updateTagRange: { id: string } };

export type IsCardRangeAvailableMutationVariables = Exact<{
  input: Types.IsTagSubrangesAvailable;
}>;


export type IsCardRangeAvailableMutation = { isAvailable: { isAvailable: boolean, overlap: { gameId: string, gameName: string, isSameGame: boolean } | null } };

export type IsGameRangeAvailableMutationVariables = Exact<{
  input: Types.IsGameTagRangeAvailable;
}>;


export type IsGameRangeAvailableMutation = { isAvailable: boolean };

export type GetImdDecileAggregatesQueryVariables = Exact<{
  gameId: string;
}>;


export type GetImdDecileAggregatesQuery = { imdDecileAggregates: { totalPlayers: number, totalPopulation: number, unmatchedZoneCount: number, deciles: Array<{ decile: number, totalPopulation: number, totalPlayers: number, totalPlayersPercent: number, totalPopulationPercent: number, indexOfPenetration: number }> } };

export type GetCampaignsQueryVariables = Exact<{
  gameId: string;
  category?: string | null | undefined;
}>;


export type GetCampaignsQuery = { getCampaigns: Array<{ campaignId: string, name: string | null, status: Types.MessageCampaignStatus | null, segment: Types.MessageSegment | null, scheduledTime: string | null, gameId: string | null, teamId: string | null, category: string | null, content: string | null, createdAt: string, pushTotalCount: number | null, pushPlayersCount: number | null, team: { name: string, type: Types.TeamTypes } | null, author: { publicName: string | null } | null, analytics: { delivered: number, read: number, likes: number, openedByPush: number } | null }> };

export type DeleteCampaignMutationVariables = Exact<{
  campaignId: string;
  gameId: string;
}>;


export type DeleteCampaignMutation = { deleteCampaign: boolean };

export type EventListTableQueryVariables = Exact<{
  gameId?: string | null | undefined;
}>;


export type EventListTableQuery = { findEvents: Array<{ id: string, description: string, points: number | null, startDate: string, endDate: string, allDay: boolean | null, weekDay: Array<number>, allBeatBoxes: boolean | null, timing: Array<{ startTime: string, endTime: string }> | null }> };

export type GetEventQueryVariables = Exact<{
  input: Types.GetEvent;
}>;


export type GetEventQuery = { getEvent: { customLocationIds: Array<string> | null, isVisible: boolean | null, sanityID: string | null, id: string, description: string, points: number | null, startDate: string, endDate: string, allDay: boolean | null, weekDay: Array<number>, allBeatBoxes: boolean | null, groupIds: Array<string> | null, timing: Array<{ startTime: string, endTime: string }> | null } };

export type FindLocationsByGameQueryVariables = Exact<{
  gameId?: string | null | undefined;
}>;


export type FindLocationsByGameQuery = { findLocations: Array<{ id: string, slug: string, type: Types.LocationTypes, name: string | null, isBonus: boolean | null, beatBoxNumber: number | null }> };

export type FindGroupsForEventQueryVariables = Exact<{
  gameId: string;
}>;


export type FindGroupsForEventQuery = { findGroups: Array<{ id: string, name: string }> };

export type GetEventGroupQueryVariables = Exact<{
  input: Types.GetGroup;
}>;


export type GetEventGroupQuery = { getGroup: { description: string | null, id: string } };

export type FindEventPointsQueryVariables = Exact<{
  input: Types.FindEventPoints;
}>;


export type FindEventPointsQuery = { findEventPoints: Array<{ id: string, startDate: string, endDate: string, locationId: string }> };

export type CreateEventScheduleMutationVariables = Exact<{
  input: Types.EventCreateInput;
}>;


export type CreateEventScheduleMutation = { createEvent: { id: string } };

export type UpdateEventScheduleMutationVariables = Exact<{
  input: Types.EventUpdateInput;
}>;


export type UpdateEventScheduleMutation = { updateEvent: { id: string } };

export type RemoveEventScheduleMutationVariables = Exact<{
  input: Types.DeleteEvent;
}>;


export type RemoveEventScheduleMutation = { deleteEvent: { id: string } };

export type RemoveEventPointMutationVariables = Exact<{
  input: Types.DeleteEventPoint;
}>;


export type RemoveEventPointMutation = { deleteEventPoint: boolean };

export type DuplicateEventScheduleMutationVariables = Exact<{
  input: Types.GetEvent;
}>;


export type DuplicateEventScheduleMutation = { duplicateEvent: { id: string } };

export type DashboardInstallerLocationsQueryVariables = Exact<{
  gameId: string;
}>;


export type DashboardInstallerLocationsQuery = { installerFindLocations: Array<{ id: string, gameId: string, slug: string, type: Types.LocationTypes, lat: number, lng: number, name: string | null, isBonus: boolean | null }> };

export type DashboardInstallerUpdateLocationMutationVariables = Exact<{
  input: Types.InstallerLocationUpdateInput;
}>;


export type DashboardInstallerUpdateLocationMutation = { installerUpdateLocation: { id: string, gameId: string, lat: number, lng: number } };

export type DashboardInstallerFindSwipeByTagQueryVariables = Exact<{
  input: Types.FindByTag;
}>;


export type DashboardInstallerFindSwipeByTagQuery = { installerFindSwipeByTag: Array<{ id: string, tagNumber: number, locationName: string | null, timestamp: string, status: Types.SwipeStatus, locationId: string | null, reason: string | null, isLucky: boolean | null }> };

export type CreateGameLeaderboardMutationVariables = Exact<{
  input: Types.GameLeaderboardCreateInput;
}>;


export type CreateGameLeaderboardMutation = { createLeaderboard: { id: string } };

export type RemoveGameLeaderboardMutationVariables = Exact<{
  input: Types.DeleteLeaderboard;
}>;


export type RemoveGameLeaderboardMutation = { deleteLeaderboard: boolean };

export type UpdateGameLeaderboardMutationVariables = Exact<{
  input: Types.GameLeaderboardUpdateInput;
}>;


export type UpdateGameLeaderboardMutation = { updateLeaderboard: { id: string } };

export type MoveSmallTeamsMutationVariables = Exact<{
  input: Types.MoveSmallTeamsInput;
}>;


export type MoveSmallTeamsMutation = { moveSmallTeams: boolean };

export type GetLeaderboardByIdQueryVariables = Exact<{
  gameId: string;
  id: string;
}>;


export type GetLeaderboardByIdQuery = { getLeaderboard: { id: string, name: string, teamIds: Array<string> | null, teamTypes: Array<Types.TeamTypes> | null } };

export type FindLeaderboardsByGameQueryVariables = Exact<{
  gameId?: string | null | undefined;
}>;


export type FindLeaderboardsByGameQuery = { findLeaderboards: Array<{ id: string, name: string, teamIds: Array<string> | null, teamTypes: Array<Types.TeamTypes> | null }> };

export type FindLeaderboardsTeamsQueryVariables = Exact<{
  input: Types.FindTeamsInput;
}>;


export type FindLeaderboardsTeamsQuery = { findTeams: Array<{ totalMembers: number, all: number, id: string, name: string, type: Types.TeamTypes, status: Types.TeamStatus, leaderboardId: string | null, subranges: Array<{ from: number, to: number }> }> };

export type GetGamesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGamesListQuery = { listGames: Array<{ id: string, info: { startsAt: string, endsAt: string, slug: string, name: string, status: Types.GameStatus, type: Types.GameType }, liveTotals: { totalMiles: number, totalPlayers: number, everJoinedPlayers: number, registeredPlayers: number } }> };

export type CreateGameMutationVariables = Exact<{
  input: Types.CreateGameInput;
}>;


export type CreateGameMutation = { createGame: { id: string } };

export type GameMapDatasetsQueryVariables = Exact<{
  gameId: string;
}>;


export type GameMapDatasetsQuery = { gameMapDatasets: Array<{ datasetId: string, audience: Types.MapDatasetAudience, visibleByDefault: boolean, sortOrder: number, styleOverride: { color: string, lineWidth: number, opacity: number } | null, dataset: { id: string, name: string, description: string | null, category: Types.MapDatasetCategory, geometryType: Types.MapDatasetGeometryType, featureCount: number, bbox: Array<number>, featuresUrl: string, version: number, updatedAt: string, updatedBy: string | null, source: { kind: Types.MapDatasetSourceKind, filename: string | null, serviceUrl: string | null, attribution: string | null }, defaultStyle: { color: string, lineWidth: number, opacity: number } } | null }> };

export type LinkMapDatasetMutationVariables = Exact<{
  input: Types.LinkMapDatasetInput;
}>;


export type LinkMapDatasetMutation = { linkMapDataset: { datasetId: string, audience: Types.MapDatasetAudience, visibleByDefault: boolean, sortOrder: number } };

export type UpdateGameMapDatasetMutationVariables = Exact<{
  input: Types.UpdateGameMapDatasetInput;
}>;


export type UpdateGameMapDatasetMutation = { updateGameMapDataset: { datasetId: string, audience: Types.MapDatasetAudience, visibleByDefault: boolean, sortOrder: number, styleOverride: { color: string, lineWidth: number, opacity: number } | null } };

export type UnlinkMapDatasetMutationVariables = Exact<{
  input: Types.UnlinkMapDatasetInput;
}>;


export type UnlinkMapDatasetMutation = { unlinkMapDataset: boolean };

export type NearbyLamppostsQueryVariables = Exact<{
  gameId: string;
  lng: number;
  lat: number;
}>;


export type NearbyLamppostsQuery = { nearbyMappingLampposts: { searchRadiusMeters: number, candidates: Array<{ osid: string, lng: number, lat: number, distanceMeters: number }> } };

export type MappingLayerReviewFieldsFragment = { gameId: string, layer: Types.MappingLayer, type: Types.MappingReviewType, status: Types.MappingLayerReviewStatus, totalCount: number, locationCount: number, approvedCount: number, changesRequestedCount: number, respondedCount: number, pendingCount: number, openQueryCount: number, approvedAt: string | null };

export type MappingLayerReviewsQueryVariables = Exact<{
  gameId: string;
  type: Types.MappingReviewType;
}>;


export type MappingLayerReviewsQuery = { mappingLayerReviews: Array<{ gameId: string, layer: Types.MappingLayer, type: Types.MappingReviewType, status: Types.MappingLayerReviewStatus, totalCount: number, locationCount: number, approvedCount: number, changesRequestedCount: number, respondedCount: number, pendingCount: number, openQueryCount: number, approvedAt: string | null }> };

export type SubmitMappingLayerForReviewMutationVariables = Exact<{
  input: Types.SubmitMappingLayerForReviewInput;
}>;


export type SubmitMappingLayerForReviewMutation = { submitMappingLayerForReview: { createdCount: number, skippedCount: number, failedLocationIds: Array<string>, layer: { gameId: string, layer: Types.MappingLayer, type: Types.MappingReviewType, status: Types.MappingLayerReviewStatus, totalCount: number, locationCount: number, approvedCount: number, changesRequestedCount: number, respondedCount: number, pendingCount: number, openQueryCount: number, approvedAt: string | null } } };

export type FindAllGroupsElementsQueryVariables = Exact<{
  gameId?: string | null | undefined;
}>;


export type FindAllGroupsElementsQuery = { findAllGroupsElements: Array<{ locationId: string, groupId: string }> };

export type FindAllLocationsQueryVariables = Exact<{
  gameId?: string | null | undefined;
}>;


export type FindAllLocationsQuery = { locations: Array<{ isVisible: boolean, what3words: string | null, ownerName: string | null, id: string, type: Types.LocationTypes, slug: string, points: number, gemType: Types.GemType | null, beatBoxNumber: number | null, lng: number, lat: number, name: string | null, isBonus: boolean | null, description: string | null, accessible: boolean | null, geo: { lamppost: unknown, isochrone: unknown, nearest: unknown } | null }> };

export type FindLocationGroupsQueryVariables = Exact<{
  gameId?: string | null | undefined;
}>;


export type FindLocationGroupsQuery = { groups: Array<{ id: string, name: string, color: string }> };

export type LocationDetailsQueryVariables = Exact<{
  input: Types.GetLocationInput;
}>;


export type LocationDetailsQuery = { locationDetails: { beatBoxNumber: number | null, id: string, type: Types.LocationTypes, slug: string, points: number, gemType: Types.GemType | null, lng: number, lat: number, name: string | null, isBonus: boolean | null, description: string | null, accessible: boolean | null, what3words: string | null, geo: { isochrone: unknown, nearest: unknown, lamppost: unknown } | null, stats: { deviceID: string | null, batteryLevel: string | null, reported: string | null } | null } };

export type GetGroupQueryVariables = Exact<{
  input: Types.GetGroup;
}>;


export type GetGroupQuery = { details: { id: string, name: string, description: string | null, color: string } };

export type FindGroupLocationsQueryVariables = Exact<{
  input: Types.FindGroupElements;
}>;


export type FindGroupLocationsQuery = { locations: Array<{ locationId: string }> };

export type OrsRuntimeArtifactGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrsRuntimeArtifactGroupsQuery = { orsRuntimeArtifactGroups: Array<{ countryKey: string, displayName: string, artifacts: Array<{ artifactPath: string, countryKey: string, createdAt: string | null, displayName: string }> }> };

export type OrsRuntimeStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type OrsRuntimeStatusQuery = { orsRuntimeStatus: { artifactKey: string | null, artifactPath: string | null, autoScalingGroupName: string, configS3Uri: string | null, currentCapacity: number, desiredCapacity: number, instanceId: string | null, instanceState: string | null, manifestCreatedAt: string | null, orsHealthStatus: string, scheduledStopAt: string | null } };

export type StartOrsRuntimeMutationVariables = Exact<{
  input: Types.StartOrsRuntimeInput;
}>;


export type StartOrsRuntimeMutation = { startOrsRuntime: { artifactKey: string | null, artifactPath: string | null, autoScalingGroupName: string, configS3Uri: string | null, currentCapacity: number, desiredCapacity: number, instanceId: string | null, instanceState: string | null, manifestCreatedAt: string | null, orsHealthStatus: string, scheduledStopAt: string | null } };

export type StopOrsRuntimeMutationVariables = Exact<{ [key: string]: never; }>;


export type StopOrsRuntimeMutation = { stopOrsRuntime: { autoScalingGroupName: string, desiredCapacity: number } };

export type AssessLocationPlacementQueryVariables = Exact<{
  gameId: string;
  lng: number;
  lat: number;
  selfId?: string | null | undefined;
  snap?: boolean | null | undefined;
}>;


export type AssessLocationPlacementQuery = { assessMappingPlacement: { coord: Array<number>, isochrone: unknown, nearest: unknown, isTooClose: boolean } };

export type MapWorkflowLocationsQueryVariables = Exact<{
  gameId: string;
}>;


export type MapWorkflowLocationsQuery = { mappingLocations: Array<{ id: string, name: string, slug: string | null, type: Types.LocationTypes, isBonus: boolean | null, beatBoxNumber: number | null, gemType: Types.GemType | null, description: string, mappingNotes: string | null, reviewStatus: Types.MappingLocationReviewStatus, publishedAt: string | null, updatedAt: string, selectedCandidateId: string | null, points: number | null, accessible: boolean | null, ownerName: string | null, what3words: string | null, coordinates: { lat: number, lng: number } | null, candidates: Array<{ id: string, lat: number, lng: number }>, geo: { lamppost: unknown, nearest: unknown } | null, reviews: Array<{ id: string, type: Types.MappingReviewType, status: Types.MappingReviewStatus, riskAssessment: unknown, approvedAt: string | null, updatedAt: string }> | null }> };

export type MappingRoundFieldsFragment = { type: Types.MappingReviewType, locationIds: Array<string>, openedAt: string, passedAt: string | null, openedBy: { name: string, email: string } | null, passedBy: { name: string, email: string } | null };

export type MappingWorkflowQueryVariables = Exact<{
  gameId: string;
}>;


export type MappingWorkflowQuery = { mappingWorkflow: { stage: Types.MappingMapStage, rounds: Array<{ type: Types.MappingReviewType, locationIds: Array<string>, openedAt: string, passedAt: string | null, openedBy: { name: string, email: string } | null, passedBy: { name: string, email: string } | null }> } };

export type SubmitMappingStageMutationVariables = Exact<{
  input: Types.SubmitMappingStageInput;
}>;


export type SubmitMappingStageMutation = { submitMappingStage: { createdCount: number, skippedCount: number, failedLocationIds: Array<string>, failedLayers: Array<Types.MappingLayer>, workflow: { stage: Types.MappingMapStage, rounds: Array<{ type: Types.MappingReviewType, locationIds: Array<string>, openedAt: string, passedAt: string | null, openedBy: { name: string, email: string } | null, passedBy: { name: string, email: string } | null }> } } };

export type InactiveTagsQueryVariables = Exact<{
  input: Types.FindInactiveTagInput;
}>;


export type InactiveTagsQuery = { findInactiveTags: Array<{ id: string, playerId: string, startDate: string, endDate: string | null, tagNumber: number }> };

export type PlayerCreateInactiveTagMutationVariables = Exact<{
  input: Types.InactiveTagCreateInput;
}>;


export type PlayerCreateInactiveTagMutation = { createInactiveTag: { id: string } };

export type PlayerRemoveInactiveTagMutationVariables = Exact<{
  input: Types.InactiveTagDeleteInput;
}>;


export type PlayerRemoveInactiveTagMutation = { removeInactiveTag: boolean };

export type CheckPlayerIdByEmailQueryVariables = Exact<{
  email: string;
}>;


export type CheckPlayerIdByEmailQuery = { getPlayerByEmail: { id: string } };

export type MoveTagMutationVariables = Exact<{
  input: Types.MovePlayerInput;
}>;


export type MoveTagMutation = { moveTag: boolean };

export type StartDataExportMutationVariables = Exact<{
  input: Types.StartDataExportInput;
}>;


export type StartDataExportMutation = { startDataExport: { jobId: string, gameId: string, exportType: Types.DataExportType, status: Types.DataExportJobStatus, s3Path: string, downloadUrl: string | null, filename: string | null, mimeType: string, error: string | null, createdAt: string, updatedAt: string, expiredAt: number } };

export type GetDataExportJobQueryVariables = Exact<{
  gameId: string;
  jobId: string;
}>;


export type GetDataExportJobQuery = { getDataExportJob: { jobId: string, gameId: string, exportType: Types.DataExportType, status: Types.DataExportJobStatus, s3Path: string, downloadUrl: string | null, filename: string | null, mimeType: string, error: string | null, createdAt: string, updatedAt: string, expiredAt: number } };

export type FindDataExportJobsQueryVariables = Exact<{
  gameId: string;
}>;


export type FindDataExportJobsQuery = { findDataExportJobs: Array<{ jobId: string, gameId: string, exportType: Types.DataExportType, status: Types.DataExportJobStatus, s3Path: string, downloadUrl: string | null, filename: string | null, mimeType: string, error: string | null, createdAt: string, updatedAt: string, expiredAt: number }> };

export type UpdatePlayerMutationVariables = Exact<{
  input: Types.FullUpdatePlayerInput;
}>;


export type UpdatePlayerMutation = { updatePlayer: { id: string } };

export type DeletePlayerMutationVariables = Exact<{
  playerId: string;
}>;


export type DeletePlayerMutation = { deletePlayer: boolean };

export type UpdatePlayerPointsMutationVariables = Exact<{
  input: Types.IncrementPlayerPoint;
}>;


export type UpdatePlayerPointsMutation = { updatePlayerPoints: boolean };

export type PlayerJoinTeamMutationVariables = Exact<{
  input: Types.JoinTeamInput;
}>;


export type PlayerJoinTeamMutation = { joinTeam: boolean };

export type CreatePlayerTagMutationVariables = Exact<{
  input: Types.PlayerTagCreateInput;
}>;


export type CreatePlayerTagMutation = { assignTag: { deviceID: string | null } };

export type PlayersListTableQueryVariables = Exact<{
  gameId?: string | null | undefined;
}>;


export type PlayersListTableQuery = { findPlayers: Array<{ id: string, tags: Array<{ tagType: Types.TagTypes, tagNumber: number }>, profile: { isRegistered: boolean | null }, info: { gameId: string | null, teamId: string | null, publicName: string | null, avatar: string | null }, role: { isChild: boolean | null, parentId: string | null, isAnonymous: boolean | null, authID: string | null, removedAt: string | null }, points: { all: number, routes: number, gems: number, extra: number, mileage: number | null } | null }> };

export type PlayerListLeaderboardQueryVariables = Exact<{
  input: Types.GetPlayerLeaderboardsInput;
}>;


export type PlayerListLeaderboardQuery = { getPlayerLeaderboards: { data: Array<{ id: string, amount: number, name: string }> } };

export type FindPlayersListQueryVariables = Exact<{
  input: Types.PlayersListInput;
}>;


export type FindPlayersListQuery = { findPlayerList: Array<{ id: string, all: number, isAnonymous: boolean | null }> };

export type PlayerGameTeamsQueryVariables = Exact<{
  input: Types.FindTeamsInput;
}>;


export type PlayerGameTeamsQuery = { teams: Array<{ id: string, name: string }> };

export type PlayerRoutesQueryVariables = Exact<{
  playerId: string;
}>;


export type PlayerRoutesQuery = { getPlayer: { routes: Array<{ __typename: 'Route', id: string, tagNumber: number, locationId: string, locationSlug: string | null, swipeTimestamp: string, swipeId: string, points: number }> | null, gemRoutes: Array<{ __typename: 'GemRoute', id: string, tagNumber: number, locationId: string, locationSlug: string | null, timestamp: string, points: number, gemType: Types.GemType }> | null } };

export type PlayerLuckySwipesQueryVariables = Exact<{
  playerId: string;
  gameId: string;
}>;


export type PlayerLuckySwipesQuery = { getPlayerLuckySwipes: Array<{ id: string, tagNumber: number, locationId: string | null, locationName: string | null, timestamp: string, isLucky: boolean | null, extraPoints: number | null, status: Types.SwipeStatus }> };

export type PlayerRawSwipesQueryVariables = Exact<{
  input: Types.FindByTag;
}>;


export type PlayerRawSwipesQuery = { findSwipeByTag: Array<{ id: string, tagNumber: number, locationName: string | null, timestamp: string, status: Types.SwipeStatus, locationId: string | null, sourceMetadata: unknown, wtuLat: number | null, wtuLng: number | null, invalidationReason: string | null, reason: string | null, isLucky: boolean | null }> };

export type FindPlayerSurveysQueryVariables = Exact<{
  playerId: string;
  gameId: string;
}>;


export type FindPlayerSurveysQuery = { findPlayerSurveys: Array<{ isConfirmed: boolean, active: string | null, bame: Types.AnswerType | null, disability: Types.AnswerType | null, condition: Types.AnswerType | null, surveyType: Types.SurveyTypes, confirmedDate: string, createdAt: string, status: Types.SurveyStatus | null }> };

export type PlayerLeaveTeamMutationVariables = Exact<{
  playerId: string;
}>;


export type PlayerLeaveTeamMutation = { leaveTeam: boolean };

export type GetGameByIdQueryVariables = Exact<{
  id: string;
}>;


export type GetGameByIdQuery = { getGame: { id: string, info: { name: string } } };

export type GetPlayersForPaginatedListQueryVariables = Exact<{
  input: Types.GetForPaginatedListInput;
}>;


export type GetPlayersForPaginatedListQuery = { getPlayersForPaginatedList: Array<{ id: string, tags: Array<{ tagType: Types.TagTypes, tagNumber: number }>, profile: { isRegistered: boolean | null }, info: { gameId: string | null, teamId: string | null, publicName: string | null, avatar: string | null }, role: { isChild: boolean | null, parentId: string | null, isAnonymous: boolean | null, authID: string | null, removedAt: string | null }, points: { all: number, routes: number, gems: number, extra: number, mileage: number | null } | null }> };

export type SearchPlayerInGameQueryVariables = Exact<{
  input: Types.SearchPlayerByInput;
}>;


export type SearchPlayerInGameQuery = { getPlayerBy: { id: string, tags: Array<{ tagType: Types.TagTypes, tagNumber: number }>, profile: { isRegistered: boolean | null }, info: { gameId: string | null, teamId: string | null, publicName: string | null, avatar: string | null }, role: { isChild: boolean | null, parentId: string | null, isAnonymous: boolean | null, authID: string | null, removedAt: string | null }, points: { all: number, routes: number, gems: number, extra: number, mileage: number | null } | null } };

export type KickFromGameMutationVariables = Exact<{
  playerId: string;
}>;


export type KickFromGameMutation = { kickFromGame: boolean };

export type RemovePlayersFromGameMutationVariables = Exact<{
  gameId: string;
}>;


export type RemovePlayersFromGameMutation = { removePlayersFromGame: boolean };

export type FindGameResourcesQueryVariables = Exact<{
  gameId: string;
}>;


export type FindGameResourcesQuery = { findGameResources: Array<{ key: Types.GameResourceKey, title: string, available: boolean, unavailableReason: string | null }> };

export type GenerateGameResourcePdfMutationVariables = Exact<{
  input: Types.GenerateGameResourcePdfInput;
}>;


export type GenerateGameResourcePdfMutation = { generateGameResourcePdf: { jobId: string, gameId: string, status: Types.PdfGenerationStatus, s3Path: string, downloadUrl: string | null, filename: string | null, mimeType: string, error: string | null, createdAt: string, updatedAt: string } };

export type GetPdfGenerationJobQueryVariables = Exact<{
  gameId: string;
  jobId: string;
}>;


export type GetPdfGenerationJobQuery = { getPdfGenerationJob: { jobId: string, gameId: string, status: Types.PdfGenerationStatus, s3Path: string, downloadUrl: string | null, filename: string | null, mimeType: string, error: string | null, createdAt: string, updatedAt: string } };

export type UpdateGameMutationVariables = Exact<{
  input: Types.UpdateGameInput;
}>;


export type UpdateGameMutation = { updateGame: { id: string, info: { slug: string } } };

export type DeleteGameMutationVariables = Exact<{
  input: Types.DeleteGameInput;
}>;


export type DeleteGameMutation = { deleteGame: boolean };

export type GetGameWithSurveysQueryVariables = Exact<{
  slug: string;
}>;


export type GetGameWithSurveysQuery = { getGameBySlug: { id: string, info: { region: Types.GameRegion | null, surveys: { tellUsAboutYou: { surveyID: string, link: string, surveyName: string | null, validationStatus: Types.ValidationStatus | null, lastValidated: string | null } | null, closing: { surveyID: string, link: string, surveyName: string | null, validationStatus: Types.ValidationStatus | null, lastValidated: string | null, shownFromDate: string, isAutoSend: boolean, sendDaysBeforeEnd: Array<number> | null } | null, sixMonths: { surveyID: string, link: string, surveyName: string | null, validationStatus: Types.ValidationStatus | null, lastValidated: string | null, sendDate: string, isAutoSend: boolean } | null, oneYear: { surveyID: string, link: string, surveyName: string | null, validationStatus: Types.ValidationStatus | null, lastValidated: string | null, sendDate: string, isAutoSend: boolean } | null } | null, settings: { minSwipeTime: number, timezone: string, city: string | null, lat: number | null, lon: number | null, target: number, targetZones: Array<string> | null, locationDistanceMeters: number, beatBoxPlacementValidationEnabled: boolean | null, POIName: string | null, collectPartnerConsentForAges13To17: boolean | null, luckyTapEnabled: boolean | null, luckyTapFrequency: number | null, luckyTapPoints: number | null, mappingApprovalsRequired: boolean | null, mappingPostRequired: boolean | null, targetBeatBoxCount: number | null } } } };

export type FAnswerFragment = { days: { status: Types.ValidateSurveyStatus, errors: unknown }, minutes: { status: Types.ValidateSurveyStatus, errors: unknown }, hours: { status: Types.ValidateSurveyStatus, errors: unknown }, flag: { status: Types.ValidateSurveyStatus, errors: unknown } };

export type FQuestionFragment = { days: { status: Types.ValidateSurveyStatus, message: string }, minutes: { status: Types.ValidateSurveyStatus, message: string }, hours: { status: Types.ValidateSurveyStatus, message: string }, flag: { status: Types.ValidateSurveyStatus, message: string } };

export type AdminValidateSurveyMutationVariables = Exact<{
  input: Types.AdminValidateSurvey;
}>;


export type AdminValidateSurveyMutation = { validateSurvey: { surveyTitle: string | null, surveyLink: string | null, childrenAnswers: { days: { status: Types.ValidateSurveyStatus, errors: unknown }, minutes: { status: Types.ValidateSurveyStatus, errors: unknown }, hours: { status: Types.ValidateSurveyStatus, errors: unknown }, flag: { status: Types.ValidateSurveyStatus, errors: unknown } }, adultAnswers: { days: { status: Types.ValidateSurveyStatus, errors: unknown }, minutes: { status: Types.ValidateSurveyStatus, errors: unknown }, hours: { status: Types.ValidateSurveyStatus, errors: unknown }, flag: { status: Types.ValidateSurveyStatus, errors: unknown } }, childrenQuestions: { days: { status: Types.ValidateSurveyStatus, message: string }, minutes: { status: Types.ValidateSurveyStatus, message: string }, hours: { status: Types.ValidateSurveyStatus, message: string }, flag: { status: Types.ValidateSurveyStatus, message: string } }, adultQuestions: { days: { status: Types.ValidateSurveyStatus, message: string }, minutes: { status: Types.ValidateSurveyStatus, message: string }, hours: { status: Types.ValidateSurveyStatus, message: string }, flag: { status: Types.ValidateSurveyStatus, message: string } }, extraQuestions: { condition: { status: Types.ValidateSurveyStatus, message: string }, bame: { status: Types.ValidateSurveyStatus, message: string }, disability: { status: Types.ValidateSurveyStatus, message: string } } } };

export type AdminSearchSurveysMutationVariables = Exact<{
  input: Types.AdminSearchSurveys;
}>;


export type AdminSearchSurveysMutation = { searchSurveys: Array<{ id: string, title: string, link: string | null, dateCreated: string | null, dateModified: string | null }> };

export type AllTeamsQueryVariables = Exact<{
  input: Types.FindTeamsInput;
}>;


export type AllTeamsQuery = { findTeams: Array<{ id: string }> };

export type AllSwipesQueryVariables = Exact<{
  input: Types.FindSwipeByDateRange;
}>;


export type AllSwipesQuery = { findSwipeByDateRange: Array<{ id: string, tagNumber: number, locationName: string | null, timestamp: string, status: Types.SwipeStatus, locationId: string | null, sourceMetadata: unknown, wtuLat: number | null, wtuLng: number | null }> };

export type AdminGetSurveyLinkMutationVariables = Exact<{
  input: Types.AdminGetSurveyLink;
}>;


export type AdminGetSurveyLinkMutation = { getSurveyLink: string | null };

export type CreateTeamMutationVariables = Exact<{
  input: Types.TeamCreateInput;
}>;


export type CreateTeamMutation = { createTeam: { id: string } };

export type UpdateTeamMutationVariables = Exact<{
  input: Types.TeamUpdateInput;
}>;


export type UpdateTeamMutation = { updateTeam: { id: string } };

export type DeleteTeamMutationVariables = Exact<{
  input: Types.TeamDeleteInput;
}>;


export type DeleteTeamMutation = { deleteTeam: boolean };

export type TeamsListTableQueryVariables = Exact<{
  input: Types.FindTeamsInput;
}>;


export type TeamsListTableQuery = { teams: Array<{ id: string, name: string, type: Types.TeamTypes, status: Types.TeamStatus, leaderboardId: string | null, all: number, mileage: number | null, totalMembers: number, gems: number, extra: number }> };

export type TeamsWithDetailsQueryVariables = Exact<{
  input: Types.FindTeamsInput;
}>;


export type TeamsWithDetailsQuery = { teamsWithDetails: Array<{ id: string, name: string, type: Types.TeamTypes, gameId: string | null, details: { id: string, description: string | null, rollNumber: number | null } }> };

export type GetTeamFullQueryVariables = Exact<{
  input: Types.GetTeamInput;
}>;


export type GetTeamFullQuery = { team: { id: string, name: string, type: Types.TeamTypes, status: Types.TeamStatus, leaderboardId: string | null, all: number, mileage: number | null, totalMembers: number, gems: number, extra: number, gameId: string | null, routes: number, subranges: Array<{ from: number, to: number }>, details: { description: string | null, rejectionReason: string | null, rollNumber: number | null, leaders: Array<string> | null, leadersEmails: Array<string> | null } } };

export type GetTeamLeaderboardQueryVariables = Exact<{
  id?: string | null | undefined;
  gameId?: string | null | undefined;
}>;


export type GetTeamLeaderboardQuery = { leaderboard: { name: string, teamTypes: Array<Types.TeamTypes> | null } };

export type TeamPlayersListTableQueryVariables = Exact<{
  gameId?: string | null | undefined;
  teamId: string;
}>;


export type TeamPlayersListTableQuery = { findPlayers: Array<{ id: string, tags: Array<{ tagType: Types.TagTypes, tagNumber: number }>, info: { gameId: string | null, teamId: string | null, publicName: string | null, avatar: string | null }, profile: { firstName: string | null, email: string, birthDate: string | null, gender: string | null, isRegistered: boolean | null, ageGroup: string | null }, role: { isChild: boolean | null, parentId: string | null, isAnonymous: boolean | null, authID: string | null, removedAt: string | null }, points: { all: number, routes: number, gems: number, extra: number, mileage: number | null } | null }> };

export type GetLeaderInfoQueryVariables = Exact<{
  id: string;
}>;


export type GetLeaderInfoQuery = { getPlayer: { info: { id: string, publicName: string | null, gameId: string | null }, profile: { email: string } } };

export type FindTeamNamesQueryVariables = Exact<{
  input: Types.FindTeamsInput;
}>;


export type FindTeamNamesQuery = { findTeamNames: { teamNames: Array<string> } };

export type FindAllTeamsQueryVariables = Exact<{
  input: Types.FindTeamsInput;
}>;


export type FindAllTeamsQuery = { findTeams: Array<{ id: string, name: string, type: Types.TeamTypes, status: Types.TeamStatus, all: number, totalMembers: number, details: { rollNumber: number | null } }> };

export type GetAnalyticsGameAggregateQueryVariables = Exact<{
  gameId: string;
  metric: Types.AnalyticsMetric;
}>;


export type GetAnalyticsGameAggregateQuery = { gameAggregates: { count: number, metric: Types.AnalyticsMetric, updatedAt: string } };

export type GetAnalyticsNamedCounterAggregatesQueryVariables = Exact<{
  gameId: string;
  counterName: Types.AnalyticsNamedCounterName;
  bucketNames: Array<string> | string;
}>;


export type GetAnalyticsNamedCounterAggregatesQuery = { namedCounterAggregates: Array<{ bucketName: string, counterName: Types.AnalyticsNamedCounterName, updatedAt: string, value: number }> };

export type GetAnalyticsHour2AggregatesQueryVariables = Exact<{
  gameId: string;
  metric: Types.AnalyticsMetric;
  hour2Buckets: Array<string> | string;
}>;


export type GetAnalyticsHour2AggregatesQuery = { hour2Aggregates: Array<{ count: number, hour2Bucket: string, metric: Types.AnalyticsMetric, updatedAt: string }> };

export type GetAnalyticsLocationAggregatesQueryVariables = Exact<{
  gameId: string;
  metric: Types.AnalyticsMetric;
  locationIds: Array<string | number> | string | number;
}>;


export type GetAnalyticsLocationAggregatesQuery = { locationAggregates: Array<{ count: number, locationId: string, metric: Types.AnalyticsMetric, updatedAt: string }> };

export type FindAnalyticsLocationsQueryVariables = Exact<{
  gameId: string;
}>;


export type FindAnalyticsLocationsQuery = { findLocations: Array<{ id: string, name: string | null, slug: string, description: string | null, type: Types.LocationTypes, beatBoxNumber: number | null, isBonus: boolean | null }> };

export type ListLuckyTapsQueryVariables = Exact<{
  gameId: string;
}>;


export type ListLuckyTapsQuery = { listLuckySwipes: Array<{ id: string, gameId: string, tagNumber: number, timestamp: string, status: Types.SwipeStatus, invalidationReason: string | null, reason: string | null, locationId: string | null, locationName: string | null, sourceMetadata: unknown, wtuSerial: number | null, wtuSequence: number | null, wtuLat: number | null, wtuLng: number | null, createdAt: string, isLucky: boolean | null }> };

export type CreatePrizeDrawMutationVariables = Exact<{
  gameId: string;
  title: string;
  description: string;
  winnersCount: number;
  type: Types.PrizeDrawType;
  prizeType: Types.PrizeType;
  start?: string | null | undefined;
  end?: string | null | undefined;
  boxIds?: Array<string> | string | null | undefined;
  eventIds?: Array<string> | string | null | undefined;
  surveyType?: string | null | undefined;
  winnersDistribution?: Types.WinnersDistributionInput | null | undefined;
  autoSendWinnerEmails?: boolean | null | undefined;
  autoFulfilOnAccept?: boolean | null | undefined;
  scheduledAt?: string | null | undefined;
}>;


export type CreatePrizeDrawMutation = { createPrizeDraw: string };

export type SendPrizeDrawWinnerEmailMutationVariables = Exact<{
  drawId: string;
  gameId: string;
  playerId: string;
}>;


export type SendPrizeDrawWinnerEmailMutation = { sendPrizeDrawWinnerEmail: boolean };

export type MarkPrizeDrawWinnerAsFulfilledMutationVariables = Exact<{
  drawId: string;
  gameId: string;
  playerId: string;
}>;


export type MarkPrizeDrawWinnerAsFulfilledMutation = { markPrizeDrawWinnerAsFulfilled: boolean };

export type DeletePrizeDrawWinnerMutationVariables = Exact<{
  drawId: string;
  gameId: string;
  playerId: string;
}>;


export type DeletePrizeDrawWinnerMutation = { deletePrizeDrawWinner: boolean };

export type DeletePrizeDrawMutationVariables = Exact<{
  drawId: string;
  gameId: string;
}>;


export type DeletePrizeDrawMutation = { deletePrizeDraw: boolean };

export type DrawMorePrizeDrawWinnersMutationVariables = Exact<{
  gameId: string;
  drawId: string;
  winnersCount: number;
  winnersDistribution?: Types.WinnersDistributionInput | null | undefined;
}>;


export type DrawMorePrizeDrawWinnersMutation = { drawMorePrizeDrawWinners: number };

export type ListPrizeDrawsQueryVariables = Exact<{
  gameId: string;
}>;


export type ListPrizeDrawsQuery = { listPrizeDraws: Array<{ drawId: string, title: string, description: string, winnersCount: number, winnersDrawn: number | null, type: Types.PrizeDrawType, prizeType: Types.PrizeType, gameId: string, status: Types.PrizeDrawStatus, displayStatus: Types.PrizeDrawDisplayStatus | null, scheduledAt: string | null }> };

export type GetPrizeDrawQueryVariables = Exact<{
  gameId: string;
  drawId: string;
}>;


export type GetPrizeDrawQuery = { getPrizeDraw: { drawId: string, title: string, description: string, winnersCount: number, type: Types.PrizeDrawType, prizeType: Types.PrizeType, gameId: string, status: Types.PrizeDrawStatus, scheduledAt: string | null, start: string | null, end: string | null, boxIds: Array<string> | null, eventIds: Array<string> | null, surveyType: string | null, autoSendWinnerEmails: boolean | null, autoFulfilOnAccept: boolean | null, winnersDistribution: { child: number, adult: number } | null } };

export type ListPrizeDrawWinnersQueryVariables = Exact<{
  drawId: string;
  gameId: string;
}>;


export type ListPrizeDrawWinnersQuery = { listPrizeDrawWinners: Array<{ drawId: string, gameId: string, playerId: string, parentId: string | null, swipeId: string | null, email: string, status: Types.PrizeDrawWinnerStatus, reason: string | null, createdAt: string, info: { id: string, avatar: string | null, publicName: string | null }, profile: { id: string, email: string, fullName: string | null, firstName: string | null }, parentProfile: { id: string, email: string, fullName: string | null, firstName: string | null } | null }> };

export type GetZoneAggregatesQueryVariables = Exact<{
  gameId: string;
  metric: Types.AnalyticsMetric;
  zoneIds: Array<string> | string;
  filter?: Types.AnalyticsFilterInput | null | undefined;
}>;


export type GetZoneAggregatesQuery = { zoneAggregates: Array<{ zoneId: string, count: number, metric: Types.AnalyticsMetric }> };

export type MappingLocationFieldsFragment = { id: string, gameId: string, name: string, description: string, mappingNotes: string | null, type: Types.LocationTypes, gemType: Types.GemType | null, points: number | null, beatBoxNumber: number | null, accessible: boolean | null, isBonus: boolean | null, ownerName: string | null, slug: string | null, what3words: string | null, publishedAt: string | null, selectedCandidateId: string | null, reviewStatus: Types.MappingLocationReviewStatus, createdAt: string, updatedAt: string, coordinates: { lat: number, lng: number } | null, candidates: Array<{ id: string, lat: number, lng: number, note: string | null }>, geo: { isochrone: unknown, lamppost: unknown, nearest: unknown } | null };

export type MappingGroupFieldsFragment = { id: string, gameId: string, name: string, description: string | null, color: string };

export type MappingGroupElementFieldsFragment = { gameId: string, groupId: string, locationId: string };

export type MappingReviewFieldsFragment = { id: string, gameId: string, locationId: string, type: Types.MappingReviewType, status: Types.MappingReviewStatus, approvedAt: string | null, riskAssessment: unknown, createdAt: string, updatedAt: string };

export type MappingCommentFieldsFragment = { id: string, gameId: string, kind: Types.MappingCommentKind, reviewType: Types.MappingReviewType, locationId: string | null, layer: Types.MappingLayer | null, parentCommentId: string | null, content: string, authorRole: Types.MappingCommentAuthorRole, status: Types.MappingCommentStatus, resolvedAt: string | null, createdAt: string, updatedAt: string, author: { name: string, email: string }, coordinates: { lat: number, lng: number } | null, reactions: Array<{ emoji: string, actors: Array<{ name: string, email: string }> }> | null };

export type MappingReviewerFieldsFragment = { id: string, gameId: string, allowedReviewType: Types.MappingReviewerType, name: string, email: string, token: string, expiresAt: string, createdAt: string, updatedAt: string };

export type MappingHistoryFieldsFragment = { id: string, gameId: string, locationId: string, action: Types.MappingHistoryAction, metadata: unknown, createdAt: string, updatedAt: string, actor: { name: string, email: string } };

export type MappingLocationQueryVariables = Exact<{
  gameId: string;
  id: string;
}>;


export type MappingLocationQuery = { mappingLocation: { id: string, gameId: string, name: string, description: string, mappingNotes: string | null, type: Types.LocationTypes, gemType: Types.GemType | null, points: number | null, beatBoxNumber: number | null, accessible: boolean | null, isBonus: boolean | null, ownerName: string | null, slug: string | null, what3words: string | null, publishedAt: string | null, selectedCandidateId: string | null, reviewStatus: Types.MappingLocationReviewStatus, createdAt: string, updatedAt: string, coordinates: { lat: number, lng: number } | null, candidates: Array<{ id: string, lat: number, lng: number, note: string | null }>, geo: { isochrone: unknown, lamppost: unknown, nearest: unknown } | null } };

export type AssessMappingPlacementQueryVariables = Exact<{
  gameId: string;
  lng: number;
  lat: number;
  selfId?: string | null | undefined;
  snap?: boolean | null | undefined;
}>;


export type AssessMappingPlacementQuery = { assessMappingPlacement: { coord: Array<number>, isochrone: unknown, nearest: unknown, isTooClose: boolean } };

export type NearbyMappingLamppostsQueryVariables = Exact<{
  gameId: string;
  lng: number;
  lat: number;
}>;


export type NearbyMappingLamppostsQuery = { nearbyMappingLampposts: { searchRadiusMeters: number, candidates: Array<{ osid: string, lat: number, lng: number, distanceMeters: number }> } };

export type MappingReviewsQueryVariables = Exact<{
  gameId: string;
  locationId: string;
}>;


export type MappingReviewsQuery = { mappingReviews: Array<{ id: string, gameId: string, locationId: string, type: Types.MappingReviewType, status: Types.MappingReviewStatus, approvedAt: string | null, riskAssessment: unknown, createdAt: string, updatedAt: string }> };

export type MappingReviewQueryVariables = Exact<{
  gameId: string;
  locationId: string;
  type: Types.MappingReviewType;
}>;


export type MappingReviewQuery = { mappingReview: { id: string, gameId: string, locationId: string, type: Types.MappingReviewType, status: Types.MappingReviewStatus, approvedAt: string | null, riskAssessment: unknown, createdAt: string, updatedAt: string } };

export type MappingReviewersQueryVariables = Exact<{
  gameId: string;
}>;


export type MappingReviewersQuery = { mappingReviewers: Array<{ id: string, gameId: string, allowedReviewType: Types.MappingReviewerType, name: string, email: string, token: string, expiresAt: string, createdAt: string, updatedAt: string }> };

export type MappingLocationHistoryQueryVariables = Exact<{
  gameId: string;
  locationId: string;
}>;


export type MappingLocationHistoryQuery = { mappingLocationHistory: Array<{ id: string, gameId: string, locationId: string, action: Types.MappingHistoryAction, metadata: unknown, createdAt: string, updatedAt: string, actor: { name: string, email: string } }> };

export type CreateMappingLocationMutationVariables = Exact<{
  input: Types.CreateMappingLocationInput;
}>;


export type CreateMappingLocationMutation = { createMappingLocation: { id: string, gameId: string, name: string, description: string, mappingNotes: string | null, type: Types.LocationTypes, gemType: Types.GemType | null, points: number | null, beatBoxNumber: number | null, accessible: boolean | null, isBonus: boolean | null, ownerName: string | null, slug: string | null, what3words: string | null, publishedAt: string | null, selectedCandidateId: string | null, reviewStatus: Types.MappingLocationReviewStatus, createdAt: string, updatedAt: string, coordinates: { lat: number, lng: number } | null, candidates: Array<{ id: string, lat: number, lng: number, note: string | null }>, geo: { isochrone: unknown, lamppost: unknown, nearest: unknown } | null } };

export type UpdateMappingLocationMutationVariables = Exact<{
  input: Types.UpdateMappingLocationInput;
}>;


export type UpdateMappingLocationMutation = { updateMappingLocation: { id: string, gameId: string, name: string, description: string, mappingNotes: string | null, type: Types.LocationTypes, gemType: Types.GemType | null, points: number | null, beatBoxNumber: number | null, accessible: boolean | null, isBonus: boolean | null, ownerName: string | null, slug: string | null, what3words: string | null, publishedAt: string | null, selectedCandidateId: string | null, reviewStatus: Types.MappingLocationReviewStatus, createdAt: string, updatedAt: string, coordinates: { lat: number, lng: number } | null, candidates: Array<{ id: string, lat: number, lng: number, note: string | null }>, geo: { isochrone: unknown, lamppost: unknown, nearest: unknown } | null } };

export type UpdateMappingGroupMutationVariables = Exact<{
  input: Types.UpdateGroupInput;
}>;


export type UpdateMappingGroupMutation = { updateMappingGroup: { id: string, gameId: string, name: string, description: string | null, color: string } };

export type DeleteMappingGroupMutationVariables = Exact<{
  gameId: string;
  id: string;
}>;


export type DeleteMappingGroupMutation = { deleteMappingGroup: boolean };

export type CreateMappingGroupElementMutationVariables = Exact<{
  input: Types.GroupElementInput;
}>;


export type CreateMappingGroupElementMutation = { createMappingGroupElement: { gameId: string, groupId: string, locationId: string } };

export type DeleteMappingGroupElementMutationVariables = Exact<{
  input: Types.GroupElementInput;
}>;


export type DeleteMappingGroupElementMutation = { deleteMappingGroupElement: boolean };

export type CreateMappingReviewMutationVariables = Exact<{
  input: Types.CreateMappingReviewInput;
}>;


export type CreateMappingReviewMutation = { createMappingReview: { id: string, gameId: string, locationId: string, type: Types.MappingReviewType, status: Types.MappingReviewStatus, approvedAt: string | null, riskAssessment: unknown, createdAt: string, updatedAt: string } };

export type UpdateMappingReviewMutationVariables = Exact<{
  input: Types.UpdateMappingReviewInput;
}>;


export type UpdateMappingReviewMutation = { updateMappingReview: { id: string, gameId: string, locationId: string, type: Types.MappingReviewType, status: Types.MappingReviewStatus, approvedAt: string | null, riskAssessment: unknown, createdAt: string, updatedAt: string } };

export type InviteMappingReviewerMutationVariables = Exact<{
  input: Types.InviteMappingReviewerInput;
}>;


export type InviteMappingReviewerMutation = { inviteMappingReviewer: { id: string, gameId: string, allowedReviewType: Types.MappingReviewerType, name: string, email: string, token: string, expiresAt: string, createdAt: string, updatedAt: string } };

export type DeleteMappingReviewerMutationVariables = Exact<{
  gameId: string;
  id: string;
}>;


export type DeleteMappingReviewerMutation = { deleteMappingReviewer: boolean };

export type CreateMappingCommentMutationVariables = Exact<{
  input: Types.CreateMappingCommentInput;
}>;


export type CreateMappingCommentMutation = { createMappingComment: { id: string, gameId: string, kind: Types.MappingCommentKind, reviewType: Types.MappingReviewType, locationId: string | null, layer: Types.MappingLayer | null, parentCommentId: string | null, content: string, authorRole: Types.MappingCommentAuthorRole, status: Types.MappingCommentStatus, resolvedAt: string | null, createdAt: string, updatedAt: string, author: { name: string, email: string }, coordinates: { lat: number, lng: number } | null, reactions: Array<{ emoji: string, actors: Array<{ name: string, email: string }> }> | null } };

export type ToggleMappingCommentReactionMutationVariables = Exact<{
  input: Types.ToggleMappingCommentReactionInput;
}>;


export type ToggleMappingCommentReactionMutation = { toggleMappingCommentReaction: { id: string, gameId: string, kind: Types.MappingCommentKind, reviewType: Types.MappingReviewType, locationId: string | null, layer: Types.MappingLayer | null, parentCommentId: string | null, content: string, authorRole: Types.MappingCommentAuthorRole, status: Types.MappingCommentStatus, resolvedAt: string | null, createdAt: string, updatedAt: string, author: { name: string, email: string }, coordinates: { lat: number, lng: number } | null, reactions: Array<{ emoji: string, actors: Array<{ name: string, email: string }> }> | null } };

export type UpdateMappingCommentMutationVariables = Exact<{
  input: Types.UpdateMappingCommentInput;
}>;


export type UpdateMappingCommentMutation = { updateMappingComment: { id: string, gameId: string, kind: Types.MappingCommentKind, reviewType: Types.MappingReviewType, locationId: string | null, layer: Types.MappingLayer | null, parentCommentId: string | null, content: string, authorRole: Types.MappingCommentAuthorRole, status: Types.MappingCommentStatus, resolvedAt: string | null, createdAt: string, updatedAt: string, author: { name: string, email: string }, coordinates: { lat: number, lng: number } | null, reactions: Array<{ emoji: string, actors: Array<{ name: string, email: string }> }> | null } };

export type MappingCommentsQueryVariables = Exact<{
  gameId: string;
}>;


export type MappingCommentsQuery = { mappingComments: Array<{ id: string, gameId: string, kind: Types.MappingCommentKind, reviewType: Types.MappingReviewType, locationId: string | null, layer: Types.MappingLayer | null, parentCommentId: string | null, content: string, authorRole: Types.MappingCommentAuthorRole, status: Types.MappingCommentStatus, resolvedAt: string | null, createdAt: string, updatedAt: string, author: { name: string, email: string }, coordinates: { lat: number, lng: number } | null, reactions: Array<{ emoji: string, actors: Array<{ name: string, email: string }> }> | null }> };

export type MappingGameRevisionQueryVariables = Exact<{
  gameId: string;
}>;


export type MappingGameRevisionQuery = { mappingGameRevision: number };

export type ResolveMappingCommentMutationVariables = Exact<{
  input: Types.ResolveMappingCommentInput;
}>;


export type ResolveMappingCommentMutation = { resolveMappingComment: { id: string, gameId: string, kind: Types.MappingCommentKind, reviewType: Types.MappingReviewType, locationId: string | null, layer: Types.MappingLayer | null, parentCommentId: string | null, content: string, authorRole: Types.MappingCommentAuthorRole, status: Types.MappingCommentStatus, resolvedAt: string | null, createdAt: string, updatedAt: string, author: { name: string, email: string }, coordinates: { lat: number, lng: number } | null, reactions: Array<{ emoji: string, actors: Array<{ name: string, email: string }> }> | null } };

export type MappingLocationsQueryVariables = Exact<{
  gameId: string;
}>;


export type MappingLocationsQuery = { mappingLocations: Array<{ id: string, gameId: string, name: string, description: string, mappingNotes: string | null, type: Types.LocationTypes, gemType: Types.GemType | null, points: number | null, beatBoxNumber: number | null, accessible: boolean | null, isBonus: boolean | null, ownerName: string | null, slug: string | null, what3words: string | null, publishedAt: string | null, selectedCandidateId: string | null, reviewStatus: Types.MappingLocationReviewStatus, createdAt: string, updatedAt: string, coordinates: { lat: number, lng: number } | null, candidates: Array<{ id: string, lat: number, lng: number, note: string | null }>, geo: { isochrone: unknown, lamppost: unknown, nearest: unknown } | null }> };

export type MappingGroupsQueryVariables = Exact<{
  gameId: string;
}>;


export type MappingGroupsQuery = { mappingGroups: Array<{ id: string, gameId: string, name: string, description: string | null, color: string }> };

export type MappingGroupElementsQueryVariables = Exact<{
  gameId: string;
  groupId?: string | null | undefined;
}>;


export type MappingGroupElementsQuery = { mappingGroupElements: Array<{ gameId: string, groupId: string, locationId: string }> };

export type CreateMappingGroupMutationVariables = Exact<{
  input: Types.CreateGroupInput;
}>;


export type CreateMappingGroupMutation = { createMappingGroup: { id: string, gameId: string, name: string, description: string | null, color: string } };

export type PublishMappingLocationMutationVariables = Exact<{
  gameId: string;
  id: string;
}>;


export type PublishMappingLocationMutation = { publishMappingLocation: { id: string, reviewStatus: Types.MappingLocationReviewStatus } };

export type PublishMappingGameMutationVariables = Exact<{
  gameId: string;
  layers?: Array<Types.MappingLayer> | Types.MappingLayer | null | undefined;
  locationIds?: Array<string> | string | null | undefined;
}>;


export type PublishMappingGameMutation = { publishMappingGame: { publishedCount: number, skippedCount: number, failedLocationIds: Array<string>, skipped: Array<{ locationId: string, reason: Types.MappingPublishSkipReason }> } };

export type DeleteMappingLocationMutationVariables = Exact<{
  gameId: string;
  id: string;
}>;


export type DeleteMappingLocationMutation = { deleteMappingLocation: boolean };

export type SearchPlayerFragment = { id: string, profile: { fullName: string | null, firstName: string | null, email: string, birthDate: string | null, gender: string | null, isRegistered: boolean | null, ageGroup: string | null }, info: { publicName: string | null, gameId: string | null }, role: { isAnonymous: boolean | null }, tags: Array<{ tagNumber: number, tagType: Types.TagTypes }> };

export type GetPlayerByIdQueryVariables = Exact<{
  id: string;
}>;


export type GetPlayerByIdQuery = { getPlayer: { id: string, profile: { fullName: string | null, firstName: string | null, email: string, birthDate: string | null, gender: string | null, isRegistered: boolean | null, ageGroup: string | null }, info: { publicName: string | null, gameId: string | null }, role: { isAnonymous: boolean | null }, tags: Array<{ tagNumber: number, tagType: Types.TagTypes }> } };

export type GetPlayerByEmailQueryVariables = Exact<{
  email: string;
}>;


export type GetPlayerByEmailQuery = { getPlayerByEmail: { id: string, profile: { fullName: string | null, firstName: string | null, email: string, birthDate: string | null, gender: string | null, isRegistered: boolean | null, ageGroup: string | null }, info: { publicName: string | null, gameId: string | null }, role: { isAnonymous: boolean | null }, tags: Array<{ tagNumber: number, tagType: Types.TagTypes }> } };

export type GetTagByNumberQueryVariables = Exact<{
  tagNumber: number;
}>;


export type GetTagByNumberQuery = { getTagByTagNumber: { playerId: string } | null };

export type SearchPlayerByQueryVariables = Exact<{
  input: Types.SearchPlayerByInput;
}>;


export type SearchPlayerByQuery = { getPlayerBy: { id: string, tags: Array<{ tagType: Types.TagTypes, tagNumber: number }>, profile: { isRegistered: boolean | null }, info: { gameId: string | null, teamId: string | null, publicName: string | null, avatar: string | null }, role: { isChild: boolean | null, parentId: string | null, isAnonymous: boolean | null, authID: string | null, removedAt: string | null } } };

export type ReviewerMappingLocationFieldsFragment = { id: string, gameId: string, name: string, slug: string | null, beatBoxNumber: number | null, accessible: boolean | null, gemType: Types.GemType | null, description: string, mappingNotes: string | null, type: Types.LocationTypes, isMobile: boolean | null, reviewStatus: Types.MappingLocationReviewStatus, selectedCandidateId: string | null, what3words: string | null, createdAt: string, updatedAt: string, coordinates: { lat: number, lng: number } | null, candidates: Array<{ id: string, lat: number, lng: number, note: string | null }>, geo: { lamppost: unknown } | null };

export type ReviewerMappingReviewFieldsFragment = { id: string, gameId: string, locationId: string, type: Types.MappingReviewType, status: Types.MappingReviewStatus, approvedAt: string | null, createdAt: string, updatedAt: string };

export type ReviewerMappingCommentFieldsFragment = { id: string, gameId: string, kind: Types.MappingCommentKind, reviewType: Types.MappingReviewType, locationId: string | null, layer: Types.MappingLayer | null, parentCommentId: string | null, content: string, authorRole: Types.MappingCommentAuthorRole, status: Types.MappingCommentStatus, resolvedAt: string | null, createdAt: string, updatedAt: string, author: { name: string, email: string }, coordinates: { lat: number, lng: number } | null, reactions: Array<{ emoji: string, actors: Array<{ name: string, email: string }> }> | null };

export type ReviewerMeQueryVariables = Exact<{ [key: string]: never; }>;


export type ReviewerMeQuery = { reviewerMe: { gameId: string, gameName: string, poiName: string | null, name: string, email: string, allowedReviewType: Types.MappingReviewerType } };

export type ReviewerMappingLocationsQueryVariables = Exact<{
  layer?: Types.MappingLayer | null | undefined;
}>;


export type ReviewerMappingLocationsQuery = { reviewerMappingLocations: Array<{ location: { id: string, gameId: string, name: string, slug: string | null, beatBoxNumber: number | null, accessible: boolean | null, gemType: Types.GemType | null, description: string, mappingNotes: string | null, type: Types.LocationTypes, isMobile: boolean | null, reviewStatus: Types.MappingLocationReviewStatus, selectedCandidateId: string | null, what3words: string | null, createdAt: string, updatedAt: string, coordinates: { lat: number, lng: number } | null, candidates: Array<{ id: string, lat: number, lng: number, note: string | null }>, geo: { lamppost: unknown } | null }, review: { id: string, gameId: string, locationId: string, type: Types.MappingReviewType, status: Types.MappingReviewStatus, approvedAt: string | null, createdAt: string, updatedAt: string } }> };

export type ReviewerMappingLocationQueryVariables = Exact<{
  id: string;
}>;


export type ReviewerMappingLocationQuery = { reviewerMappingLocation: { id: string, gameId: string, name: string, slug: string | null, beatBoxNumber: number | null, accessible: boolean | null, gemType: Types.GemType | null, description: string, mappingNotes: string | null, type: Types.LocationTypes, isMobile: boolean | null, reviewStatus: Types.MappingLocationReviewStatus, selectedCandidateId: string | null, what3words: string | null, createdAt: string, updatedAt: string, coordinates: { lat: number, lng: number } | null, candidates: Array<{ id: string, lat: number, lng: number, note: string | null }>, geo: { lamppost: unknown } | null } };

export type ReviewerMappingReviewsQueryVariables = Exact<{
  locationId: string;
}>;


export type ReviewerMappingReviewsQuery = { reviewerMappingReviews: Array<{ id: string, gameId: string, locationId: string, type: Types.MappingReviewType, status: Types.MappingReviewStatus, approvedAt: string | null, createdAt: string, updatedAt: string }> };

export type ReviewerMappingCommentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReviewerMappingCommentsQuery = { reviewerMappingComments: Array<{ id: string, gameId: string, kind: Types.MappingCommentKind, reviewType: Types.MappingReviewType, locationId: string | null, layer: Types.MappingLayer | null, parentCommentId: string | null, content: string, authorRole: Types.MappingCommentAuthorRole, status: Types.MappingCommentStatus, resolvedAt: string | null, createdAt: string, updatedAt: string, author: { name: string, email: string }, coordinates: { lat: number, lng: number } | null, reactions: Array<{ emoji: string, actors: Array<{ name: string, email: string }> }> | null }> };

export type ReviewerMappingRevisionQueryVariables = Exact<{ [key: string]: never; }>;


export type ReviewerMappingRevisionQuery = { reviewerMappingRevision: number };

export type ReviewerCreateMappingCommentMutationVariables = Exact<{
  input: Types.CreateMappingCommentInput;
}>;


export type ReviewerCreateMappingCommentMutation = { reviewerCreateMappingComment: { id: string, gameId: string, kind: Types.MappingCommentKind, reviewType: Types.MappingReviewType, locationId: string | null, layer: Types.MappingLayer | null, parentCommentId: string | null, content: string, authorRole: Types.MappingCommentAuthorRole, status: Types.MappingCommentStatus, resolvedAt: string | null, createdAt: string, updatedAt: string, author: { name: string, email: string }, coordinates: { lat: number, lng: number } | null, reactions: Array<{ emoji: string, actors: Array<{ name: string, email: string }> }> | null } };

export type ReviewerUpdateMappingReviewMutationVariables = Exact<{
  input: Types.UpdateMappingReviewInput;
}>;


export type ReviewerUpdateMappingReviewMutation = { reviewerUpdateMappingReview: { id: string, gameId: string, locationId: string, type: Types.MappingReviewType, status: Types.MappingReviewStatus, approvedAt: string | null, createdAt: string, updatedAt: string } };

export type ReviewerMappingHistoryFieldsFragment = { id: string, gameId: string, locationId: string, action: Types.MappingHistoryAction, metadata: unknown, createdAt: string, updatedAt: string, actor: { name: string, email: string } };

export type ReviewerMappingLocationHistoryQueryVariables = Exact<{
  locationId: string;
}>;


export type ReviewerMappingLocationHistoryQuery = { reviewerMappingLocationHistory: Array<{ id: string, gameId: string, locationId: string, action: Types.MappingHistoryAction, metadata: unknown, createdAt: string, updatedAt: string, actor: { name: string, email: string } }> };

export type ReviewerMappingLayerReviewFieldsFragment = { gameId: string, layer: Types.MappingLayer, type: Types.MappingReviewType, status: Types.MappingLayerReviewStatus, totalCount: number, approvedCount: number, changesRequestedCount: number, respondedCount: number, pendingCount: number, openQueryCount: number, approvedAt: string | null };

export type ReviewerMappingLayerReviewsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReviewerMappingLayerReviewsQuery = { reviewerMappingLayerReviews: Array<{ gameId: string, layer: Types.MappingLayer, type: Types.MappingReviewType, status: Types.MappingLayerReviewStatus, totalCount: number, approvedCount: number, changesRequestedCount: number, respondedCount: number, pendingCount: number, openQueryCount: number, approvedAt: string | null }> };

export type ReviewerToggleMappingCommentReactionMutationVariables = Exact<{
  input: Types.ToggleMappingCommentReactionInput;
}>;


export type ReviewerToggleMappingCommentReactionMutation = { reviewerToggleMappingCommentReaction: { id: string, gameId: string, kind: Types.MappingCommentKind, reviewType: Types.MappingReviewType, locationId: string | null, layer: Types.MappingLayer | null, parentCommentId: string | null, content: string, authorRole: Types.MappingCommentAuthorRole, status: Types.MappingCommentStatus, resolvedAt: string | null, createdAt: string, updatedAt: string, author: { name: string, email: string }, coordinates: { lat: number, lng: number } | null, reactions: Array<{ emoji: string, actors: Array<{ name: string, email: string }> }> | null } };

export type ReviewerUpdateMappingCommentMutationVariables = Exact<{
  input: Types.UpdateMappingCommentInput;
}>;


export type ReviewerUpdateMappingCommentMutation = { reviewerUpdateMappingComment: { id: string, gameId: string, kind: Types.MappingCommentKind, reviewType: Types.MappingReviewType, locationId: string | null, layer: Types.MappingLayer | null, parentCommentId: string | null, content: string, authorRole: Types.MappingCommentAuthorRole, status: Types.MappingCommentStatus, resolvedAt: string | null, createdAt: string, updatedAt: string, author: { name: string, email: string }, coordinates: { lat: number, lng: number } | null, reactions: Array<{ emoji: string, actors: Array<{ name: string, email: string }> }> | null } };

export type ReviewerResolveMappingCommentMutationVariables = Exact<{
  input: Types.ResolveMappingCommentInput;
}>;


export type ReviewerResolveMappingCommentMutation = { reviewerResolveMappingComment: { id: string, gameId: string, kind: Types.MappingCommentKind, reviewType: Types.MappingReviewType, locationId: string | null, layer: Types.MappingLayer | null, parentCommentId: string | null, content: string, authorRole: Types.MappingCommentAuthorRole, status: Types.MappingCommentStatus, resolvedAt: string | null, createdAt: string, updatedAt: string, author: { name: string, email: string }, coordinates: { lat: number, lng: number } | null, reactions: Array<{ emoji: string, actors: Array<{ name: string, email: string }> }> | null } };

export type ReviewerApproveMappingLayerMutationVariables = Exact<{
  input: Types.ApproveMappingLayerInput;
}>;


export type ReviewerApproveMappingLayerMutation = { reviewerApproveMappingLayer: { gameId: string, layer: Types.MappingLayer, type: Types.MappingReviewType, status: Types.MappingLayerReviewStatus, totalCount: number, approvedCount: number, changesRequestedCount: number, respondedCount: number, pendingCount: number, openQueryCount: number, approvedAt: string | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me: { id: string, email: string, fullName: string, adminManagement: boolean, gameCreation: boolean, isSuperAdmin: boolean, globalModulesAccess: boolean, pii: boolean, permissions: { allGames: Array<string>, perGame: unknown } | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const FEventBaseFragmentDoc = new TypedDocumentString(`
    fragment FEventBase on Event {
  id
  description
  points
  startDate
  endDate
  timing {
    startTime
    endTime
  }
  allDay
  weekDay
  allBeatBoxes
}
    `, {"fragmentName":"FEventBase"});
export const FEventDetailsFragmentDoc = new TypedDocumentString(`
    fragment FEventDetails on Event {
  groupIds
}
    `, {"fragmentName":"FEventDetails"});
export const FEventAllFragmentDoc = new TypedDocumentString(`
    fragment FEventAll on Event {
  ...FEventBase
  ...FEventDetails
  customLocationIds
  isVisible
  sanityID
}
    fragment FEventBase on Event {
  id
  description
  points
  startDate
  endDate
  timing {
    startTime
    endTime
  }
  allDay
  weekDay
  allBeatBoxes
}
fragment FEventDetails on Event {
  groupIds
}`, {"fragmentName":"FEventAll"});
export const FGameInfoSurveysFragmentDoc = new TypedDocumentString(`
    fragment FGameInfoSurveys on GameInfo {
  surveys {
    tellUsAboutYou {
      surveyID
      link
      surveyName
      validationStatus
      lastValidated
    }
    closing {
      surveyID
      link
      surveyName
      validationStatus
      lastValidated
      shownFromDate
      isAutoSend
      sendDaysBeforeEnd
    }
    sixMonths {
      surveyID
      link
      surveyName
      validationStatus
      lastValidated
      sendDate
      isAutoSend
    }
    oneYear {
      surveyID
      link
      surveyName
      validationStatus
      lastValidated
      sendDate
      isAutoSend
    }
  }
}
    `, {"fragmentName":"FGameInfoSurveys"});
export const FGameInfoBasicFragmentDoc = new TypedDocumentString(`
    fragment FGameInfoBasic on GameInfo {
  slug
  name
  status
  type
}
    `, {"fragmentName":"FGameInfoBasic"});
export const FGameInfoDatesFragmentDoc = new TypedDocumentString(`
    fragment FGameInfoDates on GameInfo {
  anticipationStartsAt
  teamsStartsAt
  startsAt
  endsAt
  sustainEndsAt
}
    `, {"fragmentName":"FGameInfoDates"});
export const FGameInfoRestFragmentDoc = new TypedDocumentString(`
    fragment FGameInfoRest on GameInfo {
  hideOnLanding
  originalSlug
  boundingBox
  helpWidget
  isMobileGame
  appOnlyGame
  appVariant
  restrictAtDays
  endCountdownDays
}
    `, {"fragmentName":"FGameInfoRest"});
export const FGameInfoSettingsFragmentDoc = new TypedDocumentString(`
    fragment FGameInfoSettings on GameInfo {
  region
  settings {
    minSwipeTime
    timezone
    city
    lat
    lon
    target
    targetZones
    locationDistanceMeters
    beatBoxPlacementValidationEnabled
    POIName
    collectPartnerConsentForAges13To17
    luckyTapEnabled
    luckyTapFrequency
    luckyTapPoints
    mappingApprovalsRequired
    mappingPostRequired
    targetBeatBoxCount
  }
}
    `, {"fragmentName":"FGameInfoSettings"});
export const FGameInfoTargetedEmailsFragmentDoc = new TypedDocumentString(`
    fragment FGameInfoTargetedEmails on GameInfo {
  targetedEmails {
    gameCountdown
    noActivity
    stoppedPlaying
  }
}
    `, {"fragmentName":"FGameInfoTargetedEmails"});
export const FGameInfoFragmentDoc = new TypedDocumentString(`
    fragment FGameInfo on Game {
  info {
    ...FGameInfoBasic
    ...FGameInfoDates
    ...FGameInfoRest
    ...FGameInfoSettings
    ...FGameInfoTargetedEmails
  }
}
    fragment FGameInfoBasic on GameInfo {
  slug
  name
  status
  type
}
fragment FGameInfoDates on GameInfo {
  anticipationStartsAt
  teamsStartsAt
  startsAt
  endsAt
  sustainEndsAt
}
fragment FGameInfoRest on GameInfo {
  hideOnLanding
  originalSlug
  boundingBox
  helpWidget
  isMobileGame
  appOnlyGame
  appVariant
  restrictAtDays
  endCountdownDays
}
fragment FGameInfoSettings on GameInfo {
  region
  settings {
    minSwipeTime
    timezone
    city
    lat
    lon
    target
    targetZones
    locationDistanceMeters
    beatBoxPlacementValidationEnabled
    POIName
    collectPartnerConsentForAges13To17
    luckyTapEnabled
    luckyTapFrequency
    luckyTapPoints
    mappingApprovalsRequired
    mappingPostRequired
    targetBeatBoxCount
  }
}
fragment FGameInfoTargetedEmails on GameInfo {
  targetedEmails {
    gameCountdown
    noActivity
    stoppedPlaying
  }
}`, {"fragmentName":"FGameInfo"});
export const FGameLiveTotalsFragmentDoc = new TypedDocumentString(`
    fragment FGameLiveTotals on Game {
  liveTotals {
    totalMiles
    totalPlayers
    everJoinedPlayers
    registeredPlayers
  }
}
    `, {"fragmentName":"FGameLiveTotals"});
export const FGameTagRangeFragmentDoc = new TypedDocumentString(`
    fragment FGameTagRange on Game {
  tagRanges {
    id
    from
    to
  }
}
    `, {"fragmentName":"FGameTagRange"});
export const FGameTagSubrangeFragmentDoc = new TypedDocumentString(`
    fragment FGameTagSubrange on Game {
  tagSubranges {
    id
    from
    to
    amount
    description
    isApproved
    isLocked
    connectionId
    tagType
    type
  }
}
    `, {"fragmentName":"FGameTagSubrange"});
export const FLocationsBaseFragmentDoc = new TypedDocumentString(`
    fragment FLocationsBase on Location {
  id
  slug
  type
  name
  isBonus
  beatBoxNumber
}
    `, {"fragmentName":"FLocationsBase"});
export const FLocationAllFragmentDoc = new TypedDocumentString(`
    fragment FLocationAll on Location {
  ...FLocationsBase
  lat
  lng
  points
  currentPoints
  status
  gameId
  gemType
  description
  accessible
  what3words
  ownerName
  stats {
    reported
    batteryLevel
    deviceID
  }
}
    fragment FLocationsBase on Location {
  id
  slug
  type
  name
  isBonus
  beatBoxNumber
}`, {"fragmentName":"FLocationAll"});
export const FLocationInfoBasicFragmentDoc = new TypedDocumentString(`
    fragment FLocationInfoBasic on Location {
  id
  type
  slug
  points
  gemType
  beatBoxNumber
  geo {
    isochrone
    nearest
    lamppost
  }
}
    `, {"fragmentName":"FLocationInfoBasic"});
export const FLocationCoordinatesFragmentDoc = new TypedDocumentString(`
    fragment FLocationCoordinates on Location {
  lng
  lat
}
    `, {"fragmentName":"FLocationCoordinates"});
export const FLocationCoreFragmentDoc = new TypedDocumentString(`
    fragment FLocationCore on Location {
  name
  isBonus
  description
  accessible
  what3words
}
    `, {"fragmentName":"FLocationCore"});
export const FLocationStatsFieldsFragmentDoc = new TypedDocumentString(`
    fragment FLocationStatsFields on LocationStats {
  deviceID
  batteryLevel
  reported
}
    `, {"fragmentName":"FLocationStatsFields"});
export const FLocationDetailsFragmentDoc = new TypedDocumentString(`
    fragment FLocationDetails on Location {
  ...FLocationCore
  stats {
    ...FLocationStatsFields
  }
}
    fragment FLocationCore on Location {
  name
  isBonus
  description
  accessible
  what3words
}
fragment FLocationStatsFields on LocationStats {
  deviceID
  batteryLevel
  reported
}`, {"fragmentName":"FLocationDetails"});
export const FLocationDetailsBasicFragmentDoc = new TypedDocumentString(`
    fragment FLocationDetailsBasic on Location {
  name
  isBonus
  description
  accessible
}
    `, {"fragmentName":"FLocationDetailsBasic"});
export const FPlayerPointContextFragmentDoc = new TypedDocumentString(`
    fragment FPlayerPointContext on PlayerPoint {
  all
  routes
  gems
  extra
  mileage
}
    `, {"fragmentName":"FPlayerPointContext"});
export const FPlayerPointFragmentDoc = new TypedDocumentString(`
    fragment FPlayerPoint on Player {
  points {
    ...FPlayerPointContext
  }
}
    fragment FPlayerPointContext on PlayerPoint {
  all
  routes
  gems
  extra
  mileage
}`, {"fragmentName":"FPlayerPoint"});
export const FPlayerProfileContextFragmentDoc = new TypedDocumentString(`
    fragment FPlayerProfileContext on PlayerProfile {
  firstName
  email
  birthDate
  gender
  isRegistered
  ageGroup
}
    `, {"fragmentName":"FPlayerProfileContext"});
export const FPlayerProfileFragmentDoc = new TypedDocumentString(`
    fragment FPlayerProfile on Player {
  profile {
    ...FPlayerProfileContext
  }
}
    fragment FPlayerProfileContext on PlayerProfile {
  firstName
  email
  birthDate
  gender
  isRegistered
  ageGroup
}`, {"fragmentName":"FPlayerProfile"});
export const FPlayerInfoContextFragmentDoc = new TypedDocumentString(`
    fragment FPlayerInfoContext on PlayerInfo {
  gameId
  teamId
  publicName
  avatar
}
    `, {"fragmentName":"FPlayerInfoContext"});
export const FPlayerInfoFragmentDoc = new TypedDocumentString(`
    fragment FPlayerInfo on Player {
  info {
    ...FPlayerInfoContext
  }
}
    fragment FPlayerInfoContext on PlayerInfo {
  gameId
  teamId
  publicName
  avatar
}`, {"fragmentName":"FPlayerInfo"});
export const FPlayerTeamFragmentDoc = new TypedDocumentString(`
    fragment FPlayerTeam on Player {
  team {
    id
    name
  }
}
    `, {"fragmentName":"FPlayerTeam"});
export const FPlayerRoleContextFragmentDoc = new TypedDocumentString(`
    fragment FPlayerRoleContext on PlayerRole {
  isChild
  parentId
  isAnonymous
  authID
  removedAt
}
    `, {"fragmentName":"FPlayerRoleContext"});
export const FPlayerRoleFragmentDoc = new TypedDocumentString(`
    fragment FPlayerRole on Player {
  role {
    ...FPlayerRoleContext
  }
}
    fragment FPlayerRoleContext on PlayerRole {
  isChild
  parentId
  isAnonymous
  authID
  removedAt
}`, {"fragmentName":"FPlayerRole"});
export const FTagGlobalFullFragmentDoc = new TypedDocumentString(`
    fragment FTagGlobalFull on TagGlobalRange {
  id
  name
  status
  type
  supplier
  quantity
  start
  end
  deliveryDate
  createdAt
}
    `, {"fragmentName":"FTagGlobalFull"});
export const FTagSubrangeFragmentDoc = new TypedDocumentString(`
    fragment FTagSubrange on GameTagSubrange {
  id
  from
  to
  amount
  description
  isApproved
  isLocked
  connectionId
  tagType
  createdAt
  type
  distributionPointId
  reassignTeams
  reassignExistingTeams
}
    `, {"fragmentName":"FTagSubrange"});
export const FTeamBasicFragmentDoc = new TypedDocumentString(`
    fragment FTeamBasic on Team {
  id
  name
  type
  status
  leaderboardId
}
    `, {"fragmentName":"FTeamBasic"});
export const FTeamRangesFragmentDoc = new TypedDocumentString(`
    fragment FTeamRanges on Team {
  subranges {
    from
    to
  }
}
    `, {"fragmentName":"FTeamRanges"});
export const FTeamStatsFragmentDoc = new TypedDocumentString(`
    fragment FTeamStats on Team {
  all
  mileage
  totalMembers
  gems
  extra
}
    `, {"fragmentName":"FTeamStats"});
export const FTeamRestFragmentDoc = new TypedDocumentString(`
    fragment FTeamRest on Team {
  gameId
  leaderboardId
  routes
}
    `, {"fragmentName":"FTeamRest"});
export const FTeamDetailsFragmentDoc = new TypedDocumentString(`
    fragment FTeamDetails on Team {
  details {
    description
    rejectionReason
    rollNumber
    leaders
    leadersEmails
  }
}
    `, {"fragmentName":"FTeamDetails"});
export const FTeamFragmentDoc = new TypedDocumentString(`
    fragment FTeam on Team {
  ...FTeamBasic
  ...FTeamRanges
  ...FTeamStats
  ...FTeamRest
  ...FTeamDetails
}
    fragment FTeamBasic on Team {
  id
  name
  type
  status
  leaderboardId
}
fragment FTeamRanges on Team {
  subranges {
    from
    to
  }
}
fragment FTeamStats on Team {
  all
  mileage
  totalMembers
  gems
  extra
}
fragment FTeamDetails on Team {
  details {
    description
    rejectionReason
    rollNumber
    leaders
    leadersEmails
  }
}
fragment FTeamRest on Team {
  gameId
  leaderboardId
  routes
}`, {"fragmentName":"FTeam"});
export const AdminBasicFragmentDoc = new TypedDocumentString(`
    fragment AdminBasic on Admin {
  id
  email
  fullName
  adminManagement
  gameCreation
  isSuperAdmin
  globalModulesAccess
  pii
  enabled
  createdAt
  updatedAt
}
    `, {"fragmentName":"AdminBasic"});
export const AdminMembershipFieldsFragmentDoc = new TypedDocumentString(`
    fragment AdminMembershipFields on AdminMembership {
  adminId
  gameId
  roles
  roleDetails {
    id
    name
    description
    permissions
    isSystem
    createdAt
    updatedAt
  }
  createdAt
  updatedAt
}
    `, {"fragmentName":"AdminMembershipFields"});
export const FMapDatasetFragmentDoc = new TypedDocumentString(`
    fragment FMapDataset on MapDataset {
  id
  name
  description
  category
  geometryType
  featureCount
  bbox
  featuresUrl
  version
  updatedAt
  updatedBy
  source {
    kind
    filename
    serviceUrl
    attribution
  }
  defaultStyle {
    color
    lineWidth
    opacity
  }
}
    `, {"fragmentName":"FMapDataset"});
export const MappingLayerReviewFieldsFragmentDoc = new TypedDocumentString(`
    fragment MappingLayerReviewFields on MappingLayerReview {
  gameId
  layer
  type
  status
  totalCount
  locationCount
  approvedCount
  changesRequestedCount
  respondedCount
  pendingCount
  openQueryCount
  approvedAt
}
    `, {"fragmentName":"MappingLayerReviewFields"});
export const MappingRoundFieldsFragmentDoc = new TypedDocumentString(`
    fragment MappingRoundFields on MappingRound {
  type
  locationIds
  openedAt
  openedBy {
    name
    email
  }
  passedAt
  passedBy {
    name
    email
  }
}
    `, {"fragmentName":"MappingRoundFields"});
export const FAnswerFragmentDoc = new TypedDocumentString(`
    fragment FAnswer on ValidateAnswers {
  days {
    status
    errors
  }
  minutes {
    status
    errors
  }
  hours {
    status
    errors
  }
  flag {
    status
    errors
  }
}
    `, {"fragmentName":"FAnswer"});
export const FQuestionFragmentDoc = new TypedDocumentString(`
    fragment FQuestion on ValidateQuestions {
  days {
    status
    message
  }
  minutes {
    status
    message
  }
  hours {
    status
    message
  }
  flag {
    status
    message
  }
}
    `, {"fragmentName":"FQuestion"});
export const MappingLocationFieldsFragmentDoc = new TypedDocumentString(`
    fragment MappingLocationFields on MappingLocation {
  id
  gameId
  name
  description
  mappingNotes
  type
  gemType
  points
  beatBoxNumber
  accessible
  isBonus
  ownerName
  slug
  what3words
  publishedAt
  selectedCandidateId
  coordinates {
    lat
    lng
  }
  candidates {
    id
    lat
    lng
    note
  }
  geo {
    isochrone
    lamppost
    nearest
  }
  reviewStatus
  createdAt
  updatedAt
}
    `, {"fragmentName":"MappingLocationFields"});
export const MappingGroupFieldsFragmentDoc = new TypedDocumentString(`
    fragment MappingGroupFields on Group {
  id
  gameId
  name
  description
  color
}
    `, {"fragmentName":"MappingGroupFields"});
export const MappingGroupElementFieldsFragmentDoc = new TypedDocumentString(`
    fragment MappingGroupElementFields on GroupElement {
  gameId
  groupId
  locationId
}
    `, {"fragmentName":"MappingGroupElementFields"});
export const MappingReviewFieldsFragmentDoc = new TypedDocumentString(`
    fragment MappingReviewFields on MappingReview {
  id
  gameId
  locationId
  type
  status
  approvedAt
  riskAssessment
  createdAt
  updatedAt
}
    `, {"fragmentName":"MappingReviewFields"});
export const MappingCommentFieldsFragmentDoc = new TypedDocumentString(`
    fragment MappingCommentFields on MappingComment {
  id
  gameId
  kind
  reviewType
  locationId
  layer
  parentCommentId
  content
  author {
    name
    email
  }
  authorRole
  coordinates {
    lat
    lng
  }
  reactions {
    emoji
    actors {
      name
      email
    }
  }
  status
  resolvedAt
  createdAt
  updatedAt
}
    `, {"fragmentName":"MappingCommentFields"});
export const MappingReviewerFieldsFragmentDoc = new TypedDocumentString(`
    fragment MappingReviewerFields on MappingReviewer {
  id
  gameId
  allowedReviewType
  name
  email
  token
  expiresAt
  createdAt
  updatedAt
}
    `, {"fragmentName":"MappingReviewerFields"});
export const MappingHistoryFieldsFragmentDoc = new TypedDocumentString(`
    fragment MappingHistoryFields on MappingHistory {
  id
  gameId
  locationId
  action
  actor {
    name
    email
  }
  metadata
  createdAt
  updatedAt
}
    `, {"fragmentName":"MappingHistoryFields"});
export const SearchPlayerFragmentDoc = new TypedDocumentString(`
    fragment SearchPlayer on Player {
  id
  profile {
    ...FPlayerProfileContext
    fullName
  }
  info {
    publicName
    gameId
  }
  role {
    isAnonymous
  }
  tags {
    tagNumber
    tagType
  }
}
    fragment FPlayerProfileContext on PlayerProfile {
  firstName
  email
  birthDate
  gender
  isRegistered
  ageGroup
}`, {"fragmentName":"SearchPlayer"});
export const ReviewerMappingLocationFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReviewerMappingLocationFields on MappingLocation {
  id
  gameId
  name
  slug
  beatBoxNumber
  accessible
  gemType
  description
  mappingNotes
  type
  isMobile
  reviewStatus
  selectedCandidateId
  coordinates {
    lat
    lng
  }
  candidates {
    id
    lat
    lng
    note
  }
  what3words
  geo {
    lamppost
  }
  createdAt
  updatedAt
}
    `, {"fragmentName":"ReviewerMappingLocationFields"});
export const ReviewerMappingReviewFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReviewerMappingReviewFields on MappingReview {
  id
  gameId
  locationId
  type
  status
  approvedAt
  createdAt
  updatedAt
}
    `, {"fragmentName":"ReviewerMappingReviewFields"});
export const ReviewerMappingCommentFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReviewerMappingCommentFields on MappingComment {
  id
  gameId
  kind
  reviewType
  locationId
  layer
  parentCommentId
  content
  author {
    name
    email
  }
  authorRole
  coordinates {
    lat
    lng
  }
  reactions {
    emoji
    actors {
      name
      email
    }
  }
  status
  resolvedAt
  createdAt
  updatedAt
}
    `, {"fragmentName":"ReviewerMappingCommentFields"});
export const ReviewerMappingHistoryFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReviewerMappingHistoryFields on MappingHistory {
  id
  gameId
  locationId
  action
  actor {
    name
    email
  }
  metadata
  createdAt
  updatedAt
}
    `, {"fragmentName":"ReviewerMappingHistoryFields"});
export const ReviewerMappingLayerReviewFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReviewerMappingLayerReviewFields on MappingLayerReview {
  gameId
  layer
  type
  status
  totalCount
  approvedCount
  changesRequestedCount
  respondedCount
  pendingCount
  openQueryCount
  approvedAt
}
    `, {"fragmentName":"ReviewerMappingLayerReviewFields"});
export const GetGameBySlugDocument = new TypedDocumentString(`
    query GetGameBySlug($slug: String!) {
  getGameBySlug(slug: $slug) {
    id
    info {
      ...FGameInfoBasic
    }
  }
}
    fragment FGameInfoBasic on GameInfo {
  slug
  name
  status
  type
}`);

export const useGetGameBySlugQuery = <
      TData = GetGameBySlugQuery,
      TError = unknown
    >(
      variables: GetGameBySlugQueryVariables,
      options?: UseQueryOptions<GetGameBySlugQuery, TError, TData>
    ) => {
    
    return useQuery<GetGameBySlugQuery, TError, TData>(
      ['GetGameBySlug', variables],
      fetchGenerated<GetGameBySlugQuery, GetGameBySlugQueryVariables>(GetGameBySlugDocument, variables),
      options
    )};

export const GetGameDetailsBySlugDocument = new TypedDocumentString(`
    query GetGameDetailsBySlug($slug: String!) {
  getGameBySlug(slug: $slug) {
    id
    ...FGameInfo
    ...FGameLiveTotals
  }
}
    fragment FGameInfoBasic on GameInfo {
  slug
  name
  status
  type
}
fragment FGameInfoDates on GameInfo {
  anticipationStartsAt
  teamsStartsAt
  startsAt
  endsAt
  sustainEndsAt
}
fragment FGameInfoRest on GameInfo {
  hideOnLanding
  originalSlug
  boundingBox
  helpWidget
  isMobileGame
  appOnlyGame
  appVariant
  restrictAtDays
  endCountdownDays
}
fragment FGameInfoSettings on GameInfo {
  region
  settings {
    minSwipeTime
    timezone
    city
    lat
    lon
    target
    targetZones
    locationDistanceMeters
    beatBoxPlacementValidationEnabled
    POIName
    collectPartnerConsentForAges13To17
    luckyTapEnabled
    luckyTapFrequency
    luckyTapPoints
    mappingApprovalsRequired
    mappingPostRequired
    targetBeatBoxCount
  }
}
fragment FGameInfoTargetedEmails on GameInfo {
  targetedEmails {
    gameCountdown
    noActivity
    stoppedPlaying
  }
}
fragment FGameInfo on Game {
  info {
    ...FGameInfoBasic
    ...FGameInfoDates
    ...FGameInfoRest
    ...FGameInfoSettings
    ...FGameInfoTargetedEmails
  }
}
fragment FGameLiveTotals on Game {
  liveTotals {
    totalMiles
    totalPlayers
    everJoinedPlayers
    registeredPlayers
  }
}`);

export const useGetGameDetailsBySlugQuery = <
      TData = GetGameDetailsBySlugQuery,
      TError = unknown
    >(
      variables: GetGameDetailsBySlugQueryVariables,
      options?: UseQueryOptions<GetGameDetailsBySlugQuery, TError, TData>
    ) => {
    
    return useQuery<GetGameDetailsBySlugQuery, TError, TData>(
      ['GetGameDetailsBySlug', variables],
      fetchGenerated<GetGameDetailsBySlugQuery, GetGameDetailsBySlugQueryVariables>(GetGameDetailsBySlugDocument, variables),
      options
    )};

export const ListGamesInfoDocument = new TypedDocumentString(`
    query ListGamesInfo {
  listGames {
    id
    ...FGameInfo
    liveTotals {
      totalPlayers
      everJoinedPlayers
      totalMiles
    }
  }
}
    fragment FGameInfoBasic on GameInfo {
  slug
  name
  status
  type
}
fragment FGameInfoDates on GameInfo {
  anticipationStartsAt
  teamsStartsAt
  startsAt
  endsAt
  sustainEndsAt
}
fragment FGameInfoRest on GameInfo {
  hideOnLanding
  originalSlug
  boundingBox
  helpWidget
  isMobileGame
  appOnlyGame
  appVariant
  restrictAtDays
  endCountdownDays
}
fragment FGameInfoSettings on GameInfo {
  region
  settings {
    minSwipeTime
    timezone
    city
    lat
    lon
    target
    targetZones
    locationDistanceMeters
    beatBoxPlacementValidationEnabled
    POIName
    collectPartnerConsentForAges13To17
    luckyTapEnabled
    luckyTapFrequency
    luckyTapPoints
    mappingApprovalsRequired
    mappingPostRequired
    targetBeatBoxCount
  }
}
fragment FGameInfoTargetedEmails on GameInfo {
  targetedEmails {
    gameCountdown
    noActivity
    stoppedPlaying
  }
}
fragment FGameInfo on Game {
  info {
    ...FGameInfoBasic
    ...FGameInfoDates
    ...FGameInfoRest
    ...FGameInfoSettings
    ...FGameInfoTargetedEmails
  }
}`);

export const useListGamesInfoQuery = <
      TData = ListGamesInfoQuery,
      TError = unknown
    >(
      variables?: ListGamesInfoQueryVariables,
      options?: UseQueryOptions<ListGamesInfoQuery, TError, TData>
    ) => {
    
    return useQuery<ListGamesInfoQuery, TError, TData>(
      variables === undefined ? ['ListGamesInfo'] : ['ListGamesInfo', variables],
      fetchGenerated<ListGamesInfoQuery, ListGamesInfoQueryVariables>(ListGamesInfoDocument, variables),
      options
    )};

export const GetPlayerDocument = new TypedDocumentString(`
    query GetPlayer($id: String!) {
  getPlayer(id: $id) {
    id
    emailVerified
    tags {
      id
      tagNumber
      tagType
    }
    profile {
      ...FPlayerProfileContext
      postCode
    }
    ...FPlayerTeam
    ...FPlayerInfo
    ...FPlayerPoint
    ...FPlayerRole
  }
}
    fragment FPlayerPointContext on PlayerPoint {
  all
  routes
  gems
  extra
  mileage
}
fragment FPlayerPoint on Player {
  points {
    ...FPlayerPointContext
  }
}
fragment FPlayerProfileContext on PlayerProfile {
  firstName
  email
  birthDate
  gender
  isRegistered
  ageGroup
}
fragment FPlayerInfoContext on PlayerInfo {
  gameId
  teamId
  publicName
  avatar
}
fragment FPlayerInfo on Player {
  info {
    ...FPlayerInfoContext
  }
}
fragment FPlayerTeam on Player {
  team {
    id
    name
  }
}
fragment FPlayerRoleContext on PlayerRole {
  isChild
  parentId
  isAnonymous
  authID
  removedAt
}
fragment FPlayerRole on Player {
  role {
    ...FPlayerRoleContext
  }
}`);

export const useGetPlayerQuery = <
      TData = GetPlayerQuery,
      TError = unknown
    >(
      variables: GetPlayerQueryVariables,
      options?: UseQueryOptions<GetPlayerQuery, TError, TData>
    ) => {
    
    return useQuery<GetPlayerQuery, TError, TData>(
      ['GetPlayer', variables],
      fetchGenerated<GetPlayerQuery, GetPlayerQueryVariables>(GetPlayerDocument, variables),
      options
    )};

export const FindFamilyPlayersDocument = new TypedDocumentString(`
    query FindFamilyPlayers($input: FindFamilyPlayersInput!) {
  findFamilyPlayers(input: $input) {
    id
    info {
      publicName
    }
    role {
      isChild
    }
  }
}
    `);

export const useFindFamilyPlayersQuery = <
      TData = FindFamilyPlayersQuery,
      TError = unknown
    >(
      variables: FindFamilyPlayersQueryVariables,
      options?: UseQueryOptions<FindFamilyPlayersQuery, TError, TData>
    ) => {
    
    return useQuery<FindFamilyPlayersQuery, TError, TData>(
      ['FindFamilyPlayers', variables],
      fetchGenerated<FindFamilyPlayersQuery, FindFamilyPlayersQueryVariables>(FindFamilyPlayersDocument, variables),
      options
    )};

export const ListAdminsDocument = new TypedDocumentString(`
    query ListAdmins {
  listAdmins {
    id
    email
    fullName
    adminManagement
    gameCreation
    isSuperAdmin
    globalModulesAccess
    pii
    memberships {
      adminId
      gameId
    }
  }
}
    `);

export const useListAdminsQuery = <
      TData = ListAdminsQuery,
      TError = unknown
    >(
      variables?: ListAdminsQueryVariables,
      options?: UseQueryOptions<ListAdminsQuery, TError, TData>
    ) => {
    
    return useQuery<ListAdminsQuery, TError, TData>(
      variables === undefined ? ['ListAdmins'] : ['ListAdmins', variables],
      fetchGenerated<ListAdminsQuery, ListAdminsQueryVariables>(ListAdminsDocument, variables),
      options
    )};

export const GetAdminDocument = new TypedDocumentString(`
    query GetAdmin($id: String!) {
  getAdmin(id: $id) {
    ...AdminBasic
    memberships {
      ...AdminMembershipFields
    }
    permissions {
      allGames
      perGame
    }
    roles {
      id
      name
      description
      permissions
      isSystem
      createdAt
      updatedAt
    }
  }
}
    fragment AdminBasic on Admin {
  id
  email
  fullName
  adminManagement
  gameCreation
  isSuperAdmin
  globalModulesAccess
  pii
  enabled
  createdAt
  updatedAt
}
fragment AdminMembershipFields on AdminMembership {
  adminId
  gameId
  roles
  roleDetails {
    id
    name
    description
    permissions
    isSystem
    createdAt
    updatedAt
  }
  createdAt
  updatedAt
}`);

export const useGetAdminQuery = <
      TData = GetAdminQuery,
      TError = unknown
    >(
      variables: GetAdminQueryVariables,
      options?: UseQueryOptions<GetAdminQuery, TError, TData>
    ) => {
    
    return useQuery<GetAdminQuery, TError, TData>(
      ['GetAdmin', variables],
      fetchGenerated<GetAdminQuery, GetAdminQueryVariables>(GetAdminDocument, variables),
      options
    )};

export const UpdateAdminDocument = new TypedDocumentString(`
    mutation UpdateAdmin($input: UpdateAdminInput!) {
  updateAdmin(input: $input) {
    ...AdminBasic
  }
}
    fragment AdminBasic on Admin {
  id
  email
  fullName
  adminManagement
  gameCreation
  isSuperAdmin
  globalModulesAccess
  pii
  enabled
  createdAt
  updatedAt
}`);

export const useUpdateAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAdminMutation, TError, UpdateAdminMutationVariables, TContext>) => {
    
    return useMutation<UpdateAdminMutation, TError, UpdateAdminMutationVariables, TContext>(
      ['UpdateAdmin'],
      (variables?: UpdateAdminMutationVariables) => fetchGenerated<UpdateAdminMutation, UpdateAdminMutationVariables>(UpdateAdminDocument, variables)(),
      options
    )};

export const CreateAdminDocument = new TypedDocumentString(`
    mutation CreateAdmin($input: CreateAdminInput!) {
  createAdmin(input: $input) {
    ...AdminBasic
  }
}
    fragment AdminBasic on Admin {
  id
  email
  fullName
  adminManagement
  gameCreation
  isSuperAdmin
  globalModulesAccess
  pii
  enabled
  createdAt
  updatedAt
}`);

export const useCreateAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateAdminMutation, TError, CreateAdminMutationVariables, TContext>) => {
    
    return useMutation<CreateAdminMutation, TError, CreateAdminMutationVariables, TContext>(
      ['CreateAdmin'],
      (variables?: CreateAdminMutationVariables) => fetchGenerated<CreateAdminMutation, CreateAdminMutationVariables>(CreateAdminDocument, variables)(),
      options
    )};

export const DeleteAdminDocument = new TypedDocumentString(`
    mutation DeleteAdmin($id: String!) {
  deleteAdmin(id: $id)
}
    `);

export const useDeleteAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteAdminMutation, TError, DeleteAdminMutationVariables, TContext>) => {
    
    return useMutation<DeleteAdminMutation, TError, DeleteAdminMutationVariables, TContext>(
      ['DeleteAdmin'],
      (variables?: DeleteAdminMutationVariables) => fetchGenerated<DeleteAdminMutation, DeleteAdminMutationVariables>(DeleteAdminDocument, variables)(),
      options
    )};

export const ChangeAdminPasswordDocument = new TypedDocumentString(`
    mutation ChangeAdminPassword($input: ChangeAdminPasswordInput!) {
  changeAdminPassword(input: $input)
}
    `);

export const useChangeAdminPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeAdminPasswordMutation, TError, ChangeAdminPasswordMutationVariables, TContext>) => {
    
    return useMutation<ChangeAdminPasswordMutation, TError, ChangeAdminPasswordMutationVariables, TContext>(
      ['ChangeAdminPassword'],
      (variables?: ChangeAdminPasswordMutationVariables) => fetchGenerated<ChangeAdminPasswordMutation, ChangeAdminPasswordMutationVariables>(ChangeAdminPasswordDocument, variables)(),
      options
    )};

export const ChangeMyPasswordDocument = new TypedDocumentString(`
    mutation ChangeMyPassword($password: String!) {
  changeMyPassword(password: $password)
}
    `);

export const useChangeMyPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeMyPasswordMutation, TError, ChangeMyPasswordMutationVariables, TContext>) => {
    
    return useMutation<ChangeMyPasswordMutation, TError, ChangeMyPasswordMutationVariables, TContext>(
      ['ChangeMyPassword'],
      (variables?: ChangeMyPasswordMutationVariables) => fetchGenerated<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>(ChangeMyPasswordDocument, variables)(),
      options
    )};

export const UpdateMyProfileDocument = new TypedDocumentString(`
    mutation UpdateMyProfile($fullName: String!) {
  updateMyProfile(fullName: $fullName) {
    ...AdminBasic
  }
}
    fragment AdminBasic on Admin {
  id
  email
  fullName
  adminManagement
  gameCreation
  isSuperAdmin
  globalModulesAccess
  pii
  enabled
  createdAt
  updatedAt
}`);

export const useUpdateMyProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMyProfileMutation, TError, UpdateMyProfileMutationVariables, TContext>) => {
    
    return useMutation<UpdateMyProfileMutation, TError, UpdateMyProfileMutationVariables, TContext>(
      ['UpdateMyProfile'],
      (variables?: UpdateMyProfileMutationVariables) => fetchGenerated<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>(UpdateMyProfileDocument, variables)(),
      options
    )};

export const CreateMembershipDocument = new TypedDocumentString(`
    mutation CreateMembership($input: CreateMembershipInput!) {
  createMembership(input: $input) {
    ...AdminMembershipFields
  }
}
    fragment AdminMembershipFields on AdminMembership {
  adminId
  gameId
  roles
  roleDetails {
    id
    name
    description
    permissions
    isSystem
    createdAt
    updatedAt
  }
  createdAt
  updatedAt
}`);

export const useCreateMembershipMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMembershipMutation, TError, CreateMembershipMutationVariables, TContext>) => {
    
    return useMutation<CreateMembershipMutation, TError, CreateMembershipMutationVariables, TContext>(
      ['CreateMembership'],
      (variables?: CreateMembershipMutationVariables) => fetchGenerated<CreateMembershipMutation, CreateMembershipMutationVariables>(CreateMembershipDocument, variables)(),
      options
    )};

export const UpdateMembershipDocument = new TypedDocumentString(`
    mutation UpdateMembership($input: UpdateMembershipInput!) {
  updateMembership(input: $input) {
    ...AdminMembershipFields
  }
}
    fragment AdminMembershipFields on AdminMembership {
  adminId
  gameId
  roles
  roleDetails {
    id
    name
    description
    permissions
    isSystem
    createdAt
    updatedAt
  }
  createdAt
  updatedAt
}`);

export const useUpdateMembershipMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMembershipMutation, TError, UpdateMembershipMutationVariables, TContext>) => {
    
    return useMutation<UpdateMembershipMutation, TError, UpdateMembershipMutationVariables, TContext>(
      ['UpdateMembership'],
      (variables?: UpdateMembershipMutationVariables) => fetchGenerated<UpdateMembershipMutation, UpdateMembershipMutationVariables>(UpdateMembershipDocument, variables)(),
      options
    )};

export const DeleteMembershipDocument = new TypedDocumentString(`
    mutation DeleteMembership($input: DeleteMembershipInput!) {
  deleteMembership(input: $input)
}
    `);

export const useDeleteMembershipMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMembershipMutation, TError, DeleteMembershipMutationVariables, TContext>) => {
    
    return useMutation<DeleteMembershipMutation, TError, DeleteMembershipMutationVariables, TContext>(
      ['DeleteMembership'],
      (variables?: DeleteMembershipMutationVariables) => fetchGenerated<DeleteMembershipMutation, DeleteMembershipMutationVariables>(DeleteMembershipDocument, variables)(),
      options
    )};

export const ListRolesDocument = new TypedDocumentString(`
    query ListRoles {
  listRoles {
    id
    name
    description
    permissions
    isSystem
    createdAt
    updatedAt
  }
}
    `);

export const useListRolesQuery = <
      TData = ListRolesQuery,
      TError = unknown
    >(
      variables?: ListRolesQueryVariables,
      options?: UseQueryOptions<ListRolesQuery, TError, TData>
    ) => {
    
    return useQuery<ListRolesQuery, TError, TData>(
      variables === undefined ? ['ListRoles'] : ['ListRoles', variables],
      fetchGenerated<ListRolesQuery, ListRolesQueryVariables>(ListRolesDocument, variables),
      options
    )};

export const CreateRoleDocument = new TypedDocumentString(`
    mutation CreateRole($input: CreateAdminRoleInput!) {
  createRole(input: $input) {
    id
    name
    description
    permissions
    isSystem
    createdAt
    updatedAt
  }
}
    `);

export const useCreateRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateRoleMutation, TError, CreateRoleMutationVariables, TContext>) => {
    
    return useMutation<CreateRoleMutation, TError, CreateRoleMutationVariables, TContext>(
      ['CreateRole'],
      (variables?: CreateRoleMutationVariables) => fetchGenerated<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, variables)(),
      options
    )};

export const UpdateRoleDocument = new TypedDocumentString(`
    mutation UpdateRole($input: UpdateAdminRoleInput!) {
  updateRole(input: $input) {
    id
    name
    description
    permissions
    isSystem
    createdAt
    updatedAt
  }
}
    `);

export const useUpdateRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateRoleMutation, TError, UpdateRoleMutationVariables, TContext>) => {
    
    return useMutation<UpdateRoleMutation, TError, UpdateRoleMutationVariables, TContext>(
      ['UpdateRole'],
      (variables?: UpdateRoleMutationVariables) => fetchGenerated<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, variables)(),
      options
    )};

export const DeleteRoleDocument = new TypedDocumentString(`
    mutation DeleteRole($id: String!) {
  deleteRole(id: $id)
}
    `);

export const useDeleteRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteRoleMutation, TError, DeleteRoleMutationVariables, TContext>) => {
    
    return useMutation<DeleteRoleMutation, TError, DeleteRoleMutationVariables, TContext>(
      ['DeleteRole'],
      (variables?: DeleteRoleMutationVariables) => fetchGenerated<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, variables)(),
      options
    )};

export const CreateCardOrderDocument = new TypedDocumentString(`
    mutation CreateCardOrder($input: TagGlobalRangeCreateInput!) {
  createTagGlobal(input: $input) {
    id
  }
}
    `);

export const useCreateCardOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCardOrderMutation, TError, CreateCardOrderMutationVariables, TContext>) => {
    
    return useMutation<CreateCardOrderMutation, TError, CreateCardOrderMutationVariables, TContext>(
      ['CreateCardOrder'],
      (variables?: CreateCardOrderMutationVariables) => fetchGenerated<CreateCardOrderMutation, CreateCardOrderMutationVariables>(CreateCardOrderDocument, variables)(),
      options
    )};

export const UpdateCardOrderDocument = new TypedDocumentString(`
    mutation UpdateCardOrder($input: TagGlobalRangeUpdateInput!) {
  updateTagGlobal(input: $input) {
    id
  }
}
    `);

export const useUpdateCardOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCardOrderMutation, TError, UpdateCardOrderMutationVariables, TContext>) => {
    
    return useMutation<UpdateCardOrderMutation, TError, UpdateCardOrderMutationVariables, TContext>(
      ['UpdateCardOrder'],
      (variables?: UpdateCardOrderMutationVariables) => fetchGenerated<UpdateCardOrderMutation, UpdateCardOrderMutationVariables>(UpdateCardOrderDocument, variables)(),
      options
    )};

export const DeleteCardOrderDocument = new TypedDocumentString(`
    mutation DeleteCardOrder($id: String!) {
  deleteTagGlobal(id: $id)
}
    `);

export const useDeleteCardOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCardOrderMutation, TError, DeleteCardOrderMutationVariables, TContext>) => {
    
    return useMutation<DeleteCardOrderMutation, TError, DeleteCardOrderMutationVariables, TContext>(
      ['DeleteCardOrder'],
      (variables?: DeleteCardOrderMutationVariables) => fetchGenerated<DeleteCardOrderMutation, DeleteCardOrderMutationVariables>(DeleteCardOrderDocument, variables)(),
      options
    )};

export const FindCardOrdersDocument = new TypedDocumentString(`
    query FindCardOrders {
  findTagGlobal {
    ...FTagGlobalFull
  }
}
    fragment FTagGlobalFull on TagGlobalRange {
  id
  name
  status
  type
  supplier
  quantity
  start
  end
  deliveryDate
  createdAt
}`);

export const useFindCardOrdersQuery = <
      TData = FindCardOrdersQuery,
      TError = unknown
    >(
      variables?: FindCardOrdersQueryVariables,
      options?: UseQueryOptions<FindCardOrdersQuery, TError, TData>
    ) => {
    
    return useQuery<FindCardOrdersQuery, TError, TData>(
      variables === undefined ? ['FindCardOrders'] : ['FindCardOrders', variables],
      fetchGenerated<FindCardOrdersQuery, FindCardOrdersQueryVariables>(FindCardOrdersDocument, variables),
      options
    )};

export const GetCardOrderDocument = new TypedDocumentString(`
    query GetCardOrder($id: String!) {
  getTagGlobal(id: $id) {
    ...FTagGlobalFull
  }
}
    fragment FTagGlobalFull on TagGlobalRange {
  id
  name
  status
  type
  supplier
  quantity
  start
  end
  deliveryDate
  createdAt
}`);

export const useGetCardOrderQuery = <
      TData = GetCardOrderQuery,
      TError = unknown
    >(
      variables: GetCardOrderQueryVariables,
      options?: UseQueryOptions<GetCardOrderQuery, TError, TData>
    ) => {
    
    return useQuery<GetCardOrderQuery, TError, TData>(
      ['GetCardOrder', variables],
      fetchGenerated<GetCardOrderQuery, GetCardOrderQueryVariables>(GetCardOrderDocument, variables),
      options
    )};

export const MapDatasetsDocument = new TypedDocumentString(`
    query MapDatasets {
  mapDatasets {
    ...FMapDataset
  }
}
    fragment FMapDataset on MapDataset {
  id
  name
  description
  category
  geometryType
  featureCount
  bbox
  featuresUrl
  version
  updatedAt
  updatedBy
  source {
    kind
    filename
    serviceUrl
    attribution
  }
  defaultStyle {
    color
    lineWidth
    opacity
  }
}`);

export const useMapDatasetsQuery = <
      TData = MapDatasetsQuery,
      TError = unknown
    >(
      variables?: MapDatasetsQueryVariables,
      options?: UseQueryOptions<MapDatasetsQuery, TError, TData>
    ) => {
    
    return useQuery<MapDatasetsQuery, TError, TData>(
      variables === undefined ? ['MapDatasets'] : ['MapDatasets', variables],
      fetchGenerated<MapDatasetsQuery, MapDatasetsQueryVariables>(MapDatasetsDocument, variables),
      options
    )};

export const MapDatasetDocument = new TypedDocumentString(`
    query MapDataset($id: String!) {
  mapDataset(id: $id) {
    ...FMapDataset
  }
}
    fragment FMapDataset on MapDataset {
  id
  name
  description
  category
  geometryType
  featureCount
  bbox
  featuresUrl
  version
  updatedAt
  updatedBy
  source {
    kind
    filename
    serviceUrl
    attribution
  }
  defaultStyle {
    color
    lineWidth
    opacity
  }
}`);

export const useMapDatasetQuery = <
      TData = MapDatasetQuery,
      TError = unknown
    >(
      variables: MapDatasetQueryVariables,
      options?: UseQueryOptions<MapDatasetQuery, TError, TData>
    ) => {
    
    return useQuery<MapDatasetQuery, TError, TData>(
      ['MapDataset', variables],
      fetchGenerated<MapDatasetQuery, MapDatasetQueryVariables>(MapDatasetDocument, variables),
      options
    )};

export const MapDatasetUploadUrlDocument = new TypedDocumentString(`
    mutation MapDatasetUploadUrl($input: MapDatasetUploadTargetInput!) {
  mapDatasetUploadUrl(input: $input) {
    uploadUrl
    stagingKey
  }
}
    `);

export const useMapDatasetUploadUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MapDatasetUploadUrlMutation, TError, MapDatasetUploadUrlMutationVariables, TContext>) => {
    
    return useMutation<MapDatasetUploadUrlMutation, TError, MapDatasetUploadUrlMutationVariables, TContext>(
      ['MapDatasetUploadUrl'],
      (variables?: MapDatasetUploadUrlMutationVariables) => fetchGenerated<MapDatasetUploadUrlMutation, MapDatasetUploadUrlMutationVariables>(MapDatasetUploadUrlDocument, variables)(),
      options
    )};

export const ImportMapDatasetDocument = new TypedDocumentString(`
    mutation ImportMapDataset($input: ImportMapDatasetInput!) {
  importMapDataset(input: $input) {
    ...FMapDataset
  }
}
    fragment FMapDataset on MapDataset {
  id
  name
  description
  category
  geometryType
  featureCount
  bbox
  featuresUrl
  version
  updatedAt
  updatedBy
  source {
    kind
    filename
    serviceUrl
    attribution
  }
  defaultStyle {
    color
    lineWidth
    opacity
  }
}`);

export const useImportMapDatasetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportMapDatasetMutation, TError, ImportMapDatasetMutationVariables, TContext>) => {
    
    return useMutation<ImportMapDatasetMutation, TError, ImportMapDatasetMutationVariables, TContext>(
      ['ImportMapDataset'],
      (variables?: ImportMapDatasetMutationVariables) => fetchGenerated<ImportMapDatasetMutation, ImportMapDatasetMutationVariables>(ImportMapDatasetDocument, variables)(),
      options
    )};

export const RefreshMapDatasetDocument = new TypedDocumentString(`
    mutation RefreshMapDataset($id: String!) {
  refreshMapDataset(id: $id) {
    ...FMapDataset
  }
}
    fragment FMapDataset on MapDataset {
  id
  name
  description
  category
  geometryType
  featureCount
  bbox
  featuresUrl
  version
  updatedAt
  updatedBy
  source {
    kind
    filename
    serviceUrl
    attribution
  }
  defaultStyle {
    color
    lineWidth
    opacity
  }
}`);

export const useRefreshMapDatasetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RefreshMapDatasetMutation, TError, RefreshMapDatasetMutationVariables, TContext>) => {
    
    return useMutation<RefreshMapDatasetMutation, TError, RefreshMapDatasetMutationVariables, TContext>(
      ['RefreshMapDataset'],
      (variables?: RefreshMapDatasetMutationVariables) => fetchGenerated<RefreshMapDatasetMutation, RefreshMapDatasetMutationVariables>(RefreshMapDatasetDocument, variables)(),
      options
    )};

export const UpdateMapDatasetDocument = new TypedDocumentString(`
    mutation UpdateMapDataset($input: UpdateMapDatasetInput!) {
  updateMapDataset(input: $input) {
    ...FMapDataset
  }
}
    fragment FMapDataset on MapDataset {
  id
  name
  description
  category
  geometryType
  featureCount
  bbox
  featuresUrl
  version
  updatedAt
  updatedBy
  source {
    kind
    filename
    serviceUrl
    attribution
  }
  defaultStyle {
    color
    lineWidth
    opacity
  }
}`);

export const useUpdateMapDatasetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMapDatasetMutation, TError, UpdateMapDatasetMutationVariables, TContext>) => {
    
    return useMutation<UpdateMapDatasetMutation, TError, UpdateMapDatasetMutationVariables, TContext>(
      ['UpdateMapDataset'],
      (variables?: UpdateMapDatasetMutationVariables) => fetchGenerated<UpdateMapDatasetMutation, UpdateMapDatasetMutationVariables>(UpdateMapDatasetDocument, variables)(),
      options
    )};

export const DeleteMapDatasetDocument = new TypedDocumentString(`
    mutation DeleteMapDataset($id: String!) {
  deleteMapDataset(id: $id)
}
    `);

export const useDeleteMapDatasetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMapDatasetMutation, TError, DeleteMapDatasetMutationVariables, TContext>) => {
    
    return useMutation<DeleteMapDatasetMutation, TError, DeleteMapDatasetMutationVariables, TContext>(
      ['DeleteMapDataset'],
      (variables?: DeleteMapDatasetMutationVariables) => fetchGenerated<DeleteMapDatasetMutation, DeleteMapDatasetMutationVariables>(DeleteMapDatasetDocument, variables)(),
      options
    )};

export const GetTagSubrangeDocument = new TypedDocumentString(`
    query GetTagSubrange($id: String!, $gameId: String!) {
  getTagSubrange(gameId: $gameId, id: $id) {
    ...FTagSubrange
  }
}
    fragment FTagSubrange on GameTagSubrange {
  id
  from
  to
  amount
  description
  isApproved
  isLocked
  connectionId
  tagType
  createdAt
  type
  distributionPointId
  reassignTeams
  reassignExistingTeams
}`);

export const useGetTagSubrangeQuery = <
      TData = GetTagSubrangeQuery,
      TError = unknown
    >(
      variables: GetTagSubrangeQueryVariables,
      options?: UseQueryOptions<GetTagSubrangeQuery, TError, TData>
    ) => {
    
    return useQuery<GetTagSubrangeQuery, TError, TData>(
      ['GetTagSubrange', variables],
      fetchGenerated<GetTagSubrangeQuery, GetTagSubrangeQueryVariables>(GetTagSubrangeDocument, variables),
      options
    )};

export const CardsTagSubrangesDocument = new TypedDocumentString(`
    query CardsTagSubranges($input: FindTagSubranges!) {
  tagSubranges: findTagSubranges(input: $input) {
    ...FTagSubrange
    team {
      name
    }
  }
}
    fragment FTagSubrange on GameTagSubrange {
  id
  from
  to
  amount
  description
  isApproved
  isLocked
  connectionId
  tagType
  createdAt
  type
  distributionPointId
  reassignTeams
  reassignExistingTeams
}`);

export const useCardsTagSubrangesQuery = <
      TData = CardsTagSubrangesQuery,
      TError = unknown
    >(
      variables: CardsTagSubrangesQueryVariables,
      options?: UseQueryOptions<CardsTagSubrangesQuery, TError, TData>
    ) => {
    
    return useQuery<CardsTagSubrangesQuery, TError, TData>(
      ['CardsTagSubranges', variables],
      fetchGenerated<CardsTagSubrangesQuery, CardsTagSubrangesQueryVariables>(CardsTagSubrangesDocument, variables),
      options
    )};

export const UpdateTagSubrangeDocument = new TypedDocumentString(`
    mutation UpdateTagSubrange($input: GameTagSubrangeUpdateInput!) {
  updateTagSubrange(input: $input) {
    id
  }
}
    `);

export const useUpdateTagSubrangeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTagSubrangeMutation, TError, UpdateTagSubrangeMutationVariables, TContext>) => {
    
    return useMutation<UpdateTagSubrangeMutation, TError, UpdateTagSubrangeMutationVariables, TContext>(
      ['UpdateTagSubrange'],
      (variables?: UpdateTagSubrangeMutationVariables) => fetchGenerated<UpdateTagSubrangeMutation, UpdateTagSubrangeMutationVariables>(UpdateTagSubrangeDocument, variables)(),
      options
    )};

export const CreateTagSubrangeDocument = new TypedDocumentString(`
    mutation CreateTagSubrange($input: GameTagSubrangeCreateInput!) {
  createTagSubrange(input: $input) {
    id
  }
}
    `);

export const useCreateTagSubrangeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTagSubrangeMutation, TError, CreateTagSubrangeMutationVariables, TContext>) => {
    
    return useMutation<CreateTagSubrangeMutation, TError, CreateTagSubrangeMutationVariables, TContext>(
      ['CreateTagSubrange'],
      (variables?: CreateTagSubrangeMutationVariables) => fetchGenerated<CreateTagSubrangeMutation, CreateTagSubrangeMutationVariables>(CreateTagSubrangeDocument, variables)(),
      options
    )};

export const DeleteTagSubrangeDocument = new TypedDocumentString(`
    mutation DeleteTagSubrange($input: GameTagSubrangeDeleteInput!) {
  deleteTagSubrange(input: $input)
}
    `);

export const useDeleteTagSubrangeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTagSubrangeMutation, TError, DeleteTagSubrangeMutationVariables, TContext>) => {
    
    return useMutation<DeleteTagSubrangeMutation, TError, DeleteTagSubrangeMutationVariables, TContext>(
      ['DeleteTagSubrange'],
      (variables?: DeleteTagSubrangeMutationVariables) => fetchGenerated<DeleteTagSubrangeMutation, DeleteTagSubrangeMutationVariables>(DeleteTagSubrangeDocument, variables)(),
      options
    )};

export const UnlockApprovedSubrangeDocument = new TypedDocumentString(`
    mutation UnlockApprovedSubrange($input: GameTagSubrangeDeleteInput!) {
  unlockApprovedTagSubrange(input: $input) {
    id
    isApproved
    isLocked
  }
}
    `);

export const useUnlockApprovedSubrangeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnlockApprovedSubrangeMutation, TError, UnlockApprovedSubrangeMutationVariables, TContext>) => {
    
    return useMutation<UnlockApprovedSubrangeMutation, TError, UnlockApprovedSubrangeMutationVariables, TContext>(
      ['UnlockApprovedSubrange'],
      (variables?: UnlockApprovedSubrangeMutationVariables) => fetchGenerated<UnlockApprovedSubrangeMutation, UnlockApprovedSubrangeMutationVariables>(UnlockApprovedSubrangeDocument, variables)(),
      options
    )};

export const AssignSubrangeDocument = new TypedDocumentString(`
    mutation AssignSubrange($input: AssignSubranges!) {
  assignTagSubrange(input: $input) {
    success
    successCount
    skippedCount
    skippedRanges {
      subrangeId
      range
      reason
      conflictingGame {
        id
        name
      }
    }
  }
}
    `);

export const useAssignSubrangeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AssignSubrangeMutation, TError, AssignSubrangeMutationVariables, TContext>) => {
    
    return useMutation<AssignSubrangeMutation, TError, AssignSubrangeMutationVariables, TContext>(
      ['AssignSubrange'],
      (variables?: AssignSubrangeMutationVariables) => fetchGenerated<AssignSubrangeMutation, AssignSubrangeMutationVariables>(AssignSubrangeDocument, variables)(),
      options
    )};

export const ApproveSubrangeDocument = new TypedDocumentString(`
    mutation ApproveSubrange($input: BulkChangeSubranges!) {
  bulkChangeTagSubrange(input: $input)
}
    `);

export const useApproveSubrangeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApproveSubrangeMutation, TError, ApproveSubrangeMutationVariables, TContext>) => {
    
    return useMutation<ApproveSubrangeMutation, TError, ApproveSubrangeMutationVariables, TContext>(
      ['ApproveSubrange'],
      (variables?: ApproveSubrangeMutationVariables) => fetchGenerated<ApproveSubrangeMutation, ApproveSubrangeMutationVariables>(ApproveSubrangeDocument, variables)(),
      options
    )};

export const UpdateLockSubrangesDocument = new TypedDocumentString(`
    mutation UpdateLockSubranges($input: BulkChangeSubranges!) {
  bulkChangeTagSubrange(input: $input)
}
    `);

export const useUpdateLockSubrangesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLockSubrangesMutation, TError, UpdateLockSubrangesMutationVariables, TContext>) => {
    
    return useMutation<UpdateLockSubrangesMutation, TError, UpdateLockSubrangesMutationVariables, TContext>(
      ['UpdateLockSubranges'],
      (variables?: UpdateLockSubrangesMutationVariables) => fetchGenerated<UpdateLockSubrangesMutation, UpdateLockSubrangesMutationVariables>(UpdateLockSubrangesDocument, variables)(),
      options
    )};

export const FindCardsLocationsDocument = new TypedDocumentString(`
    query FindCardsLocations($gameId: String!) {
  locations: findLocations(gameId: $gameId) {
    id
    type
    slug
    name
  }
}
    `);

export const useFindCardsLocationsQuery = <
      TData = FindCardsLocationsQuery,
      TError = unknown
    >(
      variables: FindCardsLocationsQueryVariables,
      options?: UseQueryOptions<FindCardsLocationsQuery, TError, TData>
    ) => {
    
    return useQuery<FindCardsLocationsQuery, TError, TData>(
      ['FindCardsLocations', variables],
      fetchGenerated<FindCardsLocationsQuery, FindCardsLocationsQueryVariables>(FindCardsLocationsDocument, variables),
      options
    )};

export const FindCardsTeamsDocument = new TypedDocumentString(`
    query FindCardsTeams($input: FindTeamsInput!) {
  teams: findTeams(input: $input) {
    id
    name
  }
}
    `);

export const useFindCardsTeamsQuery = <
      TData = FindCardsTeamsQuery,
      TError = unknown
    >(
      variables: FindCardsTeamsQueryVariables,
      options?: UseQueryOptions<FindCardsTeamsQuery, TError, TData>
    ) => {
    
    return useQuery<FindCardsTeamsQuery, TError, TData>(
      ['FindCardsTeams', variables],
      fetchGenerated<FindCardsTeamsQuery, FindCardsTeamsQueryVariables>(FindCardsTeamsDocument, variables),
      options
    )};

export const FindTagRangesByGameDocument = new TypedDocumentString(`
    query FindTagRangesByGame($gameId: String!) {
  findTagRanges(gameId: $gameId) {
    id
    from
    to
  }
}
    `);

export const useFindTagRangesByGameQuery = <
      TData = FindTagRangesByGameQuery,
      TError = unknown
    >(
      variables: FindTagRangesByGameQueryVariables,
      options?: UseQueryOptions<FindTagRangesByGameQuery, TError, TData>
    ) => {
    
    return useQuery<FindTagRangesByGameQuery, TError, TData>(
      ['FindTagRangesByGame', variables],
      fetchGenerated<FindTagRangesByGameQuery, FindTagRangesByGameQueryVariables>(FindTagRangesByGameDocument, variables),
      options
    )};

export const CreateTagRangeDocument = new TypedDocumentString(`
    mutation CreateTagRange($input: GameTagRangeCreateInput!) {
  createTagRange(input: $input) {
    id
  }
}
    `);

export const useCreateTagRangeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTagRangeMutation, TError, CreateTagRangeMutationVariables, TContext>) => {
    
    return useMutation<CreateTagRangeMutation, TError, CreateTagRangeMutationVariables, TContext>(
      ['CreateTagRange'],
      (variables?: CreateTagRangeMutationVariables) => fetchGenerated<CreateTagRangeMutation, CreateTagRangeMutationVariables>(CreateTagRangeDocument, variables)(),
      options
    )};

export const DeleteTagRangeDocument = new TypedDocumentString(`
    mutation DeleteTagRange($input: GameTagRangeDeleteInput!) {
  deleteTagRange(input: $input)
}
    `);

export const useDeleteTagRangeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTagRangeMutation, TError, DeleteTagRangeMutationVariables, TContext>) => {
    
    return useMutation<DeleteTagRangeMutation, TError, DeleteTagRangeMutationVariables, TContext>(
      ['DeleteTagRange'],
      (variables?: DeleteTagRangeMutationVariables) => fetchGenerated<DeleteTagRangeMutation, DeleteTagRangeMutationVariables>(DeleteTagRangeDocument, variables)(),
      options
    )};

export const FindTagSubrangesByGameDocument = new TypedDocumentString(`
    query FindTagSubrangesByGame($input: FindTagSubranges!) {
  findTagSubranges(input: $input) {
    id
    from
    to
    isLocked
    isApproved
  }
}
    `);

export const useFindTagSubrangesByGameQuery = <
      TData = FindTagSubrangesByGameQuery,
      TError = unknown
    >(
      variables: FindTagSubrangesByGameQueryVariables,
      options?: UseQueryOptions<FindTagSubrangesByGameQuery, TError, TData>
    ) => {
    
    return useQuery<FindTagSubrangesByGameQuery, TError, TData>(
      ['FindTagSubrangesByGame', variables],
      fetchGenerated<FindTagSubrangesByGameQuery, FindTagSubrangesByGameQueryVariables>(FindTagSubrangesByGameDocument, variables),
      options
    )};

export const GetTagRangeDocument = new TypedDocumentString(`
    query GetTagRange($id: String!, $gameId: String!) {
  getTagRange(id: $id, gameId: $gameId) {
    id
    from
    to
  }
}
    `);

export const useGetTagRangeQuery = <
      TData = GetTagRangeQuery,
      TError = unknown
    >(
      variables: GetTagRangeQueryVariables,
      options?: UseQueryOptions<GetTagRangeQuery, TError, TData>
    ) => {
    
    return useQuery<GetTagRangeQuery, TError, TData>(
      ['GetTagRange', variables],
      fetchGenerated<GetTagRangeQuery, GetTagRangeQueryVariables>(GetTagRangeDocument, variables),
      options
    )};

export const UpdateTagRangeDocument = new TypedDocumentString(`
    mutation UpdateTagRange($input: GameTagRangeUpdateInput!) {
  updateTagRange(input: $input) {
    id
  }
}
    `);

export const useUpdateTagRangeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTagRangeMutation, TError, UpdateTagRangeMutationVariables, TContext>) => {
    
    return useMutation<UpdateTagRangeMutation, TError, UpdateTagRangeMutationVariables, TContext>(
      ['UpdateTagRange'],
      (variables?: UpdateTagRangeMutationVariables) => fetchGenerated<UpdateTagRangeMutation, UpdateTagRangeMutationVariables>(UpdateTagRangeDocument, variables)(),
      options
    )};

export const IsCardRangeAvailableDocument = new TypedDocumentString(`
    mutation IsCardRangeAvailable($input: IsTagSubrangesAvailable!) {
  isAvailable: isSubrangeAvailable(input: $input) {
    isAvailable
    overlap {
      gameId
      gameName
      isSameGame
    }
  }
}
    `);

export const useIsCardRangeAvailableMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<IsCardRangeAvailableMutation, TError, IsCardRangeAvailableMutationVariables, TContext>) => {
    
    return useMutation<IsCardRangeAvailableMutation, TError, IsCardRangeAvailableMutationVariables, TContext>(
      ['IsCardRangeAvailable'],
      (variables?: IsCardRangeAvailableMutationVariables) => fetchGenerated<IsCardRangeAvailableMutation, IsCardRangeAvailableMutationVariables>(IsCardRangeAvailableDocument, variables)(),
      options
    )};

export const IsGameRangeAvailableDocument = new TypedDocumentString(`
    mutation IsGameRangeAvailable($input: IsGameTagRangeAvailable!) {
  isAvailable: isGameRangeAvailable(input: $input)
}
    `);

export const useIsGameRangeAvailableMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<IsGameRangeAvailableMutation, TError, IsGameRangeAvailableMutationVariables, TContext>) => {
    
    return useMutation<IsGameRangeAvailableMutation, TError, IsGameRangeAvailableMutationVariables, TContext>(
      ['IsGameRangeAvailable'],
      (variables?: IsGameRangeAvailableMutationVariables) => fetchGenerated<IsGameRangeAvailableMutation, IsGameRangeAvailableMutationVariables>(IsGameRangeAvailableDocument, variables)(),
      options
    )};

export const GetImdDecileAggregatesDocument = new TypedDocumentString(`
    query GetImdDecileAggregates($gameId: String!) {
  imdDecileAggregates(gameId: $gameId) {
    totalPlayers
    totalPopulation
    unmatchedZoneCount
    deciles {
      decile
      totalPopulation
      totalPlayers
      totalPlayersPercent
      totalPopulationPercent
      indexOfPenetration
    }
  }
}
    `);

export const useGetImdDecileAggregatesQuery = <
      TData = GetImdDecileAggregatesQuery,
      TError = unknown
    >(
      variables: GetImdDecileAggregatesQueryVariables,
      options?: UseQueryOptions<GetImdDecileAggregatesQuery, TError, TData>
    ) => {
    
    return useQuery<GetImdDecileAggregatesQuery, TError, TData>(
      ['GetImdDecileAggregates', variables],
      fetchGenerated<GetImdDecileAggregatesQuery, GetImdDecileAggregatesQueryVariables>(GetImdDecileAggregatesDocument, variables),
      options
    )};

export const GetCampaignsDocument = new TypedDocumentString(`
    query GetCampaigns($gameId: String!, $category: String) {
  getCampaigns(gameId: $gameId, category: $category) {
    campaignId
    name
    status
    segment
    scheduledTime
    gameId
    teamId
    category
    content
    createdAt
    pushTotalCount
    pushPlayersCount
    team {
      name
      type
    }
    author {
      publicName
    }
    analytics {
      delivered
      read
      likes
      openedByPush
    }
  }
}
    `);

export const useGetCampaignsQuery = <
      TData = GetCampaignsQuery,
      TError = unknown
    >(
      variables: GetCampaignsQueryVariables,
      options?: UseQueryOptions<GetCampaignsQuery, TError, TData>
    ) => {
    
    return useQuery<GetCampaignsQuery, TError, TData>(
      ['GetCampaigns', variables],
      fetchGenerated<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, variables),
      options
    )};

export const DeleteCampaignDocument = new TypedDocumentString(`
    mutation DeleteCampaign($campaignId: String!, $gameId: String!) {
  deleteCampaign(campaignId: $campaignId, gameId: $gameId)
}
    `);

export const useDeleteCampaignMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCampaignMutation, TError, DeleteCampaignMutationVariables, TContext>) => {
    
    return useMutation<DeleteCampaignMutation, TError, DeleteCampaignMutationVariables, TContext>(
      ['DeleteCampaign'],
      (variables?: DeleteCampaignMutationVariables) => fetchGenerated<DeleteCampaignMutation, DeleteCampaignMutationVariables>(DeleteCampaignDocument, variables)(),
      options
    )};

export const EventListTableDocument = new TypedDocumentString(`
    query EventListTable($gameId: String = "") {
  findEvents(gameId: $gameId) {
    ...FEventBase
  }
}
    fragment FEventBase on Event {
  id
  description
  points
  startDate
  endDate
  timing {
    startTime
    endTime
  }
  allDay
  weekDay
  allBeatBoxes
}`);

export const useEventListTableQuery = <
      TData = EventListTableQuery,
      TError = unknown
    >(
      variables?: EventListTableQueryVariables,
      options?: UseQueryOptions<EventListTableQuery, TError, TData>
    ) => {
    
    return useQuery<EventListTableQuery, TError, TData>(
      variables === undefined ? ['EventListTable'] : ['EventListTable', variables],
      fetchGenerated<EventListTableQuery, EventListTableQueryVariables>(EventListTableDocument, variables),
      options
    )};

export const GetEventDocument = new TypedDocumentString(`
    query GetEvent($input: GetEvent!) {
  getEvent(input: $input) {
    ...FEventAll
  }
}
    fragment FEventBase on Event {
  id
  description
  points
  startDate
  endDate
  timing {
    startTime
    endTime
  }
  allDay
  weekDay
  allBeatBoxes
}
fragment FEventDetails on Event {
  groupIds
}
fragment FEventAll on Event {
  ...FEventBase
  ...FEventDetails
  customLocationIds
  isVisible
  sanityID
}`);

export const useGetEventQuery = <
      TData = GetEventQuery,
      TError = unknown
    >(
      variables: GetEventQueryVariables,
      options?: UseQueryOptions<GetEventQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventQuery, TError, TData>(
      ['GetEvent', variables],
      fetchGenerated<GetEventQuery, GetEventQueryVariables>(GetEventDocument, variables),
      options
    )};

export const FindLocationsByGameDocument = new TypedDocumentString(`
    query FindLocationsByGame($gameId: String = "") {
  findLocations(gameId: $gameId) {
    ...FLocationsBase
  }
}
    fragment FLocationsBase on Location {
  id
  slug
  type
  name
  isBonus
  beatBoxNumber
}`);

export const useFindLocationsByGameQuery = <
      TData = FindLocationsByGameQuery,
      TError = unknown
    >(
      variables?: FindLocationsByGameQueryVariables,
      options?: UseQueryOptions<FindLocationsByGameQuery, TError, TData>
    ) => {
    
    return useQuery<FindLocationsByGameQuery, TError, TData>(
      variables === undefined ? ['FindLocationsByGame'] : ['FindLocationsByGame', variables],
      fetchGenerated<FindLocationsByGameQuery, FindLocationsByGameQueryVariables>(FindLocationsByGameDocument, variables),
      options
    )};

export const FindGroupsForEventDocument = new TypedDocumentString(`
    query FindGroupsForEvent($gameId: String!) {
  findGroups(gameId: $gameId) {
    id
    name
  }
}
    `);

export const useFindGroupsForEventQuery = <
      TData = FindGroupsForEventQuery,
      TError = unknown
    >(
      variables: FindGroupsForEventQueryVariables,
      options?: UseQueryOptions<FindGroupsForEventQuery, TError, TData>
    ) => {
    
    return useQuery<FindGroupsForEventQuery, TError, TData>(
      ['FindGroupsForEvent', variables],
      fetchGenerated<FindGroupsForEventQuery, FindGroupsForEventQueryVariables>(FindGroupsForEventDocument, variables),
      options
    )};

export const GetEventGroupDocument = new TypedDocumentString(`
    query GetEventGroup($input: GetGroup!) {
  getGroup(input: $input) {
    description
    id
  }
}
    `);

export const useGetEventGroupQuery = <
      TData = GetEventGroupQuery,
      TError = unknown
    >(
      variables: GetEventGroupQueryVariables,
      options?: UseQueryOptions<GetEventGroupQuery, TError, TData>
    ) => {
    
    return useQuery<GetEventGroupQuery, TError, TData>(
      ['GetEventGroup', variables],
      fetchGenerated<GetEventGroupQuery, GetEventGroupQueryVariables>(GetEventGroupDocument, variables),
      options
    )};

export const FindEventPointsDocument = new TypedDocumentString(`
    query FindEventPoints($input: FindEventPoints!) {
  findEventPoints(input: $input) {
    id
    startDate
    endDate
    locationId
  }
}
    `);

export const useFindEventPointsQuery = <
      TData = FindEventPointsQuery,
      TError = unknown
    >(
      variables: FindEventPointsQueryVariables,
      options?: UseQueryOptions<FindEventPointsQuery, TError, TData>
    ) => {
    
    return useQuery<FindEventPointsQuery, TError, TData>(
      ['FindEventPoints', variables],
      fetchGenerated<FindEventPointsQuery, FindEventPointsQueryVariables>(FindEventPointsDocument, variables),
      options
    )};

export const CreateEventScheduleDocument = new TypedDocumentString(`
    mutation CreateEventSchedule($input: EventCreateInput!) {
  createEvent(input: $input) {
    id
  }
}
    `);

export const useCreateEventScheduleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateEventScheduleMutation, TError, CreateEventScheduleMutationVariables, TContext>) => {
    
    return useMutation<CreateEventScheduleMutation, TError, CreateEventScheduleMutationVariables, TContext>(
      ['CreateEventSchedule'],
      (variables?: CreateEventScheduleMutationVariables) => fetchGenerated<CreateEventScheduleMutation, CreateEventScheduleMutationVariables>(CreateEventScheduleDocument, variables)(),
      options
    )};

export const UpdateEventScheduleDocument = new TypedDocumentString(`
    mutation UpdateEventSchedule($input: EventUpdateInput!) {
  updateEvent(input: $input) {
    id
  }
}
    `);

export const useUpdateEventScheduleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateEventScheduleMutation, TError, UpdateEventScheduleMutationVariables, TContext>) => {
    
    return useMutation<UpdateEventScheduleMutation, TError, UpdateEventScheduleMutationVariables, TContext>(
      ['UpdateEventSchedule'],
      (variables?: UpdateEventScheduleMutationVariables) => fetchGenerated<UpdateEventScheduleMutation, UpdateEventScheduleMutationVariables>(UpdateEventScheduleDocument, variables)(),
      options
    )};

export const RemoveEventScheduleDocument = new TypedDocumentString(`
    mutation RemoveEventSchedule($input: DeleteEvent!) {
  deleteEvent(input: $input) {
    id
  }
}
    `);

export const useRemoveEventScheduleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveEventScheduleMutation, TError, RemoveEventScheduleMutationVariables, TContext>) => {
    
    return useMutation<RemoveEventScheduleMutation, TError, RemoveEventScheduleMutationVariables, TContext>(
      ['RemoveEventSchedule'],
      (variables?: RemoveEventScheduleMutationVariables) => fetchGenerated<RemoveEventScheduleMutation, RemoveEventScheduleMutationVariables>(RemoveEventScheduleDocument, variables)(),
      options
    )};

export const RemoveEventPointDocument = new TypedDocumentString(`
    mutation RemoveEventPoint($input: DeleteEventPoint!) {
  deleteEventPoint(input: $input)
}
    `);

export const useRemoveEventPointMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveEventPointMutation, TError, RemoveEventPointMutationVariables, TContext>) => {
    
    return useMutation<RemoveEventPointMutation, TError, RemoveEventPointMutationVariables, TContext>(
      ['RemoveEventPoint'],
      (variables?: RemoveEventPointMutationVariables) => fetchGenerated<RemoveEventPointMutation, RemoveEventPointMutationVariables>(RemoveEventPointDocument, variables)(),
      options
    )};

export const DuplicateEventScheduleDocument = new TypedDocumentString(`
    mutation DuplicateEventSchedule($input: GetEvent!) {
  duplicateEvent(input: $input) {
    id
  }
}
    `);

export const useDuplicateEventScheduleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DuplicateEventScheduleMutation, TError, DuplicateEventScheduleMutationVariables, TContext>) => {
    
    return useMutation<DuplicateEventScheduleMutation, TError, DuplicateEventScheduleMutationVariables, TContext>(
      ['DuplicateEventSchedule'],
      (variables?: DuplicateEventScheduleMutationVariables) => fetchGenerated<DuplicateEventScheduleMutation, DuplicateEventScheduleMutationVariables>(DuplicateEventScheduleDocument, variables)(),
      options
    )};

export const DashboardInstallerLocationsDocument = new TypedDocumentString(`
    query DashboardInstallerLocations($gameId: String!) {
  installerFindLocations(gameId: $gameId) {
    id
    gameId
    slug
    type
    lat
    lng
    name
    isBonus
  }
}
    `);

export const useDashboardInstallerLocationsQuery = <
      TData = DashboardInstallerLocationsQuery,
      TError = unknown
    >(
      variables: DashboardInstallerLocationsQueryVariables,
      options?: UseQueryOptions<DashboardInstallerLocationsQuery, TError, TData>
    ) => {
    
    return useQuery<DashboardInstallerLocationsQuery, TError, TData>(
      ['DashboardInstallerLocations', variables],
      fetchGenerated<DashboardInstallerLocationsQuery, DashboardInstallerLocationsQueryVariables>(DashboardInstallerLocationsDocument, variables),
      options
    )};

export const DashboardInstallerUpdateLocationDocument = new TypedDocumentString(`
    mutation DashboardInstallerUpdateLocation($input: InstallerLocationUpdateInput!) {
  installerUpdateLocation(input: $input) {
    id
    gameId
    lat
    lng
  }
}
    `);

export const useDashboardInstallerUpdateLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DashboardInstallerUpdateLocationMutation, TError, DashboardInstallerUpdateLocationMutationVariables, TContext>) => {
    
    return useMutation<DashboardInstallerUpdateLocationMutation, TError, DashboardInstallerUpdateLocationMutationVariables, TContext>(
      ['DashboardInstallerUpdateLocation'],
      (variables?: DashboardInstallerUpdateLocationMutationVariables) => fetchGenerated<DashboardInstallerUpdateLocationMutation, DashboardInstallerUpdateLocationMutationVariables>(DashboardInstallerUpdateLocationDocument, variables)(),
      options
    )};

export const DashboardInstallerFindSwipeByTagDocument = new TypedDocumentString(`
    query DashboardInstallerFindSwipeByTag($input: FindByTag!) {
  installerFindSwipeByTag(input: $input) {
    id
    tagNumber
    locationName
    timestamp
    status
    locationId
    reason
    isLucky
  }
}
    `);

export const useDashboardInstallerFindSwipeByTagQuery = <
      TData = DashboardInstallerFindSwipeByTagQuery,
      TError = unknown
    >(
      variables: DashboardInstallerFindSwipeByTagQueryVariables,
      options?: UseQueryOptions<DashboardInstallerFindSwipeByTagQuery, TError, TData>
    ) => {
    
    return useQuery<DashboardInstallerFindSwipeByTagQuery, TError, TData>(
      ['DashboardInstallerFindSwipeByTag', variables],
      fetchGenerated<DashboardInstallerFindSwipeByTagQuery, DashboardInstallerFindSwipeByTagQueryVariables>(DashboardInstallerFindSwipeByTagDocument, variables),
      options
    )};

export const CreateGameLeaderboardDocument = new TypedDocumentString(`
    mutation CreateGameLeaderboard($input: GameLeaderboardCreateInput!) {
  createLeaderboard(input: $input) {
    id
  }
}
    `);

export const useCreateGameLeaderboardMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGameLeaderboardMutation, TError, CreateGameLeaderboardMutationVariables, TContext>) => {
    
    return useMutation<CreateGameLeaderboardMutation, TError, CreateGameLeaderboardMutationVariables, TContext>(
      ['CreateGameLeaderboard'],
      (variables?: CreateGameLeaderboardMutationVariables) => fetchGenerated<CreateGameLeaderboardMutation, CreateGameLeaderboardMutationVariables>(CreateGameLeaderboardDocument, variables)(),
      options
    )};

export const RemoveGameLeaderboardDocument = new TypedDocumentString(`
    mutation RemoveGameLeaderboard($input: DeleteLeaderboard!) {
  deleteLeaderboard(input: $input)
}
    `);

export const useRemoveGameLeaderboardMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveGameLeaderboardMutation, TError, RemoveGameLeaderboardMutationVariables, TContext>) => {
    
    return useMutation<RemoveGameLeaderboardMutation, TError, RemoveGameLeaderboardMutationVariables, TContext>(
      ['RemoveGameLeaderboard'],
      (variables?: RemoveGameLeaderboardMutationVariables) => fetchGenerated<RemoveGameLeaderboardMutation, RemoveGameLeaderboardMutationVariables>(RemoveGameLeaderboardDocument, variables)(),
      options
    )};

export const UpdateGameLeaderboardDocument = new TypedDocumentString(`
    mutation UpdateGameLeaderboard($input: GameLeaderboardUpdateInput!) {
  updateLeaderboard(input: $input) {
    id
  }
}
    `);

export const useUpdateGameLeaderboardMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGameLeaderboardMutation, TError, UpdateGameLeaderboardMutationVariables, TContext>) => {
    
    return useMutation<UpdateGameLeaderboardMutation, TError, UpdateGameLeaderboardMutationVariables, TContext>(
      ['UpdateGameLeaderboard'],
      (variables?: UpdateGameLeaderboardMutationVariables) => fetchGenerated<UpdateGameLeaderboardMutation, UpdateGameLeaderboardMutationVariables>(UpdateGameLeaderboardDocument, variables)(),
      options
    )};

export const MoveSmallTeamsDocument = new TypedDocumentString(`
    mutation MoveSmallTeams($input: MoveSmallTeamsInput!) {
  moveSmallTeams(input: $input)
}
    `);

export const useMoveSmallTeamsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveSmallTeamsMutation, TError, MoveSmallTeamsMutationVariables, TContext>) => {
    
    return useMutation<MoveSmallTeamsMutation, TError, MoveSmallTeamsMutationVariables, TContext>(
      ['MoveSmallTeams'],
      (variables?: MoveSmallTeamsMutationVariables) => fetchGenerated<MoveSmallTeamsMutation, MoveSmallTeamsMutationVariables>(MoveSmallTeamsDocument, variables)(),
      options
    )};

export const GetLeaderboardByIdDocument = new TypedDocumentString(`
    query GetLeaderboardById($gameId: String!, $id: String!) {
  getLeaderboard(gameId: $gameId, id: $id) {
    id
    name
    teamIds
    teamTypes
  }
}
    `);

export const useGetLeaderboardByIdQuery = <
      TData = GetLeaderboardByIdQuery,
      TError = unknown
    >(
      variables: GetLeaderboardByIdQueryVariables,
      options?: UseQueryOptions<GetLeaderboardByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetLeaderboardByIdQuery, TError, TData>(
      ['GetLeaderboardById', variables],
      fetchGenerated<GetLeaderboardByIdQuery, GetLeaderboardByIdQueryVariables>(GetLeaderboardByIdDocument, variables),
      options
    )};

export const FindLeaderboardsByGameDocument = new TypedDocumentString(`
    query FindLeaderboardsByGame($gameId: String = "") {
  findLeaderboards(gameId: $gameId) {
    id
    name
    teamIds
    teamTypes
  }
}
    `);

export const useFindLeaderboardsByGameQuery = <
      TData = FindLeaderboardsByGameQuery,
      TError = unknown
    >(
      variables?: FindLeaderboardsByGameQueryVariables,
      options?: UseQueryOptions<FindLeaderboardsByGameQuery, TError, TData>
    ) => {
    
    return useQuery<FindLeaderboardsByGameQuery, TError, TData>(
      variables === undefined ? ['FindLeaderboardsByGame'] : ['FindLeaderboardsByGame', variables],
      fetchGenerated<FindLeaderboardsByGameQuery, FindLeaderboardsByGameQueryVariables>(FindLeaderboardsByGameDocument, variables),
      options
    )};

export const FindLeaderboardsTeamsDocument = new TypedDocumentString(`
    query FindLeaderboardsTeams($input: FindTeamsInput!) {
  findTeams(input: $input) {
    ...FTeamBasic
    ...FTeamRanges
    totalMembers
    all
  }
}
    fragment FTeamBasic on Team {
  id
  name
  type
  status
  leaderboardId
}
fragment FTeamRanges on Team {
  subranges {
    from
    to
  }
}`);

export const useFindLeaderboardsTeamsQuery = <
      TData = FindLeaderboardsTeamsQuery,
      TError = unknown
    >(
      variables: FindLeaderboardsTeamsQueryVariables,
      options?: UseQueryOptions<FindLeaderboardsTeamsQuery, TError, TData>
    ) => {
    
    return useQuery<FindLeaderboardsTeamsQuery, TError, TData>(
      ['FindLeaderboardsTeams', variables],
      fetchGenerated<FindLeaderboardsTeamsQuery, FindLeaderboardsTeamsQueryVariables>(FindLeaderboardsTeamsDocument, variables),
      options
    )};

export const GetGamesListDocument = new TypedDocumentString(`
    query GetGamesList {
  listGames {
    id
    ...FGameLiveTotals
    info {
      ...FGameInfoBasic
      startsAt
      endsAt
    }
  }
}
    fragment FGameInfoBasic on GameInfo {
  slug
  name
  status
  type
}
fragment FGameLiveTotals on Game {
  liveTotals {
    totalMiles
    totalPlayers
    everJoinedPlayers
    registeredPlayers
  }
}`);

export const useGetGamesListQuery = <
      TData = GetGamesListQuery,
      TError = unknown
    >(
      variables?: GetGamesListQueryVariables,
      options?: UseQueryOptions<GetGamesListQuery, TError, TData>
    ) => {
    
    return useQuery<GetGamesListQuery, TError, TData>(
      variables === undefined ? ['GetGamesList'] : ['GetGamesList', variables],
      fetchGenerated<GetGamesListQuery, GetGamesListQueryVariables>(GetGamesListDocument, variables),
      options
    )};

export const CreateGameDocument = new TypedDocumentString(`
    mutation CreateGame($input: CreateGameInput!) {
  createGame(input: $input) {
    id
  }
}
    `);

export const useCreateGameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGameMutation, TError, CreateGameMutationVariables, TContext>) => {
    
    return useMutation<CreateGameMutation, TError, CreateGameMutationVariables, TContext>(
      ['CreateGame'],
      (variables?: CreateGameMutationVariables) => fetchGenerated<CreateGameMutation, CreateGameMutationVariables>(CreateGameDocument, variables)(),
      options
    )};

export const GameMapDatasetsDocument = new TypedDocumentString(`
    query GameMapDatasets($gameId: String!) {
  gameMapDatasets(gameId: $gameId) {
    datasetId
    audience
    visibleByDefault
    sortOrder
    styleOverride {
      color
      lineWidth
      opacity
    }
    dataset {
      ...FMapDataset
    }
  }
}
    fragment FMapDataset on MapDataset {
  id
  name
  description
  category
  geometryType
  featureCount
  bbox
  featuresUrl
  version
  updatedAt
  updatedBy
  source {
    kind
    filename
    serviceUrl
    attribution
  }
  defaultStyle {
    color
    lineWidth
    opacity
  }
}`);

export const useGameMapDatasetsQuery = <
      TData = GameMapDatasetsQuery,
      TError = unknown
    >(
      variables: GameMapDatasetsQueryVariables,
      options?: UseQueryOptions<GameMapDatasetsQuery, TError, TData>
    ) => {
    
    return useQuery<GameMapDatasetsQuery, TError, TData>(
      ['GameMapDatasets', variables],
      fetchGenerated<GameMapDatasetsQuery, GameMapDatasetsQueryVariables>(GameMapDatasetsDocument, variables),
      options
    )};

export const LinkMapDatasetDocument = new TypedDocumentString(`
    mutation LinkMapDataset($input: LinkMapDatasetInput!) {
  linkMapDataset(input: $input) {
    datasetId
    audience
    visibleByDefault
    sortOrder
  }
}
    `);

export const useLinkMapDatasetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LinkMapDatasetMutation, TError, LinkMapDatasetMutationVariables, TContext>) => {
    
    return useMutation<LinkMapDatasetMutation, TError, LinkMapDatasetMutationVariables, TContext>(
      ['LinkMapDataset'],
      (variables?: LinkMapDatasetMutationVariables) => fetchGenerated<LinkMapDatasetMutation, LinkMapDatasetMutationVariables>(LinkMapDatasetDocument, variables)(),
      options
    )};

export const UpdateGameMapDatasetDocument = new TypedDocumentString(`
    mutation UpdateGameMapDataset($input: UpdateGameMapDatasetInput!) {
  updateGameMapDataset(input: $input) {
    datasetId
    audience
    visibleByDefault
    sortOrder
    styleOverride {
      color
      lineWidth
      opacity
    }
  }
}
    `);

export const useUpdateGameMapDatasetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGameMapDatasetMutation, TError, UpdateGameMapDatasetMutationVariables, TContext>) => {
    
    return useMutation<UpdateGameMapDatasetMutation, TError, UpdateGameMapDatasetMutationVariables, TContext>(
      ['UpdateGameMapDataset'],
      (variables?: UpdateGameMapDatasetMutationVariables) => fetchGenerated<UpdateGameMapDatasetMutation, UpdateGameMapDatasetMutationVariables>(UpdateGameMapDatasetDocument, variables)(),
      options
    )};

export const UnlinkMapDatasetDocument = new TypedDocumentString(`
    mutation UnlinkMapDataset($input: UnlinkMapDatasetInput!) {
  unlinkMapDataset(input: $input)
}
    `);

export const useUnlinkMapDatasetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnlinkMapDatasetMutation, TError, UnlinkMapDatasetMutationVariables, TContext>) => {
    
    return useMutation<UnlinkMapDatasetMutation, TError, UnlinkMapDatasetMutationVariables, TContext>(
      ['UnlinkMapDataset'],
      (variables?: UnlinkMapDatasetMutationVariables) => fetchGenerated<UnlinkMapDatasetMutation, UnlinkMapDatasetMutationVariables>(UnlinkMapDatasetDocument, variables)(),
      options
    )};

export const NearbyLamppostsDocument = new TypedDocumentString(`
    query NearbyLampposts($gameId: String!, $lng: Float!, $lat: Float!) {
  nearbyMappingLampposts(gameId: $gameId, lng: $lng, lat: $lat) {
    searchRadiusMeters
    candidates {
      osid
      lng
      lat
      distanceMeters
    }
  }
}
    `);

export const useNearbyLamppostsQuery = <
      TData = NearbyLamppostsQuery,
      TError = unknown
    >(
      variables: NearbyLamppostsQueryVariables,
      options?: UseQueryOptions<NearbyLamppostsQuery, TError, TData>
    ) => {
    
    return useQuery<NearbyLamppostsQuery, TError, TData>(
      ['NearbyLampposts', variables],
      fetchGenerated<NearbyLamppostsQuery, NearbyLamppostsQueryVariables>(NearbyLamppostsDocument, variables),
      options
    )};

export const MappingLayerReviewsDocument = new TypedDocumentString(`
    query MappingLayerReviews($gameId: String!, $type: MappingReviewType!) {
  mappingLayerReviews(gameId: $gameId, type: $type) {
    ...MappingLayerReviewFields
  }
}
    fragment MappingLayerReviewFields on MappingLayerReview {
  gameId
  layer
  type
  status
  totalCount
  locationCount
  approvedCount
  changesRequestedCount
  respondedCount
  pendingCount
  openQueryCount
  approvedAt
}`);

export const useMappingLayerReviewsQuery = <
      TData = MappingLayerReviewsQuery,
      TError = unknown
    >(
      variables: MappingLayerReviewsQueryVariables,
      options?: UseQueryOptions<MappingLayerReviewsQuery, TError, TData>
    ) => {
    
    return useQuery<MappingLayerReviewsQuery, TError, TData>(
      ['MappingLayerReviews', variables],
      fetchGenerated<MappingLayerReviewsQuery, MappingLayerReviewsQueryVariables>(MappingLayerReviewsDocument, variables),
      options
    )};

export const SubmitMappingLayerForReviewDocument = new TypedDocumentString(`
    mutation SubmitMappingLayerForReview($input: SubmitMappingLayerForReviewInput!) {
  submitMappingLayerForReview(input: $input) {
    createdCount
    skippedCount
    failedLocationIds
    layer {
      ...MappingLayerReviewFields
    }
  }
}
    fragment MappingLayerReviewFields on MappingLayerReview {
  gameId
  layer
  type
  status
  totalCount
  locationCount
  approvedCount
  changesRequestedCount
  respondedCount
  pendingCount
  openQueryCount
  approvedAt
}`);

export const useSubmitMappingLayerForReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitMappingLayerForReviewMutation, TError, SubmitMappingLayerForReviewMutationVariables, TContext>) => {
    
    return useMutation<SubmitMappingLayerForReviewMutation, TError, SubmitMappingLayerForReviewMutationVariables, TContext>(
      ['SubmitMappingLayerForReview'],
      (variables?: SubmitMappingLayerForReviewMutationVariables) => fetchGenerated<SubmitMappingLayerForReviewMutation, SubmitMappingLayerForReviewMutationVariables>(SubmitMappingLayerForReviewDocument, variables)(),
      options
    )};

export const FindAllGroupsElementsDocument = new TypedDocumentString(`
    query FindAllGroupsElements($gameId: String = "") {
  findAllGroupsElements(gameId: $gameId) {
    locationId
    groupId
  }
}
    `);

export const useFindAllGroupsElementsQuery = <
      TData = FindAllGroupsElementsQuery,
      TError = unknown
    >(
      variables?: FindAllGroupsElementsQueryVariables,
      options?: UseQueryOptions<FindAllGroupsElementsQuery, TError, TData>
    ) => {
    
    return useQuery<FindAllGroupsElementsQuery, TError, TData>(
      variables === undefined ? ['FindAllGroupsElements'] : ['FindAllGroupsElements', variables],
      fetchGenerated<FindAllGroupsElementsQuery, FindAllGroupsElementsQueryVariables>(FindAllGroupsElementsDocument, variables),
      options
    )};

export const FindAllLocationsDocument = new TypedDocumentString(`
    query FindAllLocations($gameId: String = "") {
  locations: findLocations(gameId: $gameId) {
    ...FLocationInfoBasic
    ...FLocationCoordinates
    isVisible
    ...FLocationDetailsBasic
    what3words
    ownerName
    geo {
      lamppost
    }
  }
}
    fragment FLocationInfoBasic on Location {
  id
  type
  slug
  points
  gemType
  beatBoxNumber
  geo {
    isochrone
    nearest
    lamppost
  }
}
fragment FLocationCoordinates on Location {
  lng
  lat
}
fragment FLocationDetailsBasic on Location {
  name
  isBonus
  description
  accessible
}`);

export const useFindAllLocationsQuery = <
      TData = FindAllLocationsQuery,
      TError = unknown
    >(
      variables?: FindAllLocationsQueryVariables,
      options?: UseQueryOptions<FindAllLocationsQuery, TError, TData>
    ) => {
    
    return useQuery<FindAllLocationsQuery, TError, TData>(
      variables === undefined ? ['FindAllLocations'] : ['FindAllLocations', variables],
      fetchGenerated<FindAllLocationsQuery, FindAllLocationsQueryVariables>(FindAllLocationsDocument, variables),
      options
    )};

export const FindLocationGroupsDocument = new TypedDocumentString(`
    query FindLocationGroups($gameId: String = "") {
  groups: findGroups(gameId: $gameId) {
    id
    name
    color
  }
}
    `);

export const useFindLocationGroupsQuery = <
      TData = FindLocationGroupsQuery,
      TError = unknown
    >(
      variables?: FindLocationGroupsQueryVariables,
      options?: UseQueryOptions<FindLocationGroupsQuery, TError, TData>
    ) => {
    
    return useQuery<FindLocationGroupsQuery, TError, TData>(
      variables === undefined ? ['FindLocationGroups'] : ['FindLocationGroups', variables],
      fetchGenerated<FindLocationGroupsQuery, FindLocationGroupsQueryVariables>(FindLocationGroupsDocument, variables),
      options
    )};

export const LocationDetailsDocument = new TypedDocumentString(`
    query LocationDetails($input: GetLocationInput!) {
  locationDetails: getLocation(input: $input) {
    beatBoxNumber
    ...FLocationInfoBasic
    ...FLocationCoordinates
    ...FLocationDetails
  }
}
    fragment FLocationInfoBasic on Location {
  id
  type
  slug
  points
  gemType
  beatBoxNumber
  geo {
    isochrone
    nearest
    lamppost
  }
}
fragment FLocationCoordinates on Location {
  lng
  lat
}
fragment FLocationCore on Location {
  name
  isBonus
  description
  accessible
  what3words
}
fragment FLocationStatsFields on LocationStats {
  deviceID
  batteryLevel
  reported
}
fragment FLocationDetails on Location {
  ...FLocationCore
  stats {
    ...FLocationStatsFields
  }
}`);

export const useLocationDetailsQuery = <
      TData = LocationDetailsQuery,
      TError = unknown
    >(
      variables: LocationDetailsQueryVariables,
      options?: UseQueryOptions<LocationDetailsQuery, TError, TData>
    ) => {
    
    return useQuery<LocationDetailsQuery, TError, TData>(
      ['LocationDetails', variables],
      fetchGenerated<LocationDetailsQuery, LocationDetailsQueryVariables>(LocationDetailsDocument, variables),
      options
    )};

export const GetGroupDocument = new TypedDocumentString(`
    query GetGroup($input: GetGroup!) {
  details: getGroup(input: $input) {
    id
    name
    description
    color
  }
}
    `);

export const useGetGroupQuery = <
      TData = GetGroupQuery,
      TError = unknown
    >(
      variables: GetGroupQueryVariables,
      options?: UseQueryOptions<GetGroupQuery, TError, TData>
    ) => {
    
    return useQuery<GetGroupQuery, TError, TData>(
      ['GetGroup', variables],
      fetchGenerated<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, variables),
      options
    )};

export const FindGroupLocationsDocument = new TypedDocumentString(`
    query FindGroupLocations($input: FindGroupElements!) {
  locations: findGroupElements(input: $input) {
    locationId
  }
}
    `);

export const useFindGroupLocationsQuery = <
      TData = FindGroupLocationsQuery,
      TError = unknown
    >(
      variables: FindGroupLocationsQueryVariables,
      options?: UseQueryOptions<FindGroupLocationsQuery, TError, TData>
    ) => {
    
    return useQuery<FindGroupLocationsQuery, TError, TData>(
      ['FindGroupLocations', variables],
      fetchGenerated<FindGroupLocationsQuery, FindGroupLocationsQueryVariables>(FindGroupLocationsDocument, variables),
      options
    )};

export const OrsRuntimeArtifactGroupsDocument = new TypedDocumentString(`
    query OrsRuntimeArtifactGroups {
  orsRuntimeArtifactGroups {
    countryKey
    displayName
    artifacts {
      artifactPath
      countryKey
      createdAt
      displayName
    }
  }
}
    `);

export const useOrsRuntimeArtifactGroupsQuery = <
      TData = OrsRuntimeArtifactGroupsQuery,
      TError = unknown
    >(
      variables?: OrsRuntimeArtifactGroupsQueryVariables,
      options?: UseQueryOptions<OrsRuntimeArtifactGroupsQuery, TError, TData>
    ) => {
    
    return useQuery<OrsRuntimeArtifactGroupsQuery, TError, TData>(
      variables === undefined ? ['OrsRuntimeArtifactGroups'] : ['OrsRuntimeArtifactGroups', variables],
      fetchGenerated<OrsRuntimeArtifactGroupsQuery, OrsRuntimeArtifactGroupsQueryVariables>(OrsRuntimeArtifactGroupsDocument, variables),
      options
    )};

export const OrsRuntimeStatusDocument = new TypedDocumentString(`
    query OrsRuntimeStatus {
  orsRuntimeStatus {
    artifactKey
    artifactPath
    autoScalingGroupName
    configS3Uri
    currentCapacity
    desiredCapacity
    instanceId
    instanceState
    manifestCreatedAt
    orsHealthStatus
    scheduledStopAt
  }
}
    `);

export const useOrsRuntimeStatusQuery = <
      TData = OrsRuntimeStatusQuery,
      TError = unknown
    >(
      variables?: OrsRuntimeStatusQueryVariables,
      options?: UseQueryOptions<OrsRuntimeStatusQuery, TError, TData>
    ) => {
    
    return useQuery<OrsRuntimeStatusQuery, TError, TData>(
      variables === undefined ? ['OrsRuntimeStatus'] : ['OrsRuntimeStatus', variables],
      fetchGenerated<OrsRuntimeStatusQuery, OrsRuntimeStatusQueryVariables>(OrsRuntimeStatusDocument, variables),
      options
    )};

export const StartOrsRuntimeDocument = new TypedDocumentString(`
    mutation StartOrsRuntime($input: StartOrsRuntimeInput!) {
  startOrsRuntime(input: $input) {
    artifactKey
    artifactPath
    autoScalingGroupName
    configS3Uri
    currentCapacity
    desiredCapacity
    instanceId
    instanceState
    manifestCreatedAt
    orsHealthStatus
    scheduledStopAt
  }
}
    `);

export const useStartOrsRuntimeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartOrsRuntimeMutation, TError, StartOrsRuntimeMutationVariables, TContext>) => {
    
    return useMutation<StartOrsRuntimeMutation, TError, StartOrsRuntimeMutationVariables, TContext>(
      ['StartOrsRuntime'],
      (variables?: StartOrsRuntimeMutationVariables) => fetchGenerated<StartOrsRuntimeMutation, StartOrsRuntimeMutationVariables>(StartOrsRuntimeDocument, variables)(),
      options
    )};

export const StopOrsRuntimeDocument = new TypedDocumentString(`
    mutation StopOrsRuntime {
  stopOrsRuntime {
    autoScalingGroupName
    desiredCapacity
  }
}
    `);

export const useStopOrsRuntimeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StopOrsRuntimeMutation, TError, StopOrsRuntimeMutationVariables, TContext>) => {
    
    return useMutation<StopOrsRuntimeMutation, TError, StopOrsRuntimeMutationVariables, TContext>(
      ['StopOrsRuntime'],
      (variables?: StopOrsRuntimeMutationVariables) => fetchGenerated<StopOrsRuntimeMutation, StopOrsRuntimeMutationVariables>(StopOrsRuntimeDocument, variables)(),
      options
    )};

export const AssessLocationPlacementDocument = new TypedDocumentString(`
    query AssessLocationPlacement($gameId: String!, $lng: Float!, $lat: Float!, $selfId: String, $snap: Boolean) {
  assessMappingPlacement(
    gameId: $gameId
    lng: $lng
    lat: $lat
    selfId: $selfId
    snap: $snap
  ) {
    coord
    isochrone
    nearest
    isTooClose
  }
}
    `);

export const useAssessLocationPlacementQuery = <
      TData = AssessLocationPlacementQuery,
      TError = unknown
    >(
      variables: AssessLocationPlacementQueryVariables,
      options?: UseQueryOptions<AssessLocationPlacementQuery, TError, TData>
    ) => {
    
    return useQuery<AssessLocationPlacementQuery, TError, TData>(
      ['AssessLocationPlacement', variables],
      fetchGenerated<AssessLocationPlacementQuery, AssessLocationPlacementQueryVariables>(AssessLocationPlacementDocument, variables),
      options
    )};

export const MapWorkflowLocationsDocument = new TypedDocumentString(`
    query MapWorkflowLocations($gameId: String!) {
  mappingLocations(gameId: $gameId) {
    id
    name
    slug
    type
    isBonus
    beatBoxNumber
    gemType
    description
    mappingNotes
    reviewStatus
    publishedAt
    updatedAt
    selectedCandidateId
    points
    accessible
    ownerName
    what3words
    coordinates {
      lat
      lng
    }
    candidates {
      id
      lat
      lng
    }
    geo {
      lamppost
      nearest
    }
    reviews {
      id
      type
      status
      riskAssessment
      approvedAt
      updatedAt
    }
  }
}
    `);

export const useMapWorkflowLocationsQuery = <
      TData = MapWorkflowLocationsQuery,
      TError = unknown
    >(
      variables: MapWorkflowLocationsQueryVariables,
      options?: UseQueryOptions<MapWorkflowLocationsQuery, TError, TData>
    ) => {
    
    return useQuery<MapWorkflowLocationsQuery, TError, TData>(
      ['MapWorkflowLocations', variables],
      fetchGenerated<MapWorkflowLocationsQuery, MapWorkflowLocationsQueryVariables>(MapWorkflowLocationsDocument, variables),
      options
    )};

export const MappingWorkflowDocument = new TypedDocumentString(`
    query MappingWorkflow($gameId: String!) {
  mappingWorkflow(gameId: $gameId) {
    stage
    rounds {
      ...MappingRoundFields
    }
  }
}
    fragment MappingRoundFields on MappingRound {
  type
  locationIds
  openedAt
  openedBy {
    name
    email
  }
  passedAt
  passedBy {
    name
    email
  }
}`);

export const useMappingWorkflowQuery = <
      TData = MappingWorkflowQuery,
      TError = unknown
    >(
      variables: MappingWorkflowQueryVariables,
      options?: UseQueryOptions<MappingWorkflowQuery, TError, TData>
    ) => {
    
    return useQuery<MappingWorkflowQuery, TError, TData>(
      ['MappingWorkflow', variables],
      fetchGenerated<MappingWorkflowQuery, MappingWorkflowQueryVariables>(MappingWorkflowDocument, variables),
      options
    )};

export const SubmitMappingStageDocument = new TypedDocumentString(`
    mutation SubmitMappingStage($input: SubmitMappingStageInput!) {
  submitMappingStage(input: $input) {
    createdCount
    skippedCount
    failedLocationIds
    failedLayers
    workflow {
      stage
      rounds {
        ...MappingRoundFields
      }
    }
  }
}
    fragment MappingRoundFields on MappingRound {
  type
  locationIds
  openedAt
  openedBy {
    name
    email
  }
  passedAt
  passedBy {
    name
    email
  }
}`);

export const useSubmitMappingStageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitMappingStageMutation, TError, SubmitMappingStageMutationVariables, TContext>) => {
    
    return useMutation<SubmitMappingStageMutation, TError, SubmitMappingStageMutationVariables, TContext>(
      ['SubmitMappingStage'],
      (variables?: SubmitMappingStageMutationVariables) => fetchGenerated<SubmitMappingStageMutation, SubmitMappingStageMutationVariables>(SubmitMappingStageDocument, variables)(),
      options
    )};

export const InactiveTagsDocument = new TypedDocumentString(`
    query InactiveTags($input: FindInactiveTagInput!) {
  findInactiveTags(input: $input) {
    id
    playerId
    startDate
    endDate
    tagNumber
  }
}
    `);

export const useInactiveTagsQuery = <
      TData = InactiveTagsQuery,
      TError = unknown
    >(
      variables: InactiveTagsQueryVariables,
      options?: UseQueryOptions<InactiveTagsQuery, TError, TData>
    ) => {
    
    return useQuery<InactiveTagsQuery, TError, TData>(
      ['InactiveTags', variables],
      fetchGenerated<InactiveTagsQuery, InactiveTagsQueryVariables>(InactiveTagsDocument, variables),
      options
    )};

export const PlayerCreateInactiveTagDocument = new TypedDocumentString(`
    mutation PlayerCreateInactiveTag($input: InactiveTagCreateInput!) {
  createInactiveTag(input: $input) {
    id
  }
}
    `);

export const usePlayerCreateInactiveTagMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PlayerCreateInactiveTagMutation, TError, PlayerCreateInactiveTagMutationVariables, TContext>) => {
    
    return useMutation<PlayerCreateInactiveTagMutation, TError, PlayerCreateInactiveTagMutationVariables, TContext>(
      ['PlayerCreateInactiveTag'],
      (variables?: PlayerCreateInactiveTagMutationVariables) => fetchGenerated<PlayerCreateInactiveTagMutation, PlayerCreateInactiveTagMutationVariables>(PlayerCreateInactiveTagDocument, variables)(),
      options
    )};

export const PlayerRemoveInactiveTagDocument = new TypedDocumentString(`
    mutation PlayerRemoveInactiveTag($input: InactiveTagDeleteInput!) {
  removeInactiveTag(input: $input)
}
    `);

export const usePlayerRemoveInactiveTagMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PlayerRemoveInactiveTagMutation, TError, PlayerRemoveInactiveTagMutationVariables, TContext>) => {
    
    return useMutation<PlayerRemoveInactiveTagMutation, TError, PlayerRemoveInactiveTagMutationVariables, TContext>(
      ['PlayerRemoveInactiveTag'],
      (variables?: PlayerRemoveInactiveTagMutationVariables) => fetchGenerated<PlayerRemoveInactiveTagMutation, PlayerRemoveInactiveTagMutationVariables>(PlayerRemoveInactiveTagDocument, variables)(),
      options
    )};

export const CheckPlayerIdByEmailDocument = new TypedDocumentString(`
    query CheckPlayerIdByEmail($email: String!) {
  getPlayerByEmail(email: $email) {
    id
  }
}
    `);

export const useCheckPlayerIdByEmailQuery = <
      TData = CheckPlayerIdByEmailQuery,
      TError = unknown
    >(
      variables: CheckPlayerIdByEmailQueryVariables,
      options?: UseQueryOptions<CheckPlayerIdByEmailQuery, TError, TData>
    ) => {
    
    return useQuery<CheckPlayerIdByEmailQuery, TError, TData>(
      ['CheckPlayerIdByEmail', variables],
      fetchGenerated<CheckPlayerIdByEmailQuery, CheckPlayerIdByEmailQueryVariables>(CheckPlayerIdByEmailDocument, variables),
      options
    )};

export const MoveTagDocument = new TypedDocumentString(`
    mutation MoveTag($input: MovePlayerInput!) {
  moveTag(input: $input)
}
    `);

export const useMoveTagMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveTagMutation, TError, MoveTagMutationVariables, TContext>) => {
    
    return useMutation<MoveTagMutation, TError, MoveTagMutationVariables, TContext>(
      ['MoveTag'],
      (variables?: MoveTagMutationVariables) => fetchGenerated<MoveTagMutation, MoveTagMutationVariables>(MoveTagDocument, variables)(),
      options
    )};

export const StartDataExportDocument = new TypedDocumentString(`
    mutation StartDataExport($input: StartDataExportInput!) {
  startDataExport(input: $input) {
    jobId
    gameId
    exportType
    status
    s3Path
    downloadUrl
    filename
    mimeType
    error
    createdAt
    updatedAt
    expiredAt
  }
}
    `);

export const useStartDataExportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartDataExportMutation, TError, StartDataExportMutationVariables, TContext>) => {
    
    return useMutation<StartDataExportMutation, TError, StartDataExportMutationVariables, TContext>(
      ['StartDataExport'],
      (variables?: StartDataExportMutationVariables) => fetchGenerated<StartDataExportMutation, StartDataExportMutationVariables>(StartDataExportDocument, variables)(),
      options
    )};

export const GetDataExportJobDocument = new TypedDocumentString(`
    query GetDataExportJob($gameId: String!, $jobId: String!) {
  getDataExportJob(gameId: $gameId, jobId: $jobId) {
    jobId
    gameId
    exportType
    status
    s3Path
    downloadUrl
    filename
    mimeType
    error
    createdAt
    updatedAt
    expiredAt
  }
}
    `);

export const useGetDataExportJobQuery = <
      TData = GetDataExportJobQuery,
      TError = unknown
    >(
      variables: GetDataExportJobQueryVariables,
      options?: UseQueryOptions<GetDataExportJobQuery, TError, TData>
    ) => {
    
    return useQuery<GetDataExportJobQuery, TError, TData>(
      ['GetDataExportJob', variables],
      fetchGenerated<GetDataExportJobQuery, GetDataExportJobQueryVariables>(GetDataExportJobDocument, variables),
      options
    )};

export const FindDataExportJobsDocument = new TypedDocumentString(`
    query FindDataExportJobs($gameId: String!) {
  findDataExportJobs(gameId: $gameId) {
    jobId
    gameId
    exportType
    status
    s3Path
    downloadUrl
    filename
    mimeType
    error
    createdAt
    updatedAt
    expiredAt
  }
}
    `);

export const useFindDataExportJobsQuery = <
      TData = FindDataExportJobsQuery,
      TError = unknown
    >(
      variables: FindDataExportJobsQueryVariables,
      options?: UseQueryOptions<FindDataExportJobsQuery, TError, TData>
    ) => {
    
    return useQuery<FindDataExportJobsQuery, TError, TData>(
      ['FindDataExportJobs', variables],
      fetchGenerated<FindDataExportJobsQuery, FindDataExportJobsQueryVariables>(FindDataExportJobsDocument, variables),
      options
    )};

export const UpdatePlayerDocument = new TypedDocumentString(`
    mutation UpdatePlayer($input: FullUpdatePlayerInput!) {
  updatePlayer(input: $input) {
    id
  }
}
    `);

export const useUpdatePlayerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePlayerMutation, TError, UpdatePlayerMutationVariables, TContext>) => {
    
    return useMutation<UpdatePlayerMutation, TError, UpdatePlayerMutationVariables, TContext>(
      ['UpdatePlayer'],
      (variables?: UpdatePlayerMutationVariables) => fetchGenerated<UpdatePlayerMutation, UpdatePlayerMutationVariables>(UpdatePlayerDocument, variables)(),
      options
    )};

export const DeletePlayerDocument = new TypedDocumentString(`
    mutation DeletePlayer($playerId: String!) {
  deletePlayer(id: $playerId)
}
    `);

export const useDeletePlayerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeletePlayerMutation, TError, DeletePlayerMutationVariables, TContext>) => {
    
    return useMutation<DeletePlayerMutation, TError, DeletePlayerMutationVariables, TContext>(
      ['DeletePlayer'],
      (variables?: DeletePlayerMutationVariables) => fetchGenerated<DeletePlayerMutation, DeletePlayerMutationVariables>(DeletePlayerDocument, variables)(),
      options
    )};

export const UpdatePlayerPointsDocument = new TypedDocumentString(`
    mutation UpdatePlayerPoints($input: IncrementPlayerPoint!) {
  updatePlayerPoints(input: $input)
}
    `);

export const useUpdatePlayerPointsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePlayerPointsMutation, TError, UpdatePlayerPointsMutationVariables, TContext>) => {
    
    return useMutation<UpdatePlayerPointsMutation, TError, UpdatePlayerPointsMutationVariables, TContext>(
      ['UpdatePlayerPoints'],
      (variables?: UpdatePlayerPointsMutationVariables) => fetchGenerated<UpdatePlayerPointsMutation, UpdatePlayerPointsMutationVariables>(UpdatePlayerPointsDocument, variables)(),
      options
    )};

export const PlayerJoinTeamDocument = new TypedDocumentString(`
    mutation PlayerJoinTeam($input: JoinTeamInput!) {
  joinTeam(input: $input)
}
    `);

export const usePlayerJoinTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PlayerJoinTeamMutation, TError, PlayerJoinTeamMutationVariables, TContext>) => {
    
    return useMutation<PlayerJoinTeamMutation, TError, PlayerJoinTeamMutationVariables, TContext>(
      ['PlayerJoinTeam'],
      (variables?: PlayerJoinTeamMutationVariables) => fetchGenerated<PlayerJoinTeamMutation, PlayerJoinTeamMutationVariables>(PlayerJoinTeamDocument, variables)(),
      options
    )};

export const CreatePlayerTagDocument = new TypedDocumentString(`
    mutation CreatePlayerTag($input: PlayerTagCreateInput!) {
  assignTag(input: $input) {
    deviceID
  }
}
    `);

export const useCreatePlayerTagMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePlayerTagMutation, TError, CreatePlayerTagMutationVariables, TContext>) => {
    
    return useMutation<CreatePlayerTagMutation, TError, CreatePlayerTagMutationVariables, TContext>(
      ['CreatePlayerTag'],
      (variables?: CreatePlayerTagMutationVariables) => fetchGenerated<CreatePlayerTagMutation, CreatePlayerTagMutationVariables>(CreatePlayerTagDocument, variables)(),
      options
    )};

export const PlayersListTableDocument = new TypedDocumentString(`
    query PlayersListTable($gameId: String = "") {
  findPlayers(gameId: $gameId) {
    id
    tags {
      tagType
      tagNumber
    }
    profile {
      isRegistered
    }
    ...FPlayerInfo
    ...FPlayerRole
    ...FPlayerPoint
  }
}
    fragment FPlayerPointContext on PlayerPoint {
  all
  routes
  gems
  extra
  mileage
}
fragment FPlayerPoint on Player {
  points {
    ...FPlayerPointContext
  }
}
fragment FPlayerInfoContext on PlayerInfo {
  gameId
  teamId
  publicName
  avatar
}
fragment FPlayerInfo on Player {
  info {
    ...FPlayerInfoContext
  }
}
fragment FPlayerRoleContext on PlayerRole {
  isChild
  parentId
  isAnonymous
  authID
  removedAt
}
fragment FPlayerRole on Player {
  role {
    ...FPlayerRoleContext
  }
}`);

export const usePlayersListTableQuery = <
      TData = PlayersListTableQuery,
      TError = unknown
    >(
      variables?: PlayersListTableQueryVariables,
      options?: UseQueryOptions<PlayersListTableQuery, TError, TData>
    ) => {
    
    return useQuery<PlayersListTableQuery, TError, TData>(
      variables === undefined ? ['PlayersListTable'] : ['PlayersListTable', variables],
      fetchGenerated<PlayersListTableQuery, PlayersListTableQueryVariables>(PlayersListTableDocument, variables),
      options
    )};

export const PlayerListLeaderboardDocument = new TypedDocumentString(`
    query PlayerListLeaderboard($input: GetPlayerLeaderboardsInput!) {
  getPlayerLeaderboards(input: $input) {
    data {
      id
      amount
      name
    }
  }
}
    `);

export const usePlayerListLeaderboardQuery = <
      TData = PlayerListLeaderboardQuery,
      TError = unknown
    >(
      variables: PlayerListLeaderboardQueryVariables,
      options?: UseQueryOptions<PlayerListLeaderboardQuery, TError, TData>
    ) => {
    
    return useQuery<PlayerListLeaderboardQuery, TError, TData>(
      ['PlayerListLeaderboard', variables],
      fetchGenerated<PlayerListLeaderboardQuery, PlayerListLeaderboardQueryVariables>(PlayerListLeaderboardDocument, variables),
      options
    )};

export const FindPlayersListDocument = new TypedDocumentString(`
    query FindPlayersList($input: PlayersListInput!) {
  findPlayerList(input: $input) {
    id
    all
    isAnonymous
  }
}
    `);

export const useFindPlayersListQuery = <
      TData = FindPlayersListQuery,
      TError = unknown
    >(
      variables: FindPlayersListQueryVariables,
      options?: UseQueryOptions<FindPlayersListQuery, TError, TData>
    ) => {
    
    return useQuery<FindPlayersListQuery, TError, TData>(
      ['FindPlayersList', variables],
      fetchGenerated<FindPlayersListQuery, FindPlayersListQueryVariables>(FindPlayersListDocument, variables),
      options
    )};

export const PlayerGameTeamsDocument = new TypedDocumentString(`
    query PlayerGameTeams($input: FindTeamsInput!) {
  teams: findTeams(input: $input) {
    id
    name
  }
}
    `);

export const usePlayerGameTeamsQuery = <
      TData = PlayerGameTeamsQuery,
      TError = unknown
    >(
      variables: PlayerGameTeamsQueryVariables,
      options?: UseQueryOptions<PlayerGameTeamsQuery, TError, TData>
    ) => {
    
    return useQuery<PlayerGameTeamsQuery, TError, TData>(
      ['PlayerGameTeams', variables],
      fetchGenerated<PlayerGameTeamsQuery, PlayerGameTeamsQueryVariables>(PlayerGameTeamsDocument, variables),
      options
    )};

export const PlayerRoutesDocument = new TypedDocumentString(`
    query PlayerRoutes($playerId: String!) {
  getPlayer(id: $playerId) {
    routes {
      __typename
      id
      tagNumber
      locationId
      locationSlug
      swipeTimestamp
      swipeId
      points
    }
    gemRoutes {
      __typename
      id
      tagNumber
      locationId
      locationSlug
      timestamp
      points
      gemType
    }
  }
}
    `);

export const usePlayerRoutesQuery = <
      TData = PlayerRoutesQuery,
      TError = unknown
    >(
      variables: PlayerRoutesQueryVariables,
      options?: UseQueryOptions<PlayerRoutesQuery, TError, TData>
    ) => {
    
    return useQuery<PlayerRoutesQuery, TError, TData>(
      ['PlayerRoutes', variables],
      fetchGenerated<PlayerRoutesQuery, PlayerRoutesQueryVariables>(PlayerRoutesDocument, variables),
      options
    )};

export const PlayerLuckySwipesDocument = new TypedDocumentString(`
    query PlayerLuckySwipes($playerId: String!, $gameId: String!) {
  getPlayerLuckySwipes(playerId: $playerId, gameId: $gameId) {
    id
    tagNumber
    locationId
    locationName
    timestamp
    isLucky
    extraPoints
    status
  }
}
    `);

export const usePlayerLuckySwipesQuery = <
      TData = PlayerLuckySwipesQuery,
      TError = unknown
    >(
      variables: PlayerLuckySwipesQueryVariables,
      options?: UseQueryOptions<PlayerLuckySwipesQuery, TError, TData>
    ) => {
    
    return useQuery<PlayerLuckySwipesQuery, TError, TData>(
      ['PlayerLuckySwipes', variables],
      fetchGenerated<PlayerLuckySwipesQuery, PlayerLuckySwipesQueryVariables>(PlayerLuckySwipesDocument, variables),
      options
    )};

export const PlayerRawSwipesDocument = new TypedDocumentString(`
    query PlayerRawSwipes($input: FindByTag!) {
  findSwipeByTag(input: $input) {
    id
    tagNumber
    locationName
    timestamp
    status
    locationId
    sourceMetadata
    wtuLat
    wtuLng
    invalidationReason
    reason
    isLucky
  }
}
    `);

export const usePlayerRawSwipesQuery = <
      TData = PlayerRawSwipesQuery,
      TError = unknown
    >(
      variables: PlayerRawSwipesQueryVariables,
      options?: UseQueryOptions<PlayerRawSwipesQuery, TError, TData>
    ) => {
    
    return useQuery<PlayerRawSwipesQuery, TError, TData>(
      ['PlayerRawSwipes', variables],
      fetchGenerated<PlayerRawSwipesQuery, PlayerRawSwipesQueryVariables>(PlayerRawSwipesDocument, variables),
      options
    )};

export const FindPlayerSurveysDocument = new TypedDocumentString(`
    query FindPlayerSurveys($playerId: String!, $gameId: String!) {
  findPlayerSurveys(playerId: $playerId, gameId: $gameId) {
    isConfirmed
    active
    bame
    disability
    condition
    surveyType
    confirmedDate
    createdAt
    status
  }
}
    `);

export const useFindPlayerSurveysQuery = <
      TData = FindPlayerSurveysQuery,
      TError = unknown
    >(
      variables: FindPlayerSurveysQueryVariables,
      options?: UseQueryOptions<FindPlayerSurveysQuery, TError, TData>
    ) => {
    
    return useQuery<FindPlayerSurveysQuery, TError, TData>(
      ['FindPlayerSurveys', variables],
      fetchGenerated<FindPlayerSurveysQuery, FindPlayerSurveysQueryVariables>(FindPlayerSurveysDocument, variables),
      options
    )};

export const PlayerLeaveTeamDocument = new TypedDocumentString(`
    mutation PlayerLeaveTeam($playerId: String!) {
  leaveTeam(playerId: $playerId)
}
    `);

export const usePlayerLeaveTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PlayerLeaveTeamMutation, TError, PlayerLeaveTeamMutationVariables, TContext>) => {
    
    return useMutation<PlayerLeaveTeamMutation, TError, PlayerLeaveTeamMutationVariables, TContext>(
      ['PlayerLeaveTeam'],
      (variables?: PlayerLeaveTeamMutationVariables) => fetchGenerated<PlayerLeaveTeamMutation, PlayerLeaveTeamMutationVariables>(PlayerLeaveTeamDocument, variables)(),
      options
    )};

export const GetGameByIdDocument = new TypedDocumentString(`
    query GetGameById($id: String!) {
  getGame(id: $id) {
    id
    info {
      name
    }
  }
}
    `);

export const useGetGameByIdQuery = <
      TData = GetGameByIdQuery,
      TError = unknown
    >(
      variables: GetGameByIdQueryVariables,
      options?: UseQueryOptions<GetGameByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetGameByIdQuery, TError, TData>(
      ['GetGameById', variables],
      fetchGenerated<GetGameByIdQuery, GetGameByIdQueryVariables>(GetGameByIdDocument, variables),
      options
    )};

export const GetPlayersForPaginatedListDocument = new TypedDocumentString(`
    query GetPlayersForPaginatedList($input: GetForPaginatedListInput!) {
  getPlayersForPaginatedList(input: $input) {
    id
    tags {
      tagType
      tagNumber
    }
    profile {
      isRegistered
    }
    ...FPlayerInfo
    ...FPlayerRole
    ...FPlayerPoint
  }
}
    fragment FPlayerPointContext on PlayerPoint {
  all
  routes
  gems
  extra
  mileage
}
fragment FPlayerPoint on Player {
  points {
    ...FPlayerPointContext
  }
}
fragment FPlayerInfoContext on PlayerInfo {
  gameId
  teamId
  publicName
  avatar
}
fragment FPlayerInfo on Player {
  info {
    ...FPlayerInfoContext
  }
}
fragment FPlayerRoleContext on PlayerRole {
  isChild
  parentId
  isAnonymous
  authID
  removedAt
}
fragment FPlayerRole on Player {
  role {
    ...FPlayerRoleContext
  }
}`);

export const useGetPlayersForPaginatedListQuery = <
      TData = GetPlayersForPaginatedListQuery,
      TError = unknown
    >(
      variables: GetPlayersForPaginatedListQueryVariables,
      options?: UseQueryOptions<GetPlayersForPaginatedListQuery, TError, TData>
    ) => {
    
    return useQuery<GetPlayersForPaginatedListQuery, TError, TData>(
      ['GetPlayersForPaginatedList', variables],
      fetchGenerated<GetPlayersForPaginatedListQuery, GetPlayersForPaginatedListQueryVariables>(GetPlayersForPaginatedListDocument, variables),
      options
    )};

export const SearchPlayerInGameDocument = new TypedDocumentString(`
    query SearchPlayerInGame($input: SearchPlayerByInput!) {
  getPlayerBy(input: $input) {
    id
    tags {
      tagType
      tagNumber
    }
    profile {
      isRegistered
    }
    ...FPlayerInfo
    ...FPlayerRole
    ...FPlayerPoint
  }
}
    fragment FPlayerPointContext on PlayerPoint {
  all
  routes
  gems
  extra
  mileage
}
fragment FPlayerPoint on Player {
  points {
    ...FPlayerPointContext
  }
}
fragment FPlayerInfoContext on PlayerInfo {
  gameId
  teamId
  publicName
  avatar
}
fragment FPlayerInfo on Player {
  info {
    ...FPlayerInfoContext
  }
}
fragment FPlayerRoleContext on PlayerRole {
  isChild
  parentId
  isAnonymous
  authID
  removedAt
}
fragment FPlayerRole on Player {
  role {
    ...FPlayerRoleContext
  }
}`);

export const useSearchPlayerInGameQuery = <
      TData = SearchPlayerInGameQuery,
      TError = unknown
    >(
      variables: SearchPlayerInGameQueryVariables,
      options?: UseQueryOptions<SearchPlayerInGameQuery, TError, TData>
    ) => {
    
    return useQuery<SearchPlayerInGameQuery, TError, TData>(
      ['SearchPlayerInGame', variables],
      fetchGenerated<SearchPlayerInGameQuery, SearchPlayerInGameQueryVariables>(SearchPlayerInGameDocument, variables),
      options
    )};

export const KickFromGameDocument = new TypedDocumentString(`
    mutation KickFromGame($playerId: String!) {
  kickFromGame(id: $playerId)
}
    `);

export const useKickFromGameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<KickFromGameMutation, TError, KickFromGameMutationVariables, TContext>) => {
    
    return useMutation<KickFromGameMutation, TError, KickFromGameMutationVariables, TContext>(
      ['KickFromGame'],
      (variables?: KickFromGameMutationVariables) => fetchGenerated<KickFromGameMutation, KickFromGameMutationVariables>(KickFromGameDocument, variables)(),
      options
    )};

export const RemovePlayersFromGameDocument = new TypedDocumentString(`
    mutation RemovePlayersFromGame($gameId: String!) {
  removePlayersFromGame(gameId: $gameId)
}
    `);

export const useRemovePlayersFromGameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemovePlayersFromGameMutation, TError, RemovePlayersFromGameMutationVariables, TContext>) => {
    
    return useMutation<RemovePlayersFromGameMutation, TError, RemovePlayersFromGameMutationVariables, TContext>(
      ['RemovePlayersFromGame'],
      (variables?: RemovePlayersFromGameMutationVariables) => fetchGenerated<RemovePlayersFromGameMutation, RemovePlayersFromGameMutationVariables>(RemovePlayersFromGameDocument, variables)(),
      options
    )};

export const FindGameResourcesDocument = new TypedDocumentString(`
    query FindGameResources($gameId: String!) {
  findGameResources(gameId: $gameId) {
    key
    title
    available
    unavailableReason
  }
}
    `);

export const useFindGameResourcesQuery = <
      TData = FindGameResourcesQuery,
      TError = unknown
    >(
      variables: FindGameResourcesQueryVariables,
      options?: UseQueryOptions<FindGameResourcesQuery, TError, TData>
    ) => {
    
    return useQuery<FindGameResourcesQuery, TError, TData>(
      ['FindGameResources', variables],
      fetchGenerated<FindGameResourcesQuery, FindGameResourcesQueryVariables>(FindGameResourcesDocument, variables),
      options
    )};

export const GenerateGameResourcePdfDocument = new TypedDocumentString(`
    mutation GenerateGameResourcePdf($input: GenerateGameResourcePdfInput!) {
  generateGameResourcePdf(input: $input) {
    jobId
    gameId
    status
    s3Path
    downloadUrl
    filename
    mimeType
    error
    createdAt
    updatedAt
  }
}
    `);

export const useGenerateGameResourcePdfMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateGameResourcePdfMutation, TError, GenerateGameResourcePdfMutationVariables, TContext>) => {
    
    return useMutation<GenerateGameResourcePdfMutation, TError, GenerateGameResourcePdfMutationVariables, TContext>(
      ['GenerateGameResourcePdf'],
      (variables?: GenerateGameResourcePdfMutationVariables) => fetchGenerated<GenerateGameResourcePdfMutation, GenerateGameResourcePdfMutationVariables>(GenerateGameResourcePdfDocument, variables)(),
      options
    )};

export const GetPdfGenerationJobDocument = new TypedDocumentString(`
    query GetPdfGenerationJob($gameId: String!, $jobId: String!) {
  getPdfGenerationJob(gameId: $gameId, jobId: $jobId) {
    jobId
    gameId
    status
    s3Path
    downloadUrl
    filename
    mimeType
    error
    createdAt
    updatedAt
  }
}
    `);

export const useGetPdfGenerationJobQuery = <
      TData = GetPdfGenerationJobQuery,
      TError = unknown
    >(
      variables: GetPdfGenerationJobQueryVariables,
      options?: UseQueryOptions<GetPdfGenerationJobQuery, TError, TData>
    ) => {
    
    return useQuery<GetPdfGenerationJobQuery, TError, TData>(
      ['GetPdfGenerationJob', variables],
      fetchGenerated<GetPdfGenerationJobQuery, GetPdfGenerationJobQueryVariables>(GetPdfGenerationJobDocument, variables),
      options
    )};

export const UpdateGameDocument = new TypedDocumentString(`
    mutation UpdateGame($input: UpdateGameInput!) {
  updateGame(input: $input) {
    id
    info {
      slug
    }
  }
}
    `);

export const useUpdateGameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGameMutation, TError, UpdateGameMutationVariables, TContext>) => {
    
    return useMutation<UpdateGameMutation, TError, UpdateGameMutationVariables, TContext>(
      ['UpdateGame'],
      (variables?: UpdateGameMutationVariables) => fetchGenerated<UpdateGameMutation, UpdateGameMutationVariables>(UpdateGameDocument, variables)(),
      options
    )};

export const DeleteGameDocument = new TypedDocumentString(`
    mutation DeleteGame($input: DeleteGameInput!) {
  deleteGame(input: $input)
}
    `);

export const useDeleteGameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteGameMutation, TError, DeleteGameMutationVariables, TContext>) => {
    
    return useMutation<DeleteGameMutation, TError, DeleteGameMutationVariables, TContext>(
      ['DeleteGame'],
      (variables?: DeleteGameMutationVariables) => fetchGenerated<DeleteGameMutation, DeleteGameMutationVariables>(DeleteGameDocument, variables)(),
      options
    )};

export const GetGameWithSurveysDocument = new TypedDocumentString(`
    query GetGameWithSurveys($slug: String!) {
  getGameBySlug(slug: $slug) {
    id
    info {
      ...FGameInfoSurveys
      ...FGameInfoSettings
    }
  }
}
    fragment FGameInfoSettings on GameInfo {
  region
  settings {
    minSwipeTime
    timezone
    city
    lat
    lon
    target
    targetZones
    locationDistanceMeters
    beatBoxPlacementValidationEnabled
    POIName
    collectPartnerConsentForAges13To17
    luckyTapEnabled
    luckyTapFrequency
    luckyTapPoints
    mappingApprovalsRequired
    mappingPostRequired
    targetBeatBoxCount
  }
}
fragment FGameInfoSurveys on GameInfo {
  surveys {
    tellUsAboutYou {
      surveyID
      link
      surveyName
      validationStatus
      lastValidated
    }
    closing {
      surveyID
      link
      surveyName
      validationStatus
      lastValidated
      shownFromDate
      isAutoSend
      sendDaysBeforeEnd
    }
    sixMonths {
      surveyID
      link
      surveyName
      validationStatus
      lastValidated
      sendDate
      isAutoSend
    }
    oneYear {
      surveyID
      link
      surveyName
      validationStatus
      lastValidated
      sendDate
      isAutoSend
    }
  }
}`);

export const useGetGameWithSurveysQuery = <
      TData = GetGameWithSurveysQuery,
      TError = unknown
    >(
      variables: GetGameWithSurveysQueryVariables,
      options?: UseQueryOptions<GetGameWithSurveysQuery, TError, TData>
    ) => {
    
    return useQuery<GetGameWithSurveysQuery, TError, TData>(
      ['GetGameWithSurveys', variables],
      fetchGenerated<GetGameWithSurveysQuery, GetGameWithSurveysQueryVariables>(GetGameWithSurveysDocument, variables),
      options
    )};

export const AdminValidateSurveyDocument = new TypedDocumentString(`
    mutation AdminValidateSurvey($input: AdminValidateSurvey!) {
  validateSurvey(input: $input) {
    childrenAnswers {
      ...FAnswer
    }
    adultAnswers {
      ...FAnswer
    }
    childrenQuestions {
      ...FQuestion
    }
    adultQuestions {
      ...FQuestion
    }
    extraQuestions {
      condition {
        status
        message
      }
      bame {
        status
        message
      }
      disability {
        status
        message
      }
    }
    surveyTitle
    surveyLink
  }
}
    fragment FAnswer on ValidateAnswers {
  days {
    status
    errors
  }
  minutes {
    status
    errors
  }
  hours {
    status
    errors
  }
  flag {
    status
    errors
  }
}
fragment FQuestion on ValidateQuestions {
  days {
    status
    message
  }
  minutes {
    status
    message
  }
  hours {
    status
    message
  }
  flag {
    status
    message
  }
}`);

export const useAdminValidateSurveyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AdminValidateSurveyMutation, TError, AdminValidateSurveyMutationVariables, TContext>) => {
    
    return useMutation<AdminValidateSurveyMutation, TError, AdminValidateSurveyMutationVariables, TContext>(
      ['AdminValidateSurvey'],
      (variables?: AdminValidateSurveyMutationVariables) => fetchGenerated<AdminValidateSurveyMutation, AdminValidateSurveyMutationVariables>(AdminValidateSurveyDocument, variables)(),
      options
    )};

export const AdminSearchSurveysDocument = new TypedDocumentString(`
    mutation AdminSearchSurveys($input: AdminSearchSurveys!) {
  searchSurveys(input: $input) {
    id
    title
    link
    dateCreated
    dateModified
  }
}
    `);

export const useAdminSearchSurveysMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AdminSearchSurveysMutation, TError, AdminSearchSurveysMutationVariables, TContext>) => {
    
    return useMutation<AdminSearchSurveysMutation, TError, AdminSearchSurveysMutationVariables, TContext>(
      ['AdminSearchSurveys'],
      (variables?: AdminSearchSurveysMutationVariables) => fetchGenerated<AdminSearchSurveysMutation, AdminSearchSurveysMutationVariables>(AdminSearchSurveysDocument, variables)(),
      options
    )};

export const AllTeamsDocument = new TypedDocumentString(`
    query AllTeams($input: FindTeamsInput!) {
  findTeams(input: $input) {
    id
  }
}
    `);

export const useAllTeamsQuery = <
      TData = AllTeamsQuery,
      TError = unknown
    >(
      variables: AllTeamsQueryVariables,
      options?: UseQueryOptions<AllTeamsQuery, TError, TData>
    ) => {
    
    return useQuery<AllTeamsQuery, TError, TData>(
      ['AllTeams', variables],
      fetchGenerated<AllTeamsQuery, AllTeamsQueryVariables>(AllTeamsDocument, variables),
      options
    )};

export const AllSwipesDocument = new TypedDocumentString(`
    query AllSwipes($input: FindSwipeByDateRange!) {
  findSwipeByDateRange(input: $input) {
    id
    tagNumber
    locationName
    timestamp
    status
    locationId
    sourceMetadata
    wtuLat
    wtuLng
  }
}
    `);

export const useAllSwipesQuery = <
      TData = AllSwipesQuery,
      TError = unknown
    >(
      variables: AllSwipesQueryVariables,
      options?: UseQueryOptions<AllSwipesQuery, TError, TData>
    ) => {
    
    return useQuery<AllSwipesQuery, TError, TData>(
      ['AllSwipes', variables],
      fetchGenerated<AllSwipesQuery, AllSwipesQueryVariables>(AllSwipesDocument, variables),
      options
    )};

export const AdminGetSurveyLinkDocument = new TypedDocumentString(`
    mutation AdminGetSurveyLink($input: AdminGetSurveyLink!) {
  getSurveyLink(input: $input)
}
    `);

export const useAdminGetSurveyLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AdminGetSurveyLinkMutation, TError, AdminGetSurveyLinkMutationVariables, TContext>) => {
    
    return useMutation<AdminGetSurveyLinkMutation, TError, AdminGetSurveyLinkMutationVariables, TContext>(
      ['AdminGetSurveyLink'],
      (variables?: AdminGetSurveyLinkMutationVariables) => fetchGenerated<AdminGetSurveyLinkMutation, AdminGetSurveyLinkMutationVariables>(AdminGetSurveyLinkDocument, variables)(),
      options
    )};

export const CreateTeamDocument = new TypedDocumentString(`
    mutation CreateTeam($input: TeamCreateInput!) {
  createTeam(input: $input) {
    id
  }
}
    `);

export const useCreateTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTeamMutation, TError, CreateTeamMutationVariables, TContext>) => {
    
    return useMutation<CreateTeamMutation, TError, CreateTeamMutationVariables, TContext>(
      ['CreateTeam'],
      (variables?: CreateTeamMutationVariables) => fetchGenerated<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, variables)(),
      options
    )};

export const UpdateTeamDocument = new TypedDocumentString(`
    mutation UpdateTeam($input: TeamUpdateInput!) {
  updateTeam(input: $input) {
    id
  }
}
    `);

export const useUpdateTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTeamMutation, TError, UpdateTeamMutationVariables, TContext>) => {
    
    return useMutation<UpdateTeamMutation, TError, UpdateTeamMutationVariables, TContext>(
      ['UpdateTeam'],
      (variables?: UpdateTeamMutationVariables) => fetchGenerated<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, variables)(),
      options
    )};

export const DeleteTeamDocument = new TypedDocumentString(`
    mutation DeleteTeam($input: TeamDeleteInput!) {
  deleteTeam(input: $input)
}
    `);

export const useDeleteTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTeamMutation, TError, DeleteTeamMutationVariables, TContext>) => {
    
    return useMutation<DeleteTeamMutation, TError, DeleteTeamMutationVariables, TContext>(
      ['DeleteTeam'],
      (variables?: DeleteTeamMutationVariables) => fetchGenerated<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, variables)(),
      options
    )};

export const TeamsListTableDocument = new TypedDocumentString(`
    query TeamsListTable($input: FindTeamsInput!) {
  teams: findTeams(input: $input) {
    ...FTeamBasic
    ...FTeamStats
  }
}
    fragment FTeamBasic on Team {
  id
  name
  type
  status
  leaderboardId
}
fragment FTeamStats on Team {
  all
  mileage
  totalMembers
  gems
  extra
}`);

export const useTeamsListTableQuery = <
      TData = TeamsListTableQuery,
      TError = unknown
    >(
      variables: TeamsListTableQueryVariables,
      options?: UseQueryOptions<TeamsListTableQuery, TError, TData>
    ) => {
    
    return useQuery<TeamsListTableQuery, TError, TData>(
      ['TeamsListTable', variables],
      fetchGenerated<TeamsListTableQuery, TeamsListTableQueryVariables>(TeamsListTableDocument, variables),
      options
    )};

export const TeamsWithDetailsDocument = new TypedDocumentString(`
    query TeamsWithDetails($input: FindTeamsInput!) {
  teamsWithDetails: findTeams(input: $input) {
    id
    name
    type
    gameId
    details {
      id
      description
      rollNumber
    }
  }
}
    `);

export const useTeamsWithDetailsQuery = <
      TData = TeamsWithDetailsQuery,
      TError = unknown
    >(
      variables: TeamsWithDetailsQueryVariables,
      options?: UseQueryOptions<TeamsWithDetailsQuery, TError, TData>
    ) => {
    
    return useQuery<TeamsWithDetailsQuery, TError, TData>(
      ['TeamsWithDetails', variables],
      fetchGenerated<TeamsWithDetailsQuery, TeamsWithDetailsQueryVariables>(TeamsWithDetailsDocument, variables),
      options
    )};

export const GetTeamFullDocument = new TypedDocumentString(`
    query GetTeamFull($input: GetTeamInput!) {
  team: getTeam(input: $input) {
    ...FTeam
  }
}
    fragment FTeamBasic on Team {
  id
  name
  type
  status
  leaderboardId
}
fragment FTeamRanges on Team {
  subranges {
    from
    to
  }
}
fragment FTeamStats on Team {
  all
  mileage
  totalMembers
  gems
  extra
}
fragment FTeamDetails on Team {
  details {
    description
    rejectionReason
    rollNumber
    leaders
    leadersEmails
  }
}
fragment FTeamRest on Team {
  gameId
  leaderboardId
  routes
}
fragment FTeam on Team {
  ...FTeamBasic
  ...FTeamRanges
  ...FTeamStats
  ...FTeamRest
  ...FTeamDetails
}`);

export const useGetTeamFullQuery = <
      TData = GetTeamFullQuery,
      TError = unknown
    >(
      variables: GetTeamFullQueryVariables,
      options?: UseQueryOptions<GetTeamFullQuery, TError, TData>
    ) => {
    
    return useQuery<GetTeamFullQuery, TError, TData>(
      ['GetTeamFull', variables],
      fetchGenerated<GetTeamFullQuery, GetTeamFullQueryVariables>(GetTeamFullDocument, variables),
      options
    )};

export const GetTeamLeaderboardDocument = new TypedDocumentString(`
    query GetTeamLeaderboard($id: String = "", $gameId: String = "") {
  leaderboard: getLeaderboard(id: $id, gameId: $gameId) {
    name
    teamTypes
  }
}
    `);

export const useGetTeamLeaderboardQuery = <
      TData = GetTeamLeaderboardQuery,
      TError = unknown
    >(
      variables?: GetTeamLeaderboardQueryVariables,
      options?: UseQueryOptions<GetTeamLeaderboardQuery, TError, TData>
    ) => {
    
    return useQuery<GetTeamLeaderboardQuery, TError, TData>(
      variables === undefined ? ['GetTeamLeaderboard'] : ['GetTeamLeaderboard', variables],
      fetchGenerated<GetTeamLeaderboardQuery, GetTeamLeaderboardQueryVariables>(GetTeamLeaderboardDocument, variables),
      options
    )};

export const TeamPlayersListTableDocument = new TypedDocumentString(`
    query TeamPlayersListTable($gameId: String = "", $teamId: String!) {
  findPlayers(gameId: $gameId, teamId: $teamId) {
    id
    tags {
      tagType
      tagNumber
    }
    ...FPlayerInfo
    ...FPlayerProfile
    ...FPlayerRole
    ...FPlayerPoint
  }
}
    fragment FPlayerPointContext on PlayerPoint {
  all
  routes
  gems
  extra
  mileage
}
fragment FPlayerPoint on Player {
  points {
    ...FPlayerPointContext
  }
}
fragment FPlayerProfileContext on PlayerProfile {
  firstName
  email
  birthDate
  gender
  isRegistered
  ageGroup
}
fragment FPlayerProfile on Player {
  profile {
    ...FPlayerProfileContext
  }
}
fragment FPlayerInfoContext on PlayerInfo {
  gameId
  teamId
  publicName
  avatar
}
fragment FPlayerInfo on Player {
  info {
    ...FPlayerInfoContext
  }
}
fragment FPlayerRoleContext on PlayerRole {
  isChild
  parentId
  isAnonymous
  authID
  removedAt
}
fragment FPlayerRole on Player {
  role {
    ...FPlayerRoleContext
  }
}`);

export const useTeamPlayersListTableQuery = <
      TData = TeamPlayersListTableQuery,
      TError = unknown
    >(
      variables: TeamPlayersListTableQueryVariables,
      options?: UseQueryOptions<TeamPlayersListTableQuery, TError, TData>
    ) => {
    
    return useQuery<TeamPlayersListTableQuery, TError, TData>(
      ['TeamPlayersListTable', variables],
      fetchGenerated<TeamPlayersListTableQuery, TeamPlayersListTableQueryVariables>(TeamPlayersListTableDocument, variables),
      options
    )};

export const GetLeaderInfoDocument = new TypedDocumentString(`
    query GetLeaderInfo($id: String!) {
  getPlayer(id: $id) {
    info {
      id
      publicName
      gameId
    }
    profile {
      email
    }
  }
}
    `);

export const useGetLeaderInfoQuery = <
      TData = GetLeaderInfoQuery,
      TError = unknown
    >(
      variables: GetLeaderInfoQueryVariables,
      options?: UseQueryOptions<GetLeaderInfoQuery, TError, TData>
    ) => {
    
    return useQuery<GetLeaderInfoQuery, TError, TData>(
      ['GetLeaderInfo', variables],
      fetchGenerated<GetLeaderInfoQuery, GetLeaderInfoQueryVariables>(GetLeaderInfoDocument, variables),
      options
    )};

export const FindTeamNamesDocument = new TypedDocumentString(`
    query FindTeamNames($input: FindTeamsInput!) {
  findTeamNames(input: $input) {
    teamNames
  }
}
    `);

export const useFindTeamNamesQuery = <
      TData = FindTeamNamesQuery,
      TError = unknown
    >(
      variables: FindTeamNamesQueryVariables,
      options?: UseQueryOptions<FindTeamNamesQuery, TError, TData>
    ) => {
    
    return useQuery<FindTeamNamesQuery, TError, TData>(
      ['FindTeamNames', variables],
      fetchGenerated<FindTeamNamesQuery, FindTeamNamesQueryVariables>(FindTeamNamesDocument, variables),
      options
    )};

export const FindAllTeamsDocument = new TypedDocumentString(`
    query FindAllTeams($input: FindTeamsInput!) {
  findTeams(input: $input) {
    id
    name
    type
    status
    all
    totalMembers
    details {
      rollNumber
    }
  }
}
    `);

export const useFindAllTeamsQuery = <
      TData = FindAllTeamsQuery,
      TError = unknown
    >(
      variables: FindAllTeamsQueryVariables,
      options?: UseQueryOptions<FindAllTeamsQuery, TError, TData>
    ) => {
    
    return useQuery<FindAllTeamsQuery, TError, TData>(
      ['FindAllTeams', variables],
      fetchGenerated<FindAllTeamsQuery, FindAllTeamsQueryVariables>(FindAllTeamsDocument, variables),
      options
    )};

export const GetAnalyticsGameAggregateDocument = new TypedDocumentString(`
    query GetAnalyticsGameAggregate($gameId: String!, $metric: AnalyticsMetric!) {
  gameAggregates(gameId: $gameId, metric: $metric) {
    count
    metric
    updatedAt
  }
}
    `);

export const useGetAnalyticsGameAggregateQuery = <
      TData = GetAnalyticsGameAggregateQuery,
      TError = unknown
    >(
      variables: GetAnalyticsGameAggregateQueryVariables,
      options?: UseQueryOptions<GetAnalyticsGameAggregateQuery, TError, TData>
    ) => {
    
    return useQuery<GetAnalyticsGameAggregateQuery, TError, TData>(
      ['GetAnalyticsGameAggregate', variables],
      fetchGenerated<GetAnalyticsGameAggregateQuery, GetAnalyticsGameAggregateQueryVariables>(GetAnalyticsGameAggregateDocument, variables),
      options
    )};

export const GetAnalyticsNamedCounterAggregatesDocument = new TypedDocumentString(`
    query GetAnalyticsNamedCounterAggregates($gameId: String!, $counterName: AnalyticsNamedCounterName!, $bucketNames: [String!]!) {
  namedCounterAggregates(
    gameId: $gameId
    counterName: $counterName
    bucketNames: $bucketNames
  ) {
    bucketName
    counterName
    updatedAt
    value
  }
}
    `);

export const useGetAnalyticsNamedCounterAggregatesQuery = <
      TData = GetAnalyticsNamedCounterAggregatesQuery,
      TError = unknown
    >(
      variables: GetAnalyticsNamedCounterAggregatesQueryVariables,
      options?: UseQueryOptions<GetAnalyticsNamedCounterAggregatesQuery, TError, TData>
    ) => {
    
    return useQuery<GetAnalyticsNamedCounterAggregatesQuery, TError, TData>(
      ['GetAnalyticsNamedCounterAggregates', variables],
      fetchGenerated<GetAnalyticsNamedCounterAggregatesQuery, GetAnalyticsNamedCounterAggregatesQueryVariables>(GetAnalyticsNamedCounterAggregatesDocument, variables),
      options
    )};

export const GetAnalyticsHour2AggregatesDocument = new TypedDocumentString(`
    query GetAnalyticsHour2Aggregates($gameId: String!, $metric: AnalyticsMetric!, $hour2Buckets: [String!]!) {
  hour2Aggregates(gameId: $gameId, metric: $metric, hour2Buckets: $hour2Buckets) {
    count
    hour2Bucket
    metric
    updatedAt
  }
}
    `);

export const useGetAnalyticsHour2AggregatesQuery = <
      TData = GetAnalyticsHour2AggregatesQuery,
      TError = unknown
    >(
      variables: GetAnalyticsHour2AggregatesQueryVariables,
      options?: UseQueryOptions<GetAnalyticsHour2AggregatesQuery, TError, TData>
    ) => {
    
    return useQuery<GetAnalyticsHour2AggregatesQuery, TError, TData>(
      ['GetAnalyticsHour2Aggregates', variables],
      fetchGenerated<GetAnalyticsHour2AggregatesQuery, GetAnalyticsHour2AggregatesQueryVariables>(GetAnalyticsHour2AggregatesDocument, variables),
      options
    )};

export const GetAnalyticsLocationAggregatesDocument = new TypedDocumentString(`
    query GetAnalyticsLocationAggregates($gameId: String!, $metric: AnalyticsMetric!, $locationIds: [ID!]!) {
  locationAggregates(gameId: $gameId, metric: $metric, locationIds: $locationIds) {
    count
    locationId
    metric
    updatedAt
  }
}
    `);

export const useGetAnalyticsLocationAggregatesQuery = <
      TData = GetAnalyticsLocationAggregatesQuery,
      TError = unknown
    >(
      variables: GetAnalyticsLocationAggregatesQueryVariables,
      options?: UseQueryOptions<GetAnalyticsLocationAggregatesQuery, TError, TData>
    ) => {
    
    return useQuery<GetAnalyticsLocationAggregatesQuery, TError, TData>(
      ['GetAnalyticsLocationAggregates', variables],
      fetchGenerated<GetAnalyticsLocationAggregatesQuery, GetAnalyticsLocationAggregatesQueryVariables>(GetAnalyticsLocationAggregatesDocument, variables),
      options
    )};

export const FindAnalyticsLocationsDocument = new TypedDocumentString(`
    query FindAnalyticsLocations($gameId: String!) {
  findLocations(gameId: $gameId) {
    id
    name
    slug
    description
    type
    beatBoxNumber
    isBonus
  }
}
    `);

export const useFindAnalyticsLocationsQuery = <
      TData = FindAnalyticsLocationsQuery,
      TError = unknown
    >(
      variables: FindAnalyticsLocationsQueryVariables,
      options?: UseQueryOptions<FindAnalyticsLocationsQuery, TError, TData>
    ) => {
    
    return useQuery<FindAnalyticsLocationsQuery, TError, TData>(
      ['FindAnalyticsLocations', variables],
      fetchGenerated<FindAnalyticsLocationsQuery, FindAnalyticsLocationsQueryVariables>(FindAnalyticsLocationsDocument, variables),
      options
    )};

export const ListLuckyTapsDocument = new TypedDocumentString(`
    query ListLuckyTaps($gameId: String!) {
  listLuckySwipes(gameId: $gameId) {
    id
    gameId
    tagNumber
    timestamp
    status
    invalidationReason
    reason
    locationId
    locationName
    sourceMetadata
    wtuSerial
    wtuSequence
    wtuLat
    wtuLng
    createdAt
    isLucky
  }
}
    `);

export const useListLuckyTapsQuery = <
      TData = ListLuckyTapsQuery,
      TError = unknown
    >(
      variables: ListLuckyTapsQueryVariables,
      options?: UseQueryOptions<ListLuckyTapsQuery, TError, TData>
    ) => {
    
    return useQuery<ListLuckyTapsQuery, TError, TData>(
      ['ListLuckyTaps', variables],
      fetchGenerated<ListLuckyTapsQuery, ListLuckyTapsQueryVariables>(ListLuckyTapsDocument, variables),
      options
    )};

export const CreatePrizeDrawDocument = new TypedDocumentString(`
    mutation CreatePrizeDraw($gameId: String!, $title: String!, $description: String!, $winnersCount: Int!, $type: PrizeDrawType!, $prizeType: PrizeType!, $start: String, $end: String, $boxIds: [String!], $eventIds: [String!], $surveyType: String, $winnersDistribution: WinnersDistributionInput, $autoSendWinnerEmails: Boolean, $autoFulfilOnAccept: Boolean, $scheduledAt: String) {
  createPrizeDraw(
    gameId: $gameId
    title: $title
    description: $description
    winnersCount: $winnersCount
    type: $type
    prizeType: $prizeType
    start: $start
    end: $end
    boxIds: $boxIds
    eventIds: $eventIds
    surveyType: $surveyType
    winnersDistribution: $winnersDistribution
    autoSendWinnerEmails: $autoSendWinnerEmails
    autoFulfilOnAccept: $autoFulfilOnAccept
    scheduledAt: $scheduledAt
  )
}
    `);

export const useCreatePrizeDrawMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePrizeDrawMutation, TError, CreatePrizeDrawMutationVariables, TContext>) => {
    
    return useMutation<CreatePrizeDrawMutation, TError, CreatePrizeDrawMutationVariables, TContext>(
      ['CreatePrizeDraw'],
      (variables?: CreatePrizeDrawMutationVariables) => fetchGenerated<CreatePrizeDrawMutation, CreatePrizeDrawMutationVariables>(CreatePrizeDrawDocument, variables)(),
      options
    )};

export const SendPrizeDrawWinnerEmailDocument = new TypedDocumentString(`
    mutation SendPrizeDrawWinnerEmail($drawId: String!, $gameId: String!, $playerId: String!) {
  sendPrizeDrawWinnerEmail(drawId: $drawId, gameId: $gameId, playerId: $playerId)
}
    `);

export const useSendPrizeDrawWinnerEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendPrizeDrawWinnerEmailMutation, TError, SendPrizeDrawWinnerEmailMutationVariables, TContext>) => {
    
    return useMutation<SendPrizeDrawWinnerEmailMutation, TError, SendPrizeDrawWinnerEmailMutationVariables, TContext>(
      ['SendPrizeDrawWinnerEmail'],
      (variables?: SendPrizeDrawWinnerEmailMutationVariables) => fetchGenerated<SendPrizeDrawWinnerEmailMutation, SendPrizeDrawWinnerEmailMutationVariables>(SendPrizeDrawWinnerEmailDocument, variables)(),
      options
    )};

export const MarkPrizeDrawWinnerAsFulfilledDocument = new TypedDocumentString(`
    mutation MarkPrizeDrawWinnerAsFulfilled($drawId: String!, $gameId: String!, $playerId: String!) {
  markPrizeDrawWinnerAsFulfilled(
    drawId: $drawId
    gameId: $gameId
    playerId: $playerId
  )
}
    `);

export const useMarkPrizeDrawWinnerAsFulfilledMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MarkPrizeDrawWinnerAsFulfilledMutation, TError, MarkPrizeDrawWinnerAsFulfilledMutationVariables, TContext>) => {
    
    return useMutation<MarkPrizeDrawWinnerAsFulfilledMutation, TError, MarkPrizeDrawWinnerAsFulfilledMutationVariables, TContext>(
      ['MarkPrizeDrawWinnerAsFulfilled'],
      (variables?: MarkPrizeDrawWinnerAsFulfilledMutationVariables) => fetchGenerated<MarkPrizeDrawWinnerAsFulfilledMutation, MarkPrizeDrawWinnerAsFulfilledMutationVariables>(MarkPrizeDrawWinnerAsFulfilledDocument, variables)(),
      options
    )};

export const DeletePrizeDrawWinnerDocument = new TypedDocumentString(`
    mutation DeletePrizeDrawWinner($drawId: String!, $gameId: String!, $playerId: String!) {
  deletePrizeDrawWinner(drawId: $drawId, gameId: $gameId, playerId: $playerId)
}
    `);

export const useDeletePrizeDrawWinnerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeletePrizeDrawWinnerMutation, TError, DeletePrizeDrawWinnerMutationVariables, TContext>) => {
    
    return useMutation<DeletePrizeDrawWinnerMutation, TError, DeletePrizeDrawWinnerMutationVariables, TContext>(
      ['DeletePrizeDrawWinner'],
      (variables?: DeletePrizeDrawWinnerMutationVariables) => fetchGenerated<DeletePrizeDrawWinnerMutation, DeletePrizeDrawWinnerMutationVariables>(DeletePrizeDrawWinnerDocument, variables)(),
      options
    )};

export const DeletePrizeDrawDocument = new TypedDocumentString(`
    mutation DeletePrizeDraw($drawId: String!, $gameId: String!) {
  deletePrizeDraw(drawId: $drawId, gameId: $gameId)
}
    `);

export const useDeletePrizeDrawMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeletePrizeDrawMutation, TError, DeletePrizeDrawMutationVariables, TContext>) => {
    
    return useMutation<DeletePrizeDrawMutation, TError, DeletePrizeDrawMutationVariables, TContext>(
      ['DeletePrizeDraw'],
      (variables?: DeletePrizeDrawMutationVariables) => fetchGenerated<DeletePrizeDrawMutation, DeletePrizeDrawMutationVariables>(DeletePrizeDrawDocument, variables)(),
      options
    )};

export const DrawMorePrizeDrawWinnersDocument = new TypedDocumentString(`
    mutation DrawMorePrizeDrawWinners($gameId: String!, $drawId: String!, $winnersCount: Int!, $winnersDistribution: WinnersDistributionInput) {
  drawMorePrizeDrawWinners(
    gameId: $gameId
    drawId: $drawId
    winnersCount: $winnersCount
    winnersDistribution: $winnersDistribution
  )
}
    `);

export const useDrawMorePrizeDrawWinnersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DrawMorePrizeDrawWinnersMutation, TError, DrawMorePrizeDrawWinnersMutationVariables, TContext>) => {
    
    return useMutation<DrawMorePrizeDrawWinnersMutation, TError, DrawMorePrizeDrawWinnersMutationVariables, TContext>(
      ['DrawMorePrizeDrawWinners'],
      (variables?: DrawMorePrizeDrawWinnersMutationVariables) => fetchGenerated<DrawMorePrizeDrawWinnersMutation, DrawMorePrizeDrawWinnersMutationVariables>(DrawMorePrizeDrawWinnersDocument, variables)(),
      options
    )};

export const ListPrizeDrawsDocument = new TypedDocumentString(`
    query ListPrizeDraws($gameId: String!) {
  listPrizeDraws(gameId: $gameId) {
    drawId
    title
    description
    winnersCount
    winnersDrawn
    type
    prizeType
    gameId
    status
    displayStatus
    scheduledAt
  }
}
    `);

export const useListPrizeDrawsQuery = <
      TData = ListPrizeDrawsQuery,
      TError = unknown
    >(
      variables: ListPrizeDrawsQueryVariables,
      options?: UseQueryOptions<ListPrizeDrawsQuery, TError, TData>
    ) => {
    
    return useQuery<ListPrizeDrawsQuery, TError, TData>(
      ['ListPrizeDraws', variables],
      fetchGenerated<ListPrizeDrawsQuery, ListPrizeDrawsQueryVariables>(ListPrizeDrawsDocument, variables),
      options
    )};

export const GetPrizeDrawDocument = new TypedDocumentString(`
    query GetPrizeDraw($gameId: String!, $drawId: String!) {
  getPrizeDraw(gameId: $gameId, drawId: $drawId) {
    drawId
    title
    description
    winnersCount
    type
    prizeType
    gameId
    status
    scheduledAt
    start
    end
    boxIds
    eventIds
    surveyType
    autoSendWinnerEmails
    autoFulfilOnAccept
    winnersDistribution {
      child
      adult
    }
  }
}
    `);

export const useGetPrizeDrawQuery = <
      TData = GetPrizeDrawQuery,
      TError = unknown
    >(
      variables: GetPrizeDrawQueryVariables,
      options?: UseQueryOptions<GetPrizeDrawQuery, TError, TData>
    ) => {
    
    return useQuery<GetPrizeDrawQuery, TError, TData>(
      ['GetPrizeDraw', variables],
      fetchGenerated<GetPrizeDrawQuery, GetPrizeDrawQueryVariables>(GetPrizeDrawDocument, variables),
      options
    )};

export const ListPrizeDrawWinnersDocument = new TypedDocumentString(`
    query ListPrizeDrawWinners($drawId: String!, $gameId: String!) {
  listPrizeDrawWinners(drawId: $drawId, gameId: $gameId) {
    drawId
    gameId
    playerId
    parentId
    swipeId
    email
    status
    reason
    createdAt
    info {
      id
      avatar
      publicName
    }
    profile {
      id
      email
      fullName
      firstName
    }
    parentProfile {
      id
      email
      fullName
      firstName
    }
  }
}
    `);

export const useListPrizeDrawWinnersQuery = <
      TData = ListPrizeDrawWinnersQuery,
      TError = unknown
    >(
      variables: ListPrizeDrawWinnersQueryVariables,
      options?: UseQueryOptions<ListPrizeDrawWinnersQuery, TError, TData>
    ) => {
    
    return useQuery<ListPrizeDrawWinnersQuery, TError, TData>(
      ['ListPrizeDrawWinners', variables],
      fetchGenerated<ListPrizeDrawWinnersQuery, ListPrizeDrawWinnersQueryVariables>(ListPrizeDrawWinnersDocument, variables),
      options
    )};

export const GetZoneAggregatesDocument = new TypedDocumentString(`
    query GetZoneAggregates($gameId: String!, $metric: AnalyticsMetric!, $zoneIds: [String!]!, $filter: AnalyticsFilterInput) {
  zoneAggregates(
    gameId: $gameId
    metric: $metric
    zoneIds: $zoneIds
    filter: $filter
  ) {
    zoneId
    count
    metric
  }
}
    `);

export const useGetZoneAggregatesQuery = <
      TData = GetZoneAggregatesQuery,
      TError = unknown
    >(
      variables: GetZoneAggregatesQueryVariables,
      options?: UseQueryOptions<GetZoneAggregatesQuery, TError, TData>
    ) => {
    
    return useQuery<GetZoneAggregatesQuery, TError, TData>(
      ['GetZoneAggregates', variables],
      fetchGenerated<GetZoneAggregatesQuery, GetZoneAggregatesQueryVariables>(GetZoneAggregatesDocument, variables),
      options
    )};

export const MappingLocationDocument = new TypedDocumentString(`
    query MappingLocation($gameId: String!, $id: String!) {
  mappingLocation(gameId: $gameId, id: $id) {
    ...MappingLocationFields
  }
}
    fragment MappingLocationFields on MappingLocation {
  id
  gameId
  name
  description
  mappingNotes
  type
  gemType
  points
  beatBoxNumber
  accessible
  isBonus
  ownerName
  slug
  what3words
  publishedAt
  selectedCandidateId
  coordinates {
    lat
    lng
  }
  candidates {
    id
    lat
    lng
    note
  }
  geo {
    isochrone
    lamppost
    nearest
  }
  reviewStatus
  createdAt
  updatedAt
}`);

export const useMappingLocationQuery = <
      TData = MappingLocationQuery,
      TError = unknown
    >(
      variables: MappingLocationQueryVariables,
      options?: UseQueryOptions<MappingLocationQuery, TError, TData>
    ) => {
    
    return useQuery<MappingLocationQuery, TError, TData>(
      ['MappingLocation', variables],
      fetchGenerated<MappingLocationQuery, MappingLocationQueryVariables>(MappingLocationDocument, variables),
      options
    )};

export const AssessMappingPlacementDocument = new TypedDocumentString(`
    query AssessMappingPlacement($gameId: String!, $lng: Float!, $lat: Float!, $selfId: String, $snap: Boolean) {
  assessMappingPlacement(
    gameId: $gameId
    lng: $lng
    lat: $lat
    selfId: $selfId
    snap: $snap
  ) {
    coord
    isochrone
    nearest
    isTooClose
  }
}
    `);

export const useAssessMappingPlacementQuery = <
      TData = AssessMappingPlacementQuery,
      TError = unknown
    >(
      variables: AssessMappingPlacementQueryVariables,
      options?: UseQueryOptions<AssessMappingPlacementQuery, TError, TData>
    ) => {
    
    return useQuery<AssessMappingPlacementQuery, TError, TData>(
      ['AssessMappingPlacement', variables],
      fetchGenerated<AssessMappingPlacementQuery, AssessMappingPlacementQueryVariables>(AssessMappingPlacementDocument, variables),
      options
    )};

export const NearbyMappingLamppostsDocument = new TypedDocumentString(`
    query NearbyMappingLampposts($gameId: String!, $lng: Float!, $lat: Float!) {
  nearbyMappingLampposts(gameId: $gameId, lng: $lng, lat: $lat) {
    candidates {
      osid
      lat
      lng
      distanceMeters
    }
    searchRadiusMeters
  }
}
    `);

export const useNearbyMappingLamppostsQuery = <
      TData = NearbyMappingLamppostsQuery,
      TError = unknown
    >(
      variables: NearbyMappingLamppostsQueryVariables,
      options?: UseQueryOptions<NearbyMappingLamppostsQuery, TError, TData>
    ) => {
    
    return useQuery<NearbyMappingLamppostsQuery, TError, TData>(
      ['NearbyMappingLampposts', variables],
      fetchGenerated<NearbyMappingLamppostsQuery, NearbyMappingLamppostsQueryVariables>(NearbyMappingLamppostsDocument, variables),
      options
    )};

export const MappingReviewsDocument = new TypedDocumentString(`
    query MappingReviews($gameId: String!, $locationId: String!) {
  mappingReviews(gameId: $gameId, locationId: $locationId) {
    ...MappingReviewFields
  }
}
    fragment MappingReviewFields on MappingReview {
  id
  gameId
  locationId
  type
  status
  approvedAt
  riskAssessment
  createdAt
  updatedAt
}`);

export const useMappingReviewsQuery = <
      TData = MappingReviewsQuery,
      TError = unknown
    >(
      variables: MappingReviewsQueryVariables,
      options?: UseQueryOptions<MappingReviewsQuery, TError, TData>
    ) => {
    
    return useQuery<MappingReviewsQuery, TError, TData>(
      ['MappingReviews', variables],
      fetchGenerated<MappingReviewsQuery, MappingReviewsQueryVariables>(MappingReviewsDocument, variables),
      options
    )};

export const MappingReviewDocument = new TypedDocumentString(`
    query MappingReview($gameId: String!, $locationId: String!, $type: MappingReviewType!) {
  mappingReview(gameId: $gameId, locationId: $locationId, type: $type) {
    ...MappingReviewFields
  }
}
    fragment MappingReviewFields on MappingReview {
  id
  gameId
  locationId
  type
  status
  approvedAt
  riskAssessment
  createdAt
  updatedAt
}`);

export const useMappingReviewQuery = <
      TData = MappingReviewQuery,
      TError = unknown
    >(
      variables: MappingReviewQueryVariables,
      options?: UseQueryOptions<MappingReviewQuery, TError, TData>
    ) => {
    
    return useQuery<MappingReviewQuery, TError, TData>(
      ['MappingReview', variables],
      fetchGenerated<MappingReviewQuery, MappingReviewQueryVariables>(MappingReviewDocument, variables),
      options
    )};

export const MappingReviewersDocument = new TypedDocumentString(`
    query MappingReviewers($gameId: String!) {
  mappingReviewers(gameId: $gameId) {
    ...MappingReviewerFields
  }
}
    fragment MappingReviewerFields on MappingReviewer {
  id
  gameId
  allowedReviewType
  name
  email
  token
  expiresAt
  createdAt
  updatedAt
}`);

export const useMappingReviewersQuery = <
      TData = MappingReviewersQuery,
      TError = unknown
    >(
      variables: MappingReviewersQueryVariables,
      options?: UseQueryOptions<MappingReviewersQuery, TError, TData>
    ) => {
    
    return useQuery<MappingReviewersQuery, TError, TData>(
      ['MappingReviewers', variables],
      fetchGenerated<MappingReviewersQuery, MappingReviewersQueryVariables>(MappingReviewersDocument, variables),
      options
    )};

export const MappingLocationHistoryDocument = new TypedDocumentString(`
    query MappingLocationHistory($gameId: String!, $locationId: String!) {
  mappingLocationHistory(gameId: $gameId, locationId: $locationId) {
    ...MappingHistoryFields
  }
}
    fragment MappingHistoryFields on MappingHistory {
  id
  gameId
  locationId
  action
  actor {
    name
    email
  }
  metadata
  createdAt
  updatedAt
}`);

export const useMappingLocationHistoryQuery = <
      TData = MappingLocationHistoryQuery,
      TError = unknown
    >(
      variables: MappingLocationHistoryQueryVariables,
      options?: UseQueryOptions<MappingLocationHistoryQuery, TError, TData>
    ) => {
    
    return useQuery<MappingLocationHistoryQuery, TError, TData>(
      ['MappingLocationHistory', variables],
      fetchGenerated<MappingLocationHistoryQuery, MappingLocationHistoryQueryVariables>(MappingLocationHistoryDocument, variables),
      options
    )};

export const CreateMappingLocationDocument = new TypedDocumentString(`
    mutation CreateMappingLocation($input: CreateMappingLocationInput!) {
  createMappingLocation(input: $input) {
    ...MappingLocationFields
  }
}
    fragment MappingLocationFields on MappingLocation {
  id
  gameId
  name
  description
  mappingNotes
  type
  gemType
  points
  beatBoxNumber
  accessible
  isBonus
  ownerName
  slug
  what3words
  publishedAt
  selectedCandidateId
  coordinates {
    lat
    lng
  }
  candidates {
    id
    lat
    lng
    note
  }
  geo {
    isochrone
    lamppost
    nearest
  }
  reviewStatus
  createdAt
  updatedAt
}`);

export const useCreateMappingLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMappingLocationMutation, TError, CreateMappingLocationMutationVariables, TContext>) => {
    
    return useMutation<CreateMappingLocationMutation, TError, CreateMappingLocationMutationVariables, TContext>(
      ['CreateMappingLocation'],
      (variables?: CreateMappingLocationMutationVariables) => fetchGenerated<CreateMappingLocationMutation, CreateMappingLocationMutationVariables>(CreateMappingLocationDocument, variables)(),
      options
    )};

export const UpdateMappingLocationDocument = new TypedDocumentString(`
    mutation UpdateMappingLocation($input: UpdateMappingLocationInput!) {
  updateMappingLocation(input: $input) {
    ...MappingLocationFields
  }
}
    fragment MappingLocationFields on MappingLocation {
  id
  gameId
  name
  description
  mappingNotes
  type
  gemType
  points
  beatBoxNumber
  accessible
  isBonus
  ownerName
  slug
  what3words
  publishedAt
  selectedCandidateId
  coordinates {
    lat
    lng
  }
  candidates {
    id
    lat
    lng
    note
  }
  geo {
    isochrone
    lamppost
    nearest
  }
  reviewStatus
  createdAt
  updatedAt
}`);

export const useUpdateMappingLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMappingLocationMutation, TError, UpdateMappingLocationMutationVariables, TContext>) => {
    
    return useMutation<UpdateMappingLocationMutation, TError, UpdateMappingLocationMutationVariables, TContext>(
      ['UpdateMappingLocation'],
      (variables?: UpdateMappingLocationMutationVariables) => fetchGenerated<UpdateMappingLocationMutation, UpdateMappingLocationMutationVariables>(UpdateMappingLocationDocument, variables)(),
      options
    )};

export const UpdateMappingGroupDocument = new TypedDocumentString(`
    mutation UpdateMappingGroup($input: UpdateGroupInput!) {
  updateMappingGroup(input: $input) {
    ...MappingGroupFields
  }
}
    fragment MappingGroupFields on Group {
  id
  gameId
  name
  description
  color
}`);

export const useUpdateMappingGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMappingGroupMutation, TError, UpdateMappingGroupMutationVariables, TContext>) => {
    
    return useMutation<UpdateMappingGroupMutation, TError, UpdateMappingGroupMutationVariables, TContext>(
      ['UpdateMappingGroup'],
      (variables?: UpdateMappingGroupMutationVariables) => fetchGenerated<UpdateMappingGroupMutation, UpdateMappingGroupMutationVariables>(UpdateMappingGroupDocument, variables)(),
      options
    )};

export const DeleteMappingGroupDocument = new TypedDocumentString(`
    mutation DeleteMappingGroup($gameId: String!, $id: String!) {
  deleteMappingGroup(gameId: $gameId, id: $id)
}
    `);

export const useDeleteMappingGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMappingGroupMutation, TError, DeleteMappingGroupMutationVariables, TContext>) => {
    
    return useMutation<DeleteMappingGroupMutation, TError, DeleteMappingGroupMutationVariables, TContext>(
      ['DeleteMappingGroup'],
      (variables?: DeleteMappingGroupMutationVariables) => fetchGenerated<DeleteMappingGroupMutation, DeleteMappingGroupMutationVariables>(DeleteMappingGroupDocument, variables)(),
      options
    )};

export const CreateMappingGroupElementDocument = new TypedDocumentString(`
    mutation CreateMappingGroupElement($input: GroupElementInput!) {
  createMappingGroupElement(input: $input) {
    ...MappingGroupElementFields
  }
}
    fragment MappingGroupElementFields on GroupElement {
  gameId
  groupId
  locationId
}`);

export const useCreateMappingGroupElementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMappingGroupElementMutation, TError, CreateMappingGroupElementMutationVariables, TContext>) => {
    
    return useMutation<CreateMappingGroupElementMutation, TError, CreateMappingGroupElementMutationVariables, TContext>(
      ['CreateMappingGroupElement'],
      (variables?: CreateMappingGroupElementMutationVariables) => fetchGenerated<CreateMappingGroupElementMutation, CreateMappingGroupElementMutationVariables>(CreateMappingGroupElementDocument, variables)(),
      options
    )};

export const DeleteMappingGroupElementDocument = new TypedDocumentString(`
    mutation DeleteMappingGroupElement($input: GroupElementInput!) {
  deleteMappingGroupElement(input: $input)
}
    `);

export const useDeleteMappingGroupElementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMappingGroupElementMutation, TError, DeleteMappingGroupElementMutationVariables, TContext>) => {
    
    return useMutation<DeleteMappingGroupElementMutation, TError, DeleteMappingGroupElementMutationVariables, TContext>(
      ['DeleteMappingGroupElement'],
      (variables?: DeleteMappingGroupElementMutationVariables) => fetchGenerated<DeleteMappingGroupElementMutation, DeleteMappingGroupElementMutationVariables>(DeleteMappingGroupElementDocument, variables)(),
      options
    )};

export const CreateMappingReviewDocument = new TypedDocumentString(`
    mutation CreateMappingReview($input: CreateMappingReviewInput!) {
  createMappingReview(input: $input) {
    ...MappingReviewFields
  }
}
    fragment MappingReviewFields on MappingReview {
  id
  gameId
  locationId
  type
  status
  approvedAt
  riskAssessment
  createdAt
  updatedAt
}`);

export const useCreateMappingReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMappingReviewMutation, TError, CreateMappingReviewMutationVariables, TContext>) => {
    
    return useMutation<CreateMappingReviewMutation, TError, CreateMappingReviewMutationVariables, TContext>(
      ['CreateMappingReview'],
      (variables?: CreateMappingReviewMutationVariables) => fetchGenerated<CreateMappingReviewMutation, CreateMappingReviewMutationVariables>(CreateMappingReviewDocument, variables)(),
      options
    )};

export const UpdateMappingReviewDocument = new TypedDocumentString(`
    mutation UpdateMappingReview($input: UpdateMappingReviewInput!) {
  updateMappingReview(input: $input) {
    ...MappingReviewFields
  }
}
    fragment MappingReviewFields on MappingReview {
  id
  gameId
  locationId
  type
  status
  approvedAt
  riskAssessment
  createdAt
  updatedAt
}`);

export const useUpdateMappingReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMappingReviewMutation, TError, UpdateMappingReviewMutationVariables, TContext>) => {
    
    return useMutation<UpdateMappingReviewMutation, TError, UpdateMappingReviewMutationVariables, TContext>(
      ['UpdateMappingReview'],
      (variables?: UpdateMappingReviewMutationVariables) => fetchGenerated<UpdateMappingReviewMutation, UpdateMappingReviewMutationVariables>(UpdateMappingReviewDocument, variables)(),
      options
    )};

export const InviteMappingReviewerDocument = new TypedDocumentString(`
    mutation InviteMappingReviewer($input: InviteMappingReviewerInput!) {
  inviteMappingReviewer(input: $input) {
    ...MappingReviewerFields
  }
}
    fragment MappingReviewerFields on MappingReviewer {
  id
  gameId
  allowedReviewType
  name
  email
  token
  expiresAt
  createdAt
  updatedAt
}`);

export const useInviteMappingReviewerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InviteMappingReviewerMutation, TError, InviteMappingReviewerMutationVariables, TContext>) => {
    
    return useMutation<InviteMappingReviewerMutation, TError, InviteMappingReviewerMutationVariables, TContext>(
      ['InviteMappingReviewer'],
      (variables?: InviteMappingReviewerMutationVariables) => fetchGenerated<InviteMappingReviewerMutation, InviteMappingReviewerMutationVariables>(InviteMappingReviewerDocument, variables)(),
      options
    )};

export const DeleteMappingReviewerDocument = new TypedDocumentString(`
    mutation DeleteMappingReviewer($gameId: String!, $id: String!) {
  deleteMappingReviewer(gameId: $gameId, id: $id)
}
    `);

export const useDeleteMappingReviewerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMappingReviewerMutation, TError, DeleteMappingReviewerMutationVariables, TContext>) => {
    
    return useMutation<DeleteMappingReviewerMutation, TError, DeleteMappingReviewerMutationVariables, TContext>(
      ['DeleteMappingReviewer'],
      (variables?: DeleteMappingReviewerMutationVariables) => fetchGenerated<DeleteMappingReviewerMutation, DeleteMappingReviewerMutationVariables>(DeleteMappingReviewerDocument, variables)(),
      options
    )};

export const CreateMappingCommentDocument = new TypedDocumentString(`
    mutation CreateMappingComment($input: CreateMappingCommentInput!) {
  createMappingComment(input: $input) {
    ...MappingCommentFields
  }
}
    fragment MappingCommentFields on MappingComment {
  id
  gameId
  kind
  reviewType
  locationId
  layer
  parentCommentId
  content
  author {
    name
    email
  }
  authorRole
  coordinates {
    lat
    lng
  }
  reactions {
    emoji
    actors {
      name
      email
    }
  }
  status
  resolvedAt
  createdAt
  updatedAt
}`);

export const useCreateMappingCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMappingCommentMutation, TError, CreateMappingCommentMutationVariables, TContext>) => {
    
    return useMutation<CreateMappingCommentMutation, TError, CreateMappingCommentMutationVariables, TContext>(
      ['CreateMappingComment'],
      (variables?: CreateMappingCommentMutationVariables) => fetchGenerated<CreateMappingCommentMutation, CreateMappingCommentMutationVariables>(CreateMappingCommentDocument, variables)(),
      options
    )};

export const ToggleMappingCommentReactionDocument = new TypedDocumentString(`
    mutation ToggleMappingCommentReaction($input: ToggleMappingCommentReactionInput!) {
  toggleMappingCommentReaction(input: $input) {
    ...MappingCommentFields
  }
}
    fragment MappingCommentFields on MappingComment {
  id
  gameId
  kind
  reviewType
  locationId
  layer
  parentCommentId
  content
  author {
    name
    email
  }
  authorRole
  coordinates {
    lat
    lng
  }
  reactions {
    emoji
    actors {
      name
      email
    }
  }
  status
  resolvedAt
  createdAt
  updatedAt
}`);

export const useToggleMappingCommentReactionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ToggleMappingCommentReactionMutation, TError, ToggleMappingCommentReactionMutationVariables, TContext>) => {
    
    return useMutation<ToggleMappingCommentReactionMutation, TError, ToggleMappingCommentReactionMutationVariables, TContext>(
      ['ToggleMappingCommentReaction'],
      (variables?: ToggleMappingCommentReactionMutationVariables) => fetchGenerated<ToggleMappingCommentReactionMutation, ToggleMappingCommentReactionMutationVariables>(ToggleMappingCommentReactionDocument, variables)(),
      options
    )};

export const UpdateMappingCommentDocument = new TypedDocumentString(`
    mutation UpdateMappingComment($input: UpdateMappingCommentInput!) {
  updateMappingComment(input: $input) {
    ...MappingCommentFields
  }
}
    fragment MappingCommentFields on MappingComment {
  id
  gameId
  kind
  reviewType
  locationId
  layer
  parentCommentId
  content
  author {
    name
    email
  }
  authorRole
  coordinates {
    lat
    lng
  }
  reactions {
    emoji
    actors {
      name
      email
    }
  }
  status
  resolvedAt
  createdAt
  updatedAt
}`);

export const useUpdateMappingCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMappingCommentMutation, TError, UpdateMappingCommentMutationVariables, TContext>) => {
    
    return useMutation<UpdateMappingCommentMutation, TError, UpdateMappingCommentMutationVariables, TContext>(
      ['UpdateMappingComment'],
      (variables?: UpdateMappingCommentMutationVariables) => fetchGenerated<UpdateMappingCommentMutation, UpdateMappingCommentMutationVariables>(UpdateMappingCommentDocument, variables)(),
      options
    )};

export const MappingCommentsDocument = new TypedDocumentString(`
    query MappingComments($gameId: String!) {
  mappingComments(gameId: $gameId) {
    ...MappingCommentFields
  }
}
    fragment MappingCommentFields on MappingComment {
  id
  gameId
  kind
  reviewType
  locationId
  layer
  parentCommentId
  content
  author {
    name
    email
  }
  authorRole
  coordinates {
    lat
    lng
  }
  reactions {
    emoji
    actors {
      name
      email
    }
  }
  status
  resolvedAt
  createdAt
  updatedAt
}`);

export const useMappingCommentsQuery = <
      TData = MappingCommentsQuery,
      TError = unknown
    >(
      variables: MappingCommentsQueryVariables,
      options?: UseQueryOptions<MappingCommentsQuery, TError, TData>
    ) => {
    
    return useQuery<MappingCommentsQuery, TError, TData>(
      ['MappingComments', variables],
      fetchGenerated<MappingCommentsQuery, MappingCommentsQueryVariables>(MappingCommentsDocument, variables),
      options
    )};

export const MappingGameRevisionDocument = new TypedDocumentString(`
    query MappingGameRevision($gameId: String!) {
  mappingGameRevision(gameId: $gameId)
}
    `);

export const useMappingGameRevisionQuery = <
      TData = MappingGameRevisionQuery,
      TError = unknown
    >(
      variables: MappingGameRevisionQueryVariables,
      options?: UseQueryOptions<MappingGameRevisionQuery, TError, TData>
    ) => {
    
    return useQuery<MappingGameRevisionQuery, TError, TData>(
      ['MappingGameRevision', variables],
      fetchGenerated<MappingGameRevisionQuery, MappingGameRevisionQueryVariables>(MappingGameRevisionDocument, variables),
      options
    )};

export const ResolveMappingCommentDocument = new TypedDocumentString(`
    mutation ResolveMappingComment($input: ResolveMappingCommentInput!) {
  resolveMappingComment(input: $input) {
    ...MappingCommentFields
  }
}
    fragment MappingCommentFields on MappingComment {
  id
  gameId
  kind
  reviewType
  locationId
  layer
  parentCommentId
  content
  author {
    name
    email
  }
  authorRole
  coordinates {
    lat
    lng
  }
  reactions {
    emoji
    actors {
      name
      email
    }
  }
  status
  resolvedAt
  createdAt
  updatedAt
}`);

export const useResolveMappingCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResolveMappingCommentMutation, TError, ResolveMappingCommentMutationVariables, TContext>) => {
    
    return useMutation<ResolveMappingCommentMutation, TError, ResolveMappingCommentMutationVariables, TContext>(
      ['ResolveMappingComment'],
      (variables?: ResolveMappingCommentMutationVariables) => fetchGenerated<ResolveMappingCommentMutation, ResolveMappingCommentMutationVariables>(ResolveMappingCommentDocument, variables)(),
      options
    )};

export const MappingLocationsDocument = new TypedDocumentString(`
    query MappingLocations($gameId: String!) {
  mappingLocations(gameId: $gameId) {
    ...MappingLocationFields
  }
}
    fragment MappingLocationFields on MappingLocation {
  id
  gameId
  name
  description
  mappingNotes
  type
  gemType
  points
  beatBoxNumber
  accessible
  isBonus
  ownerName
  slug
  what3words
  publishedAt
  selectedCandidateId
  coordinates {
    lat
    lng
  }
  candidates {
    id
    lat
    lng
    note
  }
  geo {
    isochrone
    lamppost
    nearest
  }
  reviewStatus
  createdAt
  updatedAt
}`);

export const useMappingLocationsQuery = <
      TData = MappingLocationsQuery,
      TError = unknown
    >(
      variables: MappingLocationsQueryVariables,
      options?: UseQueryOptions<MappingLocationsQuery, TError, TData>
    ) => {
    
    return useQuery<MappingLocationsQuery, TError, TData>(
      ['MappingLocations', variables],
      fetchGenerated<MappingLocationsQuery, MappingLocationsQueryVariables>(MappingLocationsDocument, variables),
      options
    )};

export const MappingGroupsDocument = new TypedDocumentString(`
    query MappingGroups($gameId: String!) {
  mappingGroups(gameId: $gameId) {
    ...MappingGroupFields
  }
}
    fragment MappingGroupFields on Group {
  id
  gameId
  name
  description
  color
}`);

export const useMappingGroupsQuery = <
      TData = MappingGroupsQuery,
      TError = unknown
    >(
      variables: MappingGroupsQueryVariables,
      options?: UseQueryOptions<MappingGroupsQuery, TError, TData>
    ) => {
    
    return useQuery<MappingGroupsQuery, TError, TData>(
      ['MappingGroups', variables],
      fetchGenerated<MappingGroupsQuery, MappingGroupsQueryVariables>(MappingGroupsDocument, variables),
      options
    )};

export const MappingGroupElementsDocument = new TypedDocumentString(`
    query MappingGroupElements($gameId: String!, $groupId: String) {
  mappingGroupElements(gameId: $gameId, groupId: $groupId) {
    ...MappingGroupElementFields
  }
}
    fragment MappingGroupElementFields on GroupElement {
  gameId
  groupId
  locationId
}`);

export const useMappingGroupElementsQuery = <
      TData = MappingGroupElementsQuery,
      TError = unknown
    >(
      variables: MappingGroupElementsQueryVariables,
      options?: UseQueryOptions<MappingGroupElementsQuery, TError, TData>
    ) => {
    
    return useQuery<MappingGroupElementsQuery, TError, TData>(
      ['MappingGroupElements', variables],
      fetchGenerated<MappingGroupElementsQuery, MappingGroupElementsQueryVariables>(MappingGroupElementsDocument, variables),
      options
    )};

export const CreateMappingGroupDocument = new TypedDocumentString(`
    mutation CreateMappingGroup($input: CreateGroupInput!) {
  createMappingGroup(input: $input) {
    ...MappingGroupFields
  }
}
    fragment MappingGroupFields on Group {
  id
  gameId
  name
  description
  color
}`);

export const useCreateMappingGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMappingGroupMutation, TError, CreateMappingGroupMutationVariables, TContext>) => {
    
    return useMutation<CreateMappingGroupMutation, TError, CreateMappingGroupMutationVariables, TContext>(
      ['CreateMappingGroup'],
      (variables?: CreateMappingGroupMutationVariables) => fetchGenerated<CreateMappingGroupMutation, CreateMappingGroupMutationVariables>(CreateMappingGroupDocument, variables)(),
      options
    )};

export const PublishMappingLocationDocument = new TypedDocumentString(`
    mutation PublishMappingLocation($gameId: String!, $id: String!) {
  publishMappingLocation(gameId: $gameId, id: $id) {
    id
    reviewStatus
  }
}
    `);

export const usePublishMappingLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PublishMappingLocationMutation, TError, PublishMappingLocationMutationVariables, TContext>) => {
    
    return useMutation<PublishMappingLocationMutation, TError, PublishMappingLocationMutationVariables, TContext>(
      ['PublishMappingLocation'],
      (variables?: PublishMappingLocationMutationVariables) => fetchGenerated<PublishMappingLocationMutation, PublishMappingLocationMutationVariables>(PublishMappingLocationDocument, variables)(),
      options
    )};

export const PublishMappingGameDocument = new TypedDocumentString(`
    mutation PublishMappingGame($gameId: String!, $layers: [MappingLayer!], $locationIds: [String!]) {
  publishMappingGame(gameId: $gameId, layers: $layers, locationIds: $locationIds) {
    publishedCount
    skippedCount
    failedLocationIds
    skipped {
      locationId
      reason
    }
  }
}
    `);

export const usePublishMappingGameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PublishMappingGameMutation, TError, PublishMappingGameMutationVariables, TContext>) => {
    
    return useMutation<PublishMappingGameMutation, TError, PublishMappingGameMutationVariables, TContext>(
      ['PublishMappingGame'],
      (variables?: PublishMappingGameMutationVariables) => fetchGenerated<PublishMappingGameMutation, PublishMappingGameMutationVariables>(PublishMappingGameDocument, variables)(),
      options
    )};

export const DeleteMappingLocationDocument = new TypedDocumentString(`
    mutation DeleteMappingLocation($gameId: String!, $id: String!) {
  deleteMappingLocation(gameId: $gameId, id: $id)
}
    `);

export const useDeleteMappingLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMappingLocationMutation, TError, DeleteMappingLocationMutationVariables, TContext>) => {
    
    return useMutation<DeleteMappingLocationMutation, TError, DeleteMappingLocationMutationVariables, TContext>(
      ['DeleteMappingLocation'],
      (variables?: DeleteMappingLocationMutationVariables) => fetchGenerated<DeleteMappingLocationMutation, DeleteMappingLocationMutationVariables>(DeleteMappingLocationDocument, variables)(),
      options
    )};

export const GetPlayerByIdDocument = new TypedDocumentString(`
    query GetPlayerById($id: String!) {
  getPlayer(id: $id) {
    ...SearchPlayer
  }
}
    fragment FPlayerProfileContext on PlayerProfile {
  firstName
  email
  birthDate
  gender
  isRegistered
  ageGroup
}
fragment SearchPlayer on Player {
  id
  profile {
    ...FPlayerProfileContext
    fullName
  }
  info {
    publicName
    gameId
  }
  role {
    isAnonymous
  }
  tags {
    tagNumber
    tagType
  }
}`);

export const useGetPlayerByIdQuery = <
      TData = GetPlayerByIdQuery,
      TError = unknown
    >(
      variables: GetPlayerByIdQueryVariables,
      options?: UseQueryOptions<GetPlayerByIdQuery, TError, TData>
    ) => {
    
    return useQuery<GetPlayerByIdQuery, TError, TData>(
      ['GetPlayerById', variables],
      fetchGenerated<GetPlayerByIdQuery, GetPlayerByIdQueryVariables>(GetPlayerByIdDocument, variables),
      options
    )};

export const GetPlayerByEmailDocument = new TypedDocumentString(`
    query GetPlayerByEmail($email: String!) {
  getPlayerByEmail(email: $email) {
    ...SearchPlayer
  }
}
    fragment FPlayerProfileContext on PlayerProfile {
  firstName
  email
  birthDate
  gender
  isRegistered
  ageGroup
}
fragment SearchPlayer on Player {
  id
  profile {
    ...FPlayerProfileContext
    fullName
  }
  info {
    publicName
    gameId
  }
  role {
    isAnonymous
  }
  tags {
    tagNumber
    tagType
  }
}`);

export const useGetPlayerByEmailQuery = <
      TData = GetPlayerByEmailQuery,
      TError = unknown
    >(
      variables: GetPlayerByEmailQueryVariables,
      options?: UseQueryOptions<GetPlayerByEmailQuery, TError, TData>
    ) => {
    
    return useQuery<GetPlayerByEmailQuery, TError, TData>(
      ['GetPlayerByEmail', variables],
      fetchGenerated<GetPlayerByEmailQuery, GetPlayerByEmailQueryVariables>(GetPlayerByEmailDocument, variables),
      options
    )};

export const GetTagByNumberDocument = new TypedDocumentString(`
    query GetTagByNumber($tagNumber: Int!) {
  getTagByTagNumber(tagNumber: $tagNumber) {
    playerId
  }
}
    `);

export const useGetTagByNumberQuery = <
      TData = GetTagByNumberQuery,
      TError = unknown
    >(
      variables: GetTagByNumberQueryVariables,
      options?: UseQueryOptions<GetTagByNumberQuery, TError, TData>
    ) => {
    
    return useQuery<GetTagByNumberQuery, TError, TData>(
      ['GetTagByNumber', variables],
      fetchGenerated<GetTagByNumberQuery, GetTagByNumberQueryVariables>(GetTagByNumberDocument, variables),
      options
    )};

export const SearchPlayerByDocument = new TypedDocumentString(`
    query SearchPlayerBy($input: SearchPlayerByInput!) {
  getPlayerBy(input: $input) {
    id
    tags {
      tagType
      tagNumber
    }
    profile {
      isRegistered
    }
    ...FPlayerInfo
    ...FPlayerRole
  }
}
    fragment FPlayerInfoContext on PlayerInfo {
  gameId
  teamId
  publicName
  avatar
}
fragment FPlayerInfo on Player {
  info {
    ...FPlayerInfoContext
  }
}
fragment FPlayerRoleContext on PlayerRole {
  isChild
  parentId
  isAnonymous
  authID
  removedAt
}
fragment FPlayerRole on Player {
  role {
    ...FPlayerRoleContext
  }
}`);

export const useSearchPlayerByQuery = <
      TData = SearchPlayerByQuery,
      TError = unknown
    >(
      variables: SearchPlayerByQueryVariables,
      options?: UseQueryOptions<SearchPlayerByQuery, TError, TData>
    ) => {
    
    return useQuery<SearchPlayerByQuery, TError, TData>(
      ['SearchPlayerBy', variables],
      fetchGenerated<SearchPlayerByQuery, SearchPlayerByQueryVariables>(SearchPlayerByDocument, variables),
      options
    )};

export const ReviewerMeDocument = new TypedDocumentString(`
    query ReviewerMe {
  reviewerMe {
    gameId
    gameName
    poiName
    name
    email
    allowedReviewType
  }
}
    `);

export const useReviewerMeQuery = <
      TData = ReviewerMeQuery,
      TError = unknown
    >(
      variables?: ReviewerMeQueryVariables,
      options?: UseQueryOptions<ReviewerMeQuery, TError, TData>
    ) => {
    
    return useQuery<ReviewerMeQuery, TError, TData>(
      variables === undefined ? ['ReviewerMe'] : ['ReviewerMe', variables],
      fetchGenerated<ReviewerMeQuery, ReviewerMeQueryVariables>(ReviewerMeDocument, variables),
      options
    )};

export const ReviewerMappingLocationsDocument = new TypedDocumentString(`
    query ReviewerMappingLocations($layer: MappingLayer) {
  reviewerMappingLocations(layer: $layer) {
    location {
      ...ReviewerMappingLocationFields
    }
    review {
      ...ReviewerMappingReviewFields
    }
  }
}
    fragment ReviewerMappingLocationFields on MappingLocation {
  id
  gameId
  name
  slug
  beatBoxNumber
  accessible
  gemType
  description
  mappingNotes
  type
  isMobile
  reviewStatus
  selectedCandidateId
  coordinates {
    lat
    lng
  }
  candidates {
    id
    lat
    lng
    note
  }
  what3words
  geo {
    lamppost
  }
  createdAt
  updatedAt
}
fragment ReviewerMappingReviewFields on MappingReview {
  id
  gameId
  locationId
  type
  status
  approvedAt
  createdAt
  updatedAt
}`);

export const useReviewerMappingLocationsQuery = <
      TData = ReviewerMappingLocationsQuery,
      TError = unknown
    >(
      variables?: ReviewerMappingLocationsQueryVariables,
      options?: UseQueryOptions<ReviewerMappingLocationsQuery, TError, TData>
    ) => {
    
    return useQuery<ReviewerMappingLocationsQuery, TError, TData>(
      variables === undefined ? ['ReviewerMappingLocations'] : ['ReviewerMappingLocations', variables],
      fetchGenerated<ReviewerMappingLocationsQuery, ReviewerMappingLocationsQueryVariables>(ReviewerMappingLocationsDocument, variables),
      options
    )};

export const ReviewerMappingLocationDocument = new TypedDocumentString(`
    query ReviewerMappingLocation($id: String!) {
  reviewerMappingLocation(id: $id) {
    ...ReviewerMappingLocationFields
  }
}
    fragment ReviewerMappingLocationFields on MappingLocation {
  id
  gameId
  name
  slug
  beatBoxNumber
  accessible
  gemType
  description
  mappingNotes
  type
  isMobile
  reviewStatus
  selectedCandidateId
  coordinates {
    lat
    lng
  }
  candidates {
    id
    lat
    lng
    note
  }
  what3words
  geo {
    lamppost
  }
  createdAt
  updatedAt
}`);

export const useReviewerMappingLocationQuery = <
      TData = ReviewerMappingLocationQuery,
      TError = unknown
    >(
      variables: ReviewerMappingLocationQueryVariables,
      options?: UseQueryOptions<ReviewerMappingLocationQuery, TError, TData>
    ) => {
    
    return useQuery<ReviewerMappingLocationQuery, TError, TData>(
      ['ReviewerMappingLocation', variables],
      fetchGenerated<ReviewerMappingLocationQuery, ReviewerMappingLocationQueryVariables>(ReviewerMappingLocationDocument, variables),
      options
    )};

export const ReviewerMappingReviewsDocument = new TypedDocumentString(`
    query ReviewerMappingReviews($locationId: String!) {
  reviewerMappingReviews(locationId: $locationId) {
    ...ReviewerMappingReviewFields
  }
}
    fragment ReviewerMappingReviewFields on MappingReview {
  id
  gameId
  locationId
  type
  status
  approvedAt
  createdAt
  updatedAt
}`);

export const useReviewerMappingReviewsQuery = <
      TData = ReviewerMappingReviewsQuery,
      TError = unknown
    >(
      variables: ReviewerMappingReviewsQueryVariables,
      options?: UseQueryOptions<ReviewerMappingReviewsQuery, TError, TData>
    ) => {
    
    return useQuery<ReviewerMappingReviewsQuery, TError, TData>(
      ['ReviewerMappingReviews', variables],
      fetchGenerated<ReviewerMappingReviewsQuery, ReviewerMappingReviewsQueryVariables>(ReviewerMappingReviewsDocument, variables),
      options
    )};

export const ReviewerMappingCommentsDocument = new TypedDocumentString(`
    query ReviewerMappingComments {
  reviewerMappingComments {
    ...ReviewerMappingCommentFields
  }
}
    fragment ReviewerMappingCommentFields on MappingComment {
  id
  gameId
  kind
  reviewType
  locationId
  layer
  parentCommentId
  content
  author {
    name
    email
  }
  authorRole
  coordinates {
    lat
    lng
  }
  reactions {
    emoji
    actors {
      name
      email
    }
  }
  status
  resolvedAt
  createdAt
  updatedAt
}`);

export const useReviewerMappingCommentsQuery = <
      TData = ReviewerMappingCommentsQuery,
      TError = unknown
    >(
      variables?: ReviewerMappingCommentsQueryVariables,
      options?: UseQueryOptions<ReviewerMappingCommentsQuery, TError, TData>
    ) => {
    
    return useQuery<ReviewerMappingCommentsQuery, TError, TData>(
      variables === undefined ? ['ReviewerMappingComments'] : ['ReviewerMappingComments', variables],
      fetchGenerated<ReviewerMappingCommentsQuery, ReviewerMappingCommentsQueryVariables>(ReviewerMappingCommentsDocument, variables),
      options
    )};

export const ReviewerMappingRevisionDocument = new TypedDocumentString(`
    query ReviewerMappingRevision {
  reviewerMappingRevision
}
    `);

export const useReviewerMappingRevisionQuery = <
      TData = ReviewerMappingRevisionQuery,
      TError = unknown
    >(
      variables?: ReviewerMappingRevisionQueryVariables,
      options?: UseQueryOptions<ReviewerMappingRevisionQuery, TError, TData>
    ) => {
    
    return useQuery<ReviewerMappingRevisionQuery, TError, TData>(
      variables === undefined ? ['ReviewerMappingRevision'] : ['ReviewerMappingRevision', variables],
      fetchGenerated<ReviewerMappingRevisionQuery, ReviewerMappingRevisionQueryVariables>(ReviewerMappingRevisionDocument, variables),
      options
    )};

export const ReviewerCreateMappingCommentDocument = new TypedDocumentString(`
    mutation ReviewerCreateMappingComment($input: CreateMappingCommentInput!) {
  reviewerCreateMappingComment(input: $input) {
    ...ReviewerMappingCommentFields
  }
}
    fragment ReviewerMappingCommentFields on MappingComment {
  id
  gameId
  kind
  reviewType
  locationId
  layer
  parentCommentId
  content
  author {
    name
    email
  }
  authorRole
  coordinates {
    lat
    lng
  }
  reactions {
    emoji
    actors {
      name
      email
    }
  }
  status
  resolvedAt
  createdAt
  updatedAt
}`);

export const useReviewerCreateMappingCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReviewerCreateMappingCommentMutation, TError, ReviewerCreateMappingCommentMutationVariables, TContext>) => {
    
    return useMutation<ReviewerCreateMappingCommentMutation, TError, ReviewerCreateMappingCommentMutationVariables, TContext>(
      ['ReviewerCreateMappingComment'],
      (variables?: ReviewerCreateMappingCommentMutationVariables) => fetchGenerated<ReviewerCreateMappingCommentMutation, ReviewerCreateMappingCommentMutationVariables>(ReviewerCreateMappingCommentDocument, variables)(),
      options
    )};

export const ReviewerUpdateMappingReviewDocument = new TypedDocumentString(`
    mutation ReviewerUpdateMappingReview($input: UpdateMappingReviewInput!) {
  reviewerUpdateMappingReview(input: $input) {
    ...ReviewerMappingReviewFields
  }
}
    fragment ReviewerMappingReviewFields on MappingReview {
  id
  gameId
  locationId
  type
  status
  approvedAt
  createdAt
  updatedAt
}`);

export const useReviewerUpdateMappingReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReviewerUpdateMappingReviewMutation, TError, ReviewerUpdateMappingReviewMutationVariables, TContext>) => {
    
    return useMutation<ReviewerUpdateMappingReviewMutation, TError, ReviewerUpdateMappingReviewMutationVariables, TContext>(
      ['ReviewerUpdateMappingReview'],
      (variables?: ReviewerUpdateMappingReviewMutationVariables) => fetchGenerated<ReviewerUpdateMappingReviewMutation, ReviewerUpdateMappingReviewMutationVariables>(ReviewerUpdateMappingReviewDocument, variables)(),
      options
    )};

export const ReviewerMappingLocationHistoryDocument = new TypedDocumentString(`
    query ReviewerMappingLocationHistory($locationId: String!) {
  reviewerMappingLocationHistory(locationId: $locationId) {
    ...ReviewerMappingHistoryFields
  }
}
    fragment ReviewerMappingHistoryFields on MappingHistory {
  id
  gameId
  locationId
  action
  actor {
    name
    email
  }
  metadata
  createdAt
  updatedAt
}`);

export const useReviewerMappingLocationHistoryQuery = <
      TData = ReviewerMappingLocationHistoryQuery,
      TError = unknown
    >(
      variables: ReviewerMappingLocationHistoryQueryVariables,
      options?: UseQueryOptions<ReviewerMappingLocationHistoryQuery, TError, TData>
    ) => {
    
    return useQuery<ReviewerMappingLocationHistoryQuery, TError, TData>(
      ['ReviewerMappingLocationHistory', variables],
      fetchGenerated<ReviewerMappingLocationHistoryQuery, ReviewerMappingLocationHistoryQueryVariables>(ReviewerMappingLocationHistoryDocument, variables),
      options
    )};

export const ReviewerMappingLayerReviewsDocument = new TypedDocumentString(`
    query ReviewerMappingLayerReviews {
  reviewerMappingLayerReviews {
    ...ReviewerMappingLayerReviewFields
  }
}
    fragment ReviewerMappingLayerReviewFields on MappingLayerReview {
  gameId
  layer
  type
  status
  totalCount
  approvedCount
  changesRequestedCount
  respondedCount
  pendingCount
  openQueryCount
  approvedAt
}`);

export const useReviewerMappingLayerReviewsQuery = <
      TData = ReviewerMappingLayerReviewsQuery,
      TError = unknown
    >(
      variables?: ReviewerMappingLayerReviewsQueryVariables,
      options?: UseQueryOptions<ReviewerMappingLayerReviewsQuery, TError, TData>
    ) => {
    
    return useQuery<ReviewerMappingLayerReviewsQuery, TError, TData>(
      variables === undefined ? ['ReviewerMappingLayerReviews'] : ['ReviewerMappingLayerReviews', variables],
      fetchGenerated<ReviewerMappingLayerReviewsQuery, ReviewerMappingLayerReviewsQueryVariables>(ReviewerMappingLayerReviewsDocument, variables),
      options
    )};

export const ReviewerToggleMappingCommentReactionDocument = new TypedDocumentString(`
    mutation ReviewerToggleMappingCommentReaction($input: ToggleMappingCommentReactionInput!) {
  reviewerToggleMappingCommentReaction(input: $input) {
    ...ReviewerMappingCommentFields
  }
}
    fragment ReviewerMappingCommentFields on MappingComment {
  id
  gameId
  kind
  reviewType
  locationId
  layer
  parentCommentId
  content
  author {
    name
    email
  }
  authorRole
  coordinates {
    lat
    lng
  }
  reactions {
    emoji
    actors {
      name
      email
    }
  }
  status
  resolvedAt
  createdAt
  updatedAt
}`);

export const useReviewerToggleMappingCommentReactionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReviewerToggleMappingCommentReactionMutation, TError, ReviewerToggleMappingCommentReactionMutationVariables, TContext>) => {
    
    return useMutation<ReviewerToggleMappingCommentReactionMutation, TError, ReviewerToggleMappingCommentReactionMutationVariables, TContext>(
      ['ReviewerToggleMappingCommentReaction'],
      (variables?: ReviewerToggleMappingCommentReactionMutationVariables) => fetchGenerated<ReviewerToggleMappingCommentReactionMutation, ReviewerToggleMappingCommentReactionMutationVariables>(ReviewerToggleMappingCommentReactionDocument, variables)(),
      options
    )};

export const ReviewerUpdateMappingCommentDocument = new TypedDocumentString(`
    mutation ReviewerUpdateMappingComment($input: UpdateMappingCommentInput!) {
  reviewerUpdateMappingComment(input: $input) {
    ...ReviewerMappingCommentFields
  }
}
    fragment ReviewerMappingCommentFields on MappingComment {
  id
  gameId
  kind
  reviewType
  locationId
  layer
  parentCommentId
  content
  author {
    name
    email
  }
  authorRole
  coordinates {
    lat
    lng
  }
  reactions {
    emoji
    actors {
      name
      email
    }
  }
  status
  resolvedAt
  createdAt
  updatedAt
}`);

export const useReviewerUpdateMappingCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReviewerUpdateMappingCommentMutation, TError, ReviewerUpdateMappingCommentMutationVariables, TContext>) => {
    
    return useMutation<ReviewerUpdateMappingCommentMutation, TError, ReviewerUpdateMappingCommentMutationVariables, TContext>(
      ['ReviewerUpdateMappingComment'],
      (variables?: ReviewerUpdateMappingCommentMutationVariables) => fetchGenerated<ReviewerUpdateMappingCommentMutation, ReviewerUpdateMappingCommentMutationVariables>(ReviewerUpdateMappingCommentDocument, variables)(),
      options
    )};

export const ReviewerResolveMappingCommentDocument = new TypedDocumentString(`
    mutation ReviewerResolveMappingComment($input: ResolveMappingCommentInput!) {
  reviewerResolveMappingComment(input: $input) {
    ...ReviewerMappingCommentFields
  }
}
    fragment ReviewerMappingCommentFields on MappingComment {
  id
  gameId
  kind
  reviewType
  locationId
  layer
  parentCommentId
  content
  author {
    name
    email
  }
  authorRole
  coordinates {
    lat
    lng
  }
  reactions {
    emoji
    actors {
      name
      email
    }
  }
  status
  resolvedAt
  createdAt
  updatedAt
}`);

export const useReviewerResolveMappingCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReviewerResolveMappingCommentMutation, TError, ReviewerResolveMappingCommentMutationVariables, TContext>) => {
    
    return useMutation<ReviewerResolveMappingCommentMutation, TError, ReviewerResolveMappingCommentMutationVariables, TContext>(
      ['ReviewerResolveMappingComment'],
      (variables?: ReviewerResolveMappingCommentMutationVariables) => fetchGenerated<ReviewerResolveMappingCommentMutation, ReviewerResolveMappingCommentMutationVariables>(ReviewerResolveMappingCommentDocument, variables)(),
      options
    )};

export const ReviewerApproveMappingLayerDocument = new TypedDocumentString(`
    mutation ReviewerApproveMappingLayer($input: ApproveMappingLayerInput!) {
  reviewerApproveMappingLayer(input: $input) {
    ...ReviewerMappingLayerReviewFields
  }
}
    fragment ReviewerMappingLayerReviewFields on MappingLayerReview {
  gameId
  layer
  type
  status
  totalCount
  approvedCount
  changesRequestedCount
  respondedCount
  pendingCount
  openQueryCount
  approvedAt
}`);

export const useReviewerApproveMappingLayerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReviewerApproveMappingLayerMutation, TError, ReviewerApproveMappingLayerMutationVariables, TContext>) => {
    
    return useMutation<ReviewerApproveMappingLayerMutation, TError, ReviewerApproveMappingLayerMutationVariables, TContext>(
      ['ReviewerApproveMappingLayer'],
      (variables?: ReviewerApproveMappingLayerMutationVariables) => fetchGenerated<ReviewerApproveMappingLayerMutation, ReviewerApproveMappingLayerMutationVariables>(ReviewerApproveMappingLayerDocument, variables)(),
      options
    )};

export const MeDocument = new TypedDocumentString(`
    query me {
  me {
    id
    email
    fullName
    adminManagement
    gameCreation
    isSuperAdmin
    globalModulesAccess
    pii
    permissions {
      allGames
      perGame
    }
  }
}
    `);

export const useMeQuery = <
      TData = MeQuery,
      TError = unknown
    >(
      variables?: MeQueryVariables,
      options?: UseQueryOptions<MeQuery, TError, TData>
    ) => {
    
    return useQuery<MeQuery, TError, TData>(
      variables === undefined ? ['me'] : ['me', variables],
      fetchGenerated<MeQuery, MeQueryVariables>(MeDocument, variables),
      options
    )};
